[
  {
    "name" : "CUSTOMS OFFICE SANT JULIÀ DE LÒRIA",
    "unCode" : "AD000001"
  },
  {
    "name" : "DCNJ PORTA",
    "unCode" : "AD000002"
  },
  {
    "name" : "CENTRAL CUSTOMS OFFICE",
    "unCode" : "AD000003"
  },
  {
    "name" : "Wien",
    "unCode" : "AT100000"
  },
  {
    "name" : "Hafen Wien",
    "unCode" : "AT100200"
  },
  {
    "name" : "St. Pölten",
    "unCode" : "AT230000"
  },
  {
    "name" : "Mistelbach",
    "unCode" : "AT230200"
  },
  {
    "name" : "Krems",
    "unCode" : "AT240000"
  },
  {
    "name" : "Hafen Krems",
    "unCode" : "AT240100"
  },
  {
    "name" : "Amstetten",
    "unCode" : "AT240200"
  },
  {
    "name" : "Gmünd-Nagelberg",
    "unCode" : "AT240400"
  },
  {
    "name" : "Hollabrunn",
    "unCode" : "AT240500"
  },
  {
    "name" : "Wiener Neustadt",
    "unCode" : "AT250000"
  },
  {
    "name" : "Wiener Neudorf",
    "unCode" : "AT250100"
  },
  {
    "name" : "Wr. Neudorf Außenstelle Abfertigung",
    "unCode" : "AT250101"
  },
  {
    "name" : "Eisenstadt",
    "unCode" : "AT320000"
  },
  {
    "name" : "Eisenstadt/Strasse",
    "unCode" : "AT320200"
  },
  {
    "name" : "Nickelsdorf",
    "unCode" : "AT320300"
  },
  {
    "name" : "Heiligenkreuz",
    "unCode" : "AT320400"
  },
  {
    "name" : "Oberwart",
    "unCode" : "AT320600"
  },
  {
    "name" : "Flughafen Wien Güterabfertigung",
    "unCode" : "AT330100"
  },
  {
    "name" : "Flughafen Wien Reisendenabfertigung",
    "unCode" : "AT330200"
  },
  {
    "name" : "Maria Lanzendorf",
    "unCode" : "AT330300"
  },
  {
    "name" : "Flughafen Wien Cargo Center Nord",
    "unCode" : "AT330400"
  },
  {
    "name" : "Klagenfurt",
    "unCode" : "AT420000"
  },
  {
    "name" : "Klagenfurt Flughafen/Strasse",
    "unCode" : "AT420100"
  },
  {
    "name" : "Villach",
    "unCode" : "AT430000"
  },
  {
    "name" : "Bahnhof Villach Süd",
    "unCode" : "AT430100"
  },
  {
    "name" : "Linz",
    "unCode" : "AT520000"
  },
  {
    "name" : "Flughafen Linz",
    "unCode" : "AT520100"
  },
  {
    "name" : "Hafen Enns",
    "unCode" : "AT520300"
  },
  {
    "name" : "Wels",
    "unCode" : "AT530000"
  },
  {
    "name" : "Suben",
    "unCode" : "AT530200"
  },
  {
    "name" : "Salzburg",
    "unCode" : "AT600000"
  },
  {
    "name" : "Flughafen Salzburg",
    "unCode" : "AT600200"
  },
  {
    "name" : "Zollstelle Güterverkehr Straße",
    "unCode" : "AT600300"
  },
  {
    "name" : "Liefering/Bahn",
    "unCode" : "AT600400"
  },
  {
    "name" : "Graz",
    "unCode" : "AT700000"
  },
  {
    "name" : "Flughafen Graz",
    "unCode" : "AT700100"
  },
  {
    "name" : "Containerterminal Werndorf",
    "unCode" : "AT700200"
  },
  {
    "name" : "Leoben",
    "unCode" : "AT700300"
  },
  {
    "name" : "Spielfeld",
    "unCode" : "AT700400"
  },
  {
    "name" : "Innsbruck",
    "unCode" : "AT800000"
  },
  {
    "name" : "Flughafen Innsbruck",
    "unCode" : "AT800200"
  },
  {
    "name" : "Hall",
    "unCode" : "AT800300"
  },
  {
    "name" : "Lienz",
    "unCode" : "AT800600"
  },
  {
    "name" : "Kufstein",
    "unCode" : "AT800700"
  },
  {
    "name" : "Martinsbruck",
    "unCode" : "AT800900"
  },
  {
    "name" : "Pfunds Spiss",
    "unCode" : "AT801000"
  },
  {
    "name" : "Feldkirch",
    "unCode" : "AT920000"
  },
  {
    "name" : "Buchs/Bahnhof",
    "unCode" : "AT920100"
  },
  {
    "name" : "Tisis",
    "unCode" : "AT920400"
  },
  {
    "name" : "Meiningen",
    "unCode" : "AT920700"
  },
  {
    "name" : "Mäder",
    "unCode" : "AT920900"
  },
  {
    "name" : "Wolfurt",
    "unCode" : "AT930000"
  },
  {
    "name" : "Wolfurt/Post",
    "unCode" : "AT930100"
  },
  {
    "name" : "Wolfurt/Post Selbstverzollung",
    "unCode" : "AT930101"
  },
  {
    "name" : "Hohenems",
    "unCode" : "AT930200"
  },
  {
    "name" : "Lustenau",
    "unCode" : "AT930300"
  },
  {
    "name" : "Höchst",
    "unCode" : "AT930600"
  },
  {
    "name" : "Seehafen Bregenz",
    "unCode" : "AT930800"
  },
  {
    "name" : "St. Margrethen",
    "unCode" : "AT930900"
  },
  {
    "name" : "ANTWERPEN DAE",
    "unCode" : "BE101000"
  },
  {
    "name" : "BRUXELLES DE",
    "unCode" : "BE204000"
  },
  {
    "name" : "ZAVENTEM D",
    "unCode" : "BE212000"
  },
  {
    "name" : "GENT DAE",
    "unCode" : "BE312000"
  },
  {
    "name" : "ZEEBRUGGE D",
    "unCode" : "BE343000"
  },
  {
    "name" : "HASSELT DA",
    "unCode" : "BE408000"
  },
  {
    "name" : "TIENEN DAE",
    "unCode" : "BE424000"
  },
  {
    "name" : "GEEL DAE",
    "unCode" : "BE432000"
  },
  {
    "name" : "ARLON DA",
    "unCode" : "BE501000"
  },
  {
    "name" : "EYNATTEN (RAEREN) Z",
    "unCode" : "BE514000"
  },
  {
    "name" : "BIERSET (GRACE-HOLLOGNE) DE",
    "unCode" : "BE532000"
  },
  {
    "name" : "LA LOUVIERE DAE",
    "unCode" : "BE632000"
  },
  {
    "name" : "NAMUR DA",
    "unCode" : "BE648000"
  },
  {
    "name" : "GOSSELIES (CHARLEROI) DAE",
    "unCode" : "BE680000"
  },
  {
    "name" : "MP Letishte Burgas",
    "unCode" : "BG001002"
  },
  {
    "name" : "MP M.Tarnovo",
    "unCode" : "BG001003"
  },
  {
    "name" : "CB Petrochemical plant",
    "unCode" : "BG001005"
  },
  {
    "name" : "MP Pristanishte Burgas tsentar",
    "unCode" : "BG001007"
  },
  {
    "name" : "MB Svobodna Zona",
    "unCode" : "BG001008"
  },
  {
    "name" : "CB Sliven",
    "unCode" : "BG001009"
  },
  {
    "name" : "MB Yambol",
    "unCode" : "BG001010"
  },
  {
    "name" : "MP Lesovo",
    "unCode" : "BG001011"
  },
  {
    "name" : "CP Tsarevo",
    "unCode" : "BG001012"
  },
  {
    "name" : "CP Neftopristanishte",
    "unCode" : "BG001013"
  },
  {
    "name" : "CP Zh.P. Gara Svilengrad",
    "unCode" : "BG001014"
  },
  {
    "name" : "MP Kapitan Andreevo",
    "unCode" : "BG001015"
  },
  {
    "name" : "CP Varna-West",
    "unCode" : "BG002002"
  },
  {
    "name" : "CP Varna Airport",
    "unCode" : "BG002003"
  },
  {
    "name" : "CP Varna Port",
    "unCode" : "BG002005"
  },
  {
    "name" : "CP Lesport Port",
    "unCode" : "BG002006"
  },
  {
    "name" : "CP Varna-Ferry",
    "unCode" : "BG002007"
  },
  {
    "name" : "CB Shumen",
    "unCode" : "BG002008"
  },
  {
    "name" : "MB Dobrich",
    "unCode" : "BG002009"
  },
  {
    "name" : "CP Balchik",
    "unCode" : "BG002010"
  },
  {
    "name" : "MB Kazanlak",
    "unCode" : "BG003001"
  },
  {
    "name" : "MP Letishte Plovdiv",
    "unCode" : "BG003002"
  },
  {
    "name" : "MB Pazardzhik",
    "unCode" : "BG003004"
  },
  {
    "name" : "MB Svobodna zona Plovdiv",
    "unCode" : "BG003005"
  },
  {
    "name" : "MB Smolyan",
    "unCode" : "BG003006"
  },
  {
    "name" : "MB Karlovo",
    "unCode" : "BG003007"
  },
  {
    "name" : "MB Stara Zagora",
    "unCode" : "BG003008"
  },
  {
    "name" : "MB Plovdiv",
    "unCode" : "BG003009"
  },
  {
    "name" : "MB Svilengrad",
    "unCode" : "BG003010"
  },
  {
    "name" : "MB Kardzhali",
    "unCode" : "BG003011"
  },
  {
    "name" : "MB Haskovo",
    "unCode" : "BG003012"
  },
  {
    "name" : "MB Intermodalen terminal",
    "unCode" : "BG003013"
  },
  {
    "name" : "MB Razgrad",
    "unCode" : "BG004002"
  },
  {
    "name" : "CP Pristanishte",
    "unCode" : "BG004006"
  },
  {
    "name" : "MB Targovishte",
    "unCode" : "BG004011"
  },
  {
    "name" : "Customs Point Silistra",
    "unCode" : "BG004014"
  },
  {
    "name" : "MB Vratsa",
    "unCode" : "BG004201"
  },
  {
    "name" : "MP Oryahovо",
    "unCode" : "BG004203"
  },
  {
    "name" : "MP Pristanishte Lom",
    "unCode" : "BG004205"
  },
  {
    "name" : "MB Montana",
    "unCode" : "BG004210"
  },
  {
    "name" : "MB Vidin",
    "unCode" : "BG004211"
  },
  {
    "name" : "MP Bregovo",
    "unCode" : "BG004212"
  },
  {
    "name" : "MP Vrashka chuka",
    "unCode" : "BG004213"
  },
  {
    "name" : "CustBorderPoint Svishtov",
    "unCode" : "BG004300"
  },
  {
    "name" : "MB Gabrovo",
    "unCode" : "BG004301"
  },
  {
    "name" : "MP Letishte Gorna Oryahovitsa",
    "unCode" : "BG004303"
  },
  {
    "name" : "MB Lovech",
    "unCode" : "BG004304"
  },
  {
    "name" : "MB Pleven",
    "unCode" : "BG004306"
  },
  {
    "name" : "MP Somovit",
    "unCode" : "BG004307"
  },
  {
    "name" : "MB Sevlievo",
    "unCode" : "BG004309"
  },
  {
    "name" : "CB Troyan",
    "unCode" : "BG004311"
  },
  {
    "name" : "CustOffice Airport Sofia",
    "unCode" : "BG005100"
  },
  {
    "name" : "MP Letishte Sofia - patnitsi",
    "unCode" : "BG005106"
  },
  {
    "name" : "MP Aerogara Sofia - tovari",
    "unCode" : "BG005107"
  },
  {
    "name" : "CustOffice Blagoevgrad",
    "unCode" : "BG005700"
  },
  {
    "name" : "MB Gotse Delchev",
    "unCode" : "BG005701"
  },
  {
    "name" : "MP Gyueshevo",
    "unCode" : "BG005702"
  },
  {
    "name" : "MP Zlatarevo",
    "unCode" : "BG005703"
  },
  {
    "name" : "MB Kulata",
    "unCode" : "BG005704"
  },
  {
    "name" : "MB Kyustendil",
    "unCode" : "BG005705"
  },
  {
    "name" : "MP Logodazh",
    "unCode" : "BG005706"
  },
  {
    "name" : "MP Oltomantsi",
    "unCode" : "BG005707"
  },
  {
    "name" : "MB Botevgrad",
    "unCode" : "BG005801"
  },
  {
    "name" : "MB Dragoman",
    "unCode" : "BG005803"
  },
  {
    "name" : "MP Kalotina",
    "unCode" : "BG005804"
  },
  {
    "name" : "MB Pernik",
    "unCode" : "BG005805"
  },
  {
    "name" : "MB Sofia-Zapad",
    "unCode" : "BG005807"
  },
  {
    "name" : "MB Sofia-Iztok",
    "unCode" : "BG005808"
  },
  {
    "name" : "MP Strezimirovtsi",
    "unCode" : "BG005809"
  },
  {
    "name" : "MB BRSC",
    "unCode" : "BG005810"
  },
  {
    "name" : "MB Slatina",
    "unCode" : "BG005811"
  },
  {
    "name" : "Douane Centre - Boncourt/Delle-Auto",
    "unCode" : "CH001141"
  },
  {
    "name" : "Douane Centre - Boncourt Intérieur",
    "unCode" : "CH001142"
  },
  {
    "name" : "Zoll Nord - Basel Mitte",
    "unCode" : "CH001251"
  },
  {
    "name" : "Zoll Nord - Basel Mitte Konv.",
    "unCode" : "CH001252"
  },
  {
    "name" : "Zoll Nord - Basel Messe",
    "unCode" : "CH001454"
  },
  {
    "name" : "Zoll Nord - Basel Rheinhäfen",
    "unCode" : "CH001471"
  },
  {
    "name" : "Zoll Nord - Riehen",
    "unCode" : "CH001501"
  },
  {
    "name" : "Zoll Nord - Grenzacherstrasse",
    "unCode" : "CH001551"
  },
  {
    "name" : "Zoll Nord - Basel Umschlagbahnhof",
    "unCode" : "CH001571"
  },
  {
    "name" : "Zoll Nord - Stein/Bad Säckingen",
    "unCode" : "CH001591"
  },
  {
    "name" : "Zoll Nord - Laufenburg",
    "unCode" : "CH001601"
  },
  {
    "name" : "Zoll Nord - Brugg",
    "unCode" : "CH001631"
  },
  {
    "name" : "Zoll Mitte - Bern",
    "unCode" : "CH001661"
  },
  {
    "name" : "Zoll Nord - Basel Flughafen Fracht",
    "unCode" : "CH001711"
  },
  {
    "name" : "Zoll Nord - Basel Flughafen Kurier",
    "unCode" : "CH001712"
  },
  {
    "name" : "Zoll Nord - Pratteln",
    "unCode" : "CH001731"
  },
  {
    "name" : "Zoll Nord - Basel/Weil Rhein-Autoba",
    "unCode" : "CH001801"
  },
  {
    "name" : "Zoll Nord - Basel/St.Louis Autobahn",
    "unCode" : "CH001841"
  },
  {
    "name" : "Zoll Nord - Rheinfelden Autobahn",
    "unCode" : "CH001921"
  },
  {
    "name" : "Zoll Nord - Koblenz",
    "unCode" : "CH002041"
  },
  {
    "name" : "Zoll Nordost - Trasadingen",
    "unCode" : "CH002091"
  },
  {
    "name" : "Zoll Nordost - Schleitheim",
    "unCode" : "CH002151"
  },
  {
    "name" : "Zoll Nordost - Rafz-Solgen",
    "unCode" : "CH002261"
  },
  {
    "name" : "Zoll Nordost - Neuhausen",
    "unCode" : "CH002291"
  },
  {
    "name" : "Zoll Nordost - Bargen",
    "unCode" : "CH002311"
  },
  {
    "name" : "Zoll Nordost - Ramsen",
    "unCode" : "CH002411"
  },
  {
    "name" : "Zoll Nordost - Thayngen",
    "unCode" : "CH002471"
  },
  {
    "name" : "Zoll Nordost - Kreuzlingen Autobahn",
    "unCode" : "CH002621"
  },
  {
    "name" : "Zoll Nordost - Romanshorn",
    "unCode" : "CH002671"
  },
  {
    "name" : "Zoll Nordost - Zürich",
    "unCode" : "CH002711"
  },
  {
    "name" : "Zoll Nordost - Zürich 1",
    "unCode" : "CH002751"
  },
  {
    "name" : "Zoll Nordost - Zürich 2",
    "unCode" : "CH002752"
  },
  {
    "name" : "Zoll Nordost - Zürich 3",
    "unCode" : "CH002753"
  },
  {
    "name" : "Zoll Nordost - Zürich Kurier",
    "unCode" : "CH002754"
  },
  {
    "name" : "Zoll Nordost - Zürich Messe",
    "unCode" : "CH002755"
  },
  {
    "name" : "Zoll Nordost - Mülligen",
    "unCode" : "CH002756"
  },
  {
    "name" : "Zoll Nordost - Zürich-Flughafen",
    "unCode" : "CH002771"
  },
  {
    "name" : "Zoll Ost - St. Gallen",
    "unCode" : "CH003011"
  },
  {
    "name" : "Zoll Ost - Wolfurt",
    "unCode" : "CH003031"
  },
  {
    "name" : "Zoll Ost - Altenrhein-Flughafen",
    "unCode" : "CH003041"
  },
  {
    "name" : "Zoll Ost - St. Margrethen Strasse",
    "unCode" : "CH003071"
  },
  {
    "name" : "Zoll Ost - Au",
    "unCode" : "CH003081"
  },
  {
    "name" : "Zoll Ost - St. Margrethen Freilager",
    "unCode" : "CH003091"
  },
  {
    "name" : "Zoll Ost - Kriessern",
    "unCode" : "CH003121"
  },
  {
    "name" : "Zoll Ost - Buchs",
    "unCode" : "CH003140"
  },
  {
    "name" : "Zoll Ost - Oberriet",
    "unCode" : "CH003151"
  },
  {
    "name" : "Zoll Ost - Schaanwald",
    "unCode" : "CH003201"
  },
  {
    "name" : "Zoll Ost - Martina",
    "unCode" : "CH003261"
  },
  {
    "name" : "Zoll Ost - Müstair",
    "unCode" : "CH003301"
  },
  {
    "name" : "Zoll Ost - La Drossa",
    "unCode" : "CH003331"
  },
  {
    "name" : "Zoll Ost - Campocologno",
    "unCode" : "CH003361"
  },
  {
    "name" : "Zoll Ost - Castasegna",
    "unCode" : "CH003401"
  },
  {
    "name" : "Zoll Ost - Diepoldsau",
    "unCode" : "CH003451"
  },
  {
    "name" : "Dogana Sud - Vedeggio",
    "unCode" : "CH004011"
  },
  {
    "name" : "Dogana Sud - Gandria",
    "unCode" : "CH004031"
  },
  {
    "name" : "Dogana Sud - Ponte Tresa",
    "unCode" : "CH004101"
  },
  {
    "name" : "Dogana Sud - Aeroporto Agno",
    "unCode" : "CH004131"
  },
  {
    "name" : "Dogana Sud - Mendrisio SDA DDA",
    "unCode" : "CH004162"
  },
  {
    "name" : "Dogana Sud - Mendrisio Confine",
    "unCode" : "CH004163"
  },
  {
    "name" : "Dogana Sud - Mendrisio DFD",
    "unCode" : "CH004164"
  },
  {
    "name" : "Dogana Sud - Chiasso-Strada",
    "unCode" : "CH004181"
  },
  {
    "name" : "Dogana Sud - Brogeda Autostrada",
    "unCode" : "CH004182"
  },
  {
    "name" : "Dogana Sud - Chiasso Viaggiatori",
    "unCode" : "CH004183"
  },
  {
    "name" : "Dogana Sud - Madonna di Ponte",
    "unCode" : "CH004421"
  },
  {
    "name" : "Dogana Sud - Luino",
    "unCode" : "CH004491"
  },
  {
    "name" : "Dogana Sud - Bissone",
    "unCode" : "CH004581"
  },
  {
    "name" : "Douane Ouest - Chavornay",
    "unCode" : "CH005031"
  },
  {
    "name" : "Zoll West - Domo 2",
    "unCode" : "CH005040"
  },
  {
    "name" : "Zoll West - Gamsen",
    "unCode" : "CH005051"
  },
  {
    "name" : "Zoll West - Gondo",
    "unCode" : "CH005081"
  },
  {
    "name" : "Douane Ouest - St. Gingolph",
    "unCode" : "CH005121"
  },
  {
    "name" : "Douane Ouest - Vallorbe",
    "unCode" : "CH005441"
  },
  {
    "name" : "Douane Centre - Les Verrières",
    "unCode" : "CH005491"
  },
  {
    "name" : "Douane Centre - Le Crêt-du-Locle",
    "unCode" : "CH005551"
  },
  {
    "name" : "Douane Centre - Col France",
    "unCode" : "CH005561"
  },
  {
    "name" : "Douane Ouest - Martigny",
    "unCode" : "CH005691"
  },
  {
    "name" : "Douane Ouest - Gd-St-Bernard T Sud",
    "unCode" : "CH005701"
  },
  {
    "name" : "Douane Ouest - Genève Port Franc",
    "unCode" : "CH006021"
  },
  {
    "name" : "Douane Ouest - Thônex-Vallard",
    "unCode" : "CH006221"
  },
  {
    "name" : "Douane Ouest - Bardonnex",
    "unCode" : "CH006251"
  },
  {
    "name" : "Douane Ouest - Bardonnex Primeurs",
    "unCode" : "CH006252"
  },
  {
    "name" : "Douane Ouest - Ferney-Voltaire",
    "unCode" : "CH006451"
  },
  {
    "name" : "Douane Ouest - Genève-Aéroport Fret",
    "unCode" : "CH006521"
  },
  {
    "name" : "LARNACA PORT",
    "unCode" : "CY000410"
  },
  {
    "name" : "VASILICO-ZYGI",
    "unCode" : "CY000412"
  },
  {
    "name" : "LARNACA AIRPORT",
    "unCode" : "CY000440"
  },
  {
    "name" : "LIMASSOL PORT",
    "unCode" : "CY000510"
  },
  {
    "name" : "LIMASSOL ANCHORAGE",
    "unCode" : "CY000511"
  },
  {
    "name" : "PAPHOS CUSTOMS",
    "unCode" : "CY000610"
  },
  {
    "name" : "PAPHOS AIRPORT",
    "unCode" : "CY000640"
  },
  {
    "name" : "celní - letiště, Brno",
    "unCode" : "CZ121020"
  },
  {
    "name" : "celní Brno I, Brno",
    "unCode" : "CZ121030"
  },
  {
    "name" : "celní Brno II, Brno",
    "unCode" : "CZ121040"
  },
  {
    "name" : "celní Střítež, Střítež u Jihlavy",
    "unCode" : "CZ121050"
  },
  {
    "name" : "celní Lanžhot, Lanžhot",
    "unCode" : "CZ121060"
  },
  {
    "name" : "celní I, Pardubice",
    "unCode" : "CZ221010"
  },
  {
    "name" : "celní - letiště, Pardubice",
    "unCode" : "CZ221020"
  },
  {
    "name" : "celní Ústí n/L, Ústí nad Labem",
    "unCode" : "CZ221030"
  },
  {
    "name" : "celní Liberec, Liberec",
    "unCode" : "CZ221040"
  },
  {
    "name" : "celní Hradec Králové",
    "unCode" : "CZ221050"
  },
  {
    "name" : "celní Pardubice, Pardubice",
    "unCode" : "CZ221060"
  },
  {
    "name" : "celní Česká Třebová, Česká Třebová",
    "unCode" : "CZ221061"
  },
  {
    "name" : "celní - letiště, Mošnov",
    "unCode" : "CZ321020"
  },
  {
    "name" : "celní Mošnov, Mošnov",
    "unCode" : "CZ321030"
  },
  {
    "name" : "celní Paskov, Paskov",
    "unCode" : "CZ321040"
  },
  {
    "name" : "celní Opava, Opava",
    "unCode" : "CZ321041"
  },
  {
    "name" : "celní Olomouc, Olomouc",
    "unCode" : "CZ321050"
  },
  {
    "name" : "celní Šumperk, Šumperk",
    "unCode" : "CZ321051"
  },
  {
    "name" : "celní Lípa, Lípa",
    "unCode" : "CZ321060"
  },
  {
    "name" : "celní Uherské Hradiště",
    "unCode" : "CZ321061"
  },
  {
    "name" : "celní I, České Budějovice",
    "unCode" : "CZ421010"
  },
  {
    "name" : "celní - letiště, Karlovy Vary",
    "unCode" : "CZ421020"
  },
  {
    "name" : "celní České Budějovice",
    "unCode" : "CZ421030"
  },
  {
    "name" : "celní Plzeň, Plzeň",
    "unCode" : "CZ421040"
  },
  {
    "name" : "celní Karlovy Vary, Karlovy Vary",
    "unCode" : "CZ421041"
  },
  {
    "name" : "celní I, Praha 1",
    "unCode" : "CZ521010"
  },
  {
    "name" : "celní - letiště, Praha 6",
    "unCode" : "CZ521020"
  },
  {
    "name" : "celní Hostivař, Praha 10",
    "unCode" : "CZ521030"
  },
  {
    "name" : "celní pošta Hostivař, Praha 10",
    "unCode" : "CZ521040"
  },
  {
    "name" : "celní Uhříněves, Praha 10",
    "unCode" : "CZ521050"
  },
  {
    "name" : "celní Ruzyně, Praha 6",
    "unCode" : "CZ521060"
  },
  {
    "name" : "celní I, Mělník",
    "unCode" : "CZ621010"
  },
  {
    "name" : "celní Mělník, Mělník",
    "unCode" : "CZ621020"
  },
  {
    "name" : "celní Kosmonosy, Kosmonosy",
    "unCode" : "CZ621021"
  },
  {
    "name" : "celní Kolín, Kolín",
    "unCode" : "CZ621030"
  },
  {
    "name" : "celní Benešov, Benešov",
    "unCode" : "CZ621031"
  },
  {
    "name" : "celní Rudná, Rudná",
    "unCode" : "CZ621040"
  },
  {
    "name" : "celní Zdiby, Zdiby",
    "unCode" : "CZ621050"
  },
  {
    "name" : "celní Kladno, Kladno",
    "unCode" : "CZ621060"
  },
  {
    "name" : "celní Říčany, Říčany - Jažlovice",
    "unCode" : "CZ621070"
  },
  {
    "name" : "Berlin-Marzahn",
    "unCode" : "DE002101"
  },
  {
    "name" : "Schöneberg",
    "unCode" : "DE002151"
  },
  {
    "name" : "Berlin-Dreilinden",
    "unCode" : "DE002152"
  },
  {
    "name" : "Berlin-Messe",
    "unCode" : "DE002181"
  },
  {
    "name" : "Flughafen Bremen",
    "unCode" : "DE002301"
  },
  {
    "name" : "Kontrolleinheit Flughafen Bremen",
    "unCode" : "DE002307"
  },
  {
    "name" : "Bremen",
    "unCode" : "DE002325"
  },
  {
    "name" : "Bremerhaven",
    "unCode" : "DE002452"
  },
  {
    "name" : "Flughafen Düsseldorf",
    "unCode" : "DE002601"
  },
  {
    "name" : "Düsseldorf Nord",
    "unCode" : "DE002604"
  },
  {
    "name" : "KE Flughafen Düsseldorf",
    "unCode" : "DE002605"
  },
  {
    "name" : "Düsseldorf Reisholz",
    "unCode" : "DE002607"
  },
  {
    "name" : "Düsseldorf Messe",
    "unCode" : "DE002631"
  },
  {
    "name" : "Essen",
    "unCode" : "DE002651"
  },
  {
    "name" : "Duisburg-Ruhrort",
    "unCode" : "DE002656"
  },
  {
    "name" : "Emmerich",
    "unCode" : "DE002701"
  },
  {
    "name" : "Straelen-Autobahn",
    "unCode" : "DE002702"
  },
  {
    "name" : "Kontrolleinheit Flughafen Weeze",
    "unCode" : "DE002704"
  },
  {
    "name" : "Abfertigungsstelle Flughafen Weeze",
    "unCode" : "DE002705"
  },
  {
    "name" : "Schwanenhaus",
    "unCode" : "DE002901"
  },
  {
    "name" : "Uerdingen",
    "unCode" : "DE002903"
  },
  {
    "name" : "Mönchengladbach",
    "unCode" : "DE002904"
  },
  {
    "name" : "Neuss",
    "unCode" : "DE002906"
  },
  {
    "name" : "Wuppertal",
    "unCode" : "DE002956"
  },
  {
    "name" : "Eisenach",
    "unCode" : "DE003002"
  },
  {
    "name" : "Am Flughafen Erfurt",
    "unCode" : "DE003003"
  },
  {
    "name" : "Jena",
    "unCode" : "DE003004"
  },
  {
    "name" : "Kontrolleinheit Flughafen Erfurt",
    "unCode" : "DE003009"
  },
  {
    "name" : "Abfertigungsstelle Luftverkehr",
    "unCode" : "DE003030"
  },
  {
    "name" : "Bensheim",
    "unCode" : "DE003201"
  },
  {
    "name" : "Wiesbaden",
    "unCode" : "DE003202"
  },
  {
    "name" : "Darmstadt",
    "unCode" : "DE003230"
  },
  {
    "name" : "Frankfurt am Main-Flughafen",
    "unCode" : "DE003302"
  },
  {
    "name" : "KEFR Frankfurt am Main",
    "unCode" : "DE003306"
  },
  {
    "name" : "KEF/Ü Frankfurt am Main",
    "unCode" : "DE003307"
  },
  {
    "name" : "Hanau",
    "unCode" : "DE003352"
  },
  {
    "name" : "Höchst",
    "unCode" : "DE003354"
  },
  {
    "name" : "Oberursel",
    "unCode" : "DE003356"
  },
  {
    "name" : "Frankfurt am Main-Osthafen",
    "unCode" : "DE003358"
  },
  {
    "name" : "Bad Hersfeld",
    "unCode" : "DE003401"
  },
  {
    "name" : "Fulda",
    "unCode" : "DE003430"
  },
  {
    "name" : "Marburg",
    "unCode" : "DE003452"
  },
  {
    "name" : "Wetzlar",
    "unCode" : "DE003453"
  },
  {
    "name" : "Kassel",
    "unCode" : "DE003454"
  },
  {
    "name" : "Finsterwalde",
    "unCode" : "DE003601"
  },
  {
    "name" : "Forst",
    "unCode" : "DE003603"
  },
  {
    "name" : "Frankfurt (Oder)-Autobahn",
    "unCode" : "DE003652"
  },
  {
    "name" : "Fürstenwalde",
    "unCode" : "DE003656"
  },
  {
    "name" : "Ludwigsfelde",
    "unCode" : "DE003701"
  },
  {
    "name" : "Velten",
    "unCode" : "DE003702"
  },
  {
    "name" : "Flughafen Berlin Brandenburg",
    "unCode" : "DE003703"
  },
  {
    "name" : "KE Flughafen Berlin Brandenburg",
    "unCode" : "DE003704"
  },
  {
    "name" : "Neuruppin",
    "unCode" : "DE003730"
  },
  {
    "name" : "Perleberg",
    "unCode" : "DE003731"
  },
  {
    "name" : "Brandenburg",
    "unCode" : "DE003732"
  },
  {
    "name" : "Eberswalde",
    "unCode" : "DE003752"
  },
  {
    "name" : "Freiburg",
    "unCode" : "DE003954"
  },
  {
    "name" : "Appenweier",
    "unCode" : "DE003956"
  },
  {
    "name" : "Konstanz-Industriegebiet",
    "unCode" : "DE004002"
  },
  {
    "name" : "Konstanz-Autobahn (schweiz. Gebiet)",
    "unCode" : "DE004005"
  },
  {
    "name" : "Grenzacherhorn",
    "unCode" : "DE004051"
  },
  {
    "name" : "Lörrach-Stetten",
    "unCode" : "DE004053"
  },
  {
    "name" : "Weil am Rhein-Autobahn",
    "unCode" : "DE004055"
  },
  {
    "name" : "Deutsches Zollamt Basel",
    "unCode" : "DE004058"
  },
  {
    "name" : "Rheinfelden-Autobahn",
    "unCode" : "DE004062"
  },
  {
    "name" : "Weil am Rhein - Umschlagbahnhof",
    "unCode" : "DE004081"
  },
  {
    "name" : "Weil am Rhein",
    "unCode" : "DE004083"
  },
  {
    "name" : "Basler Häfen",
    "unCode" : "DE004085"
  },
  {
    "name" : "Rheinhafen",
    "unCode" : "DE004087"
  },
  {
    "name" : "Bietingen",
    "unCode" : "DE004101"
  },
  {
    "name" : "Neuhaus",
    "unCode" : "DE004102"
  },
  {
    "name" : "Rielasingen",
    "unCode" : "DE004103"
  },
  {
    "name" : "Singen-Bahnhof",
    "unCode" : "DE004105"
  },
  {
    "name" : "Deißlingen",
    "unCode" : "DE004106"
  },
  {
    "name" : "Erzingen",
    "unCode" : "DE004201"
  },
  {
    "name" : "Jestetten (schweiz. Gebiet)",
    "unCode" : "DE004203"
  },
  {
    "name" : "Laufenburg",
    "unCode" : "DE004204"
  },
  {
    "name" : "Lottstetten",
    "unCode" : "DE004205"
  },
  {
    "name" : "Stühlingen",
    "unCode" : "DE004206"
  },
  {
    "name" : "Waldshut",
    "unCode" : "DE004208"
  },
  {
    "name" : "Bad Säckingen",
    "unCode" : "DE004209"
  },
  {
    "name" : "Cuxhaven",
    "unCode" : "DE004501"
  },
  {
    "name" : "Hamburg-Flughafen",
    "unCode" : "DE004701"
  },
  {
    "name" : "Hamburg",
    "unCode" : "DE004851"
  },
  {
    "name" : "Wolfsburg",
    "unCode" : "DE004906"
  },
  {
    "name" : "Braunschweig- Broitzem",
    "unCode" : "DE004930"
  },
  {
    "name" : "Helmstedt-Autobahn",
    "unCode" : "DE004961"
  },
  {
    "name" : "Emden",
    "unCode" : "DE005004"
  },
  {
    "name" : "Papenburg",
    "unCode" : "DE005008"
  },
  {
    "name" : "Goslar",
    "unCode" : "DE005052"
  },
  {
    "name" : "Hameln",
    "unCode" : "DE005053"
  },
  {
    "name" : "Hildesheim",
    "unCode" : "DE005055"
  },
  {
    "name" : "Holzminden",
    "unCode" : "DE005056"
  },
  {
    "name" : "Göttingen",
    "unCode" : "DE005080"
  },
  {
    "name" : "Hannover-Nord",
    "unCode" : "DE005102"
  },
  {
    "name" : "Flughafen Hannover",
    "unCode" : "DE005103"
  },
  {
    "name" : "KE Flughafen Hannover Langenhagen",
    "unCode" : "DE005104"
  },
  {
    "name" : "Hannover Messe",
    "unCode" : "DE005110"
  },
  {
    "name" : "Celle",
    "unCode" : "DE005111"
  },
  {
    "name" : "Soltau",
    "unCode" : "DE005202"
  },
  {
    "name" : "Stade",
    "unCode" : "DE005203"
  },
  {
    "name" : "Verden",
    "unCode" : "DE005204"
  },
  {
    "name" : "Lüneburg",
    "unCode" : "DE005230"
  },
  {
    "name" : "Brake",
    "unCode" : "DE005301"
  },
  {
    "name" : "Wilhelmshaven",
    "unCode" : "DE005310"
  },
  {
    "name" : "Oldenburg-Kreyenbrück",
    "unCode" : "DE005330"
  },
  {
    "name" : "Schüttorf",
    "unCode" : "DE005351"
  },
  {
    "name" : "Lohne",
    "unCode" : "DE005355"
  },
  {
    "name" : "Lingen",
    "unCode" : "DE005356"
  },
  {
    "name" : "Fledder",
    "unCode" : "DE005380"
  },
  {
    "name" : "Nossen",
    "unCode" : "DE005502"
  },
  {
    "name" : "Chemnitz",
    "unCode" : "DE005530"
  },
  {
    "name" : "Flughafen Dresden",
    "unCode" : "DE005552"
  },
  {
    "name" : "Kontrolleinheit Flughafen Dresden",
    "unCode" : "DE005555"
  },
  {
    "name" : "Kontrolleinheit Flughafen Leipzig",
    "unCode" : "DE005557"
  },
  {
    "name" : "Dresden",
    "unCode" : "DE005580"
  },
  {
    "name" : "Taucha",
    "unCode" : "DE005603"
  },
  {
    "name" : "Flughafen Leipzig",
    "unCode" : "DE005604"
  },
  {
    "name" : "IFS Radefeld",
    "unCode" : "DE005633"
  },
  {
    "name" : "Löbau",
    "unCode" : "DE005687"
  },
  {
    "name" : "Reichenbach",
    "unCode" : "DE005756"
  },
  {
    "name" : "Bruchsal",
    "unCode" : "DE005852"
  },
  {
    "name" : "Baden-Baden",
    "unCode" : "DE005853"
  },
  {
    "name" : "Kontrolleinheit Flughafen Karlsruhe",
    "unCode" : "DE005855"
  },
  {
    "name" : "Nagold",
    "unCode" : "DE005857"
  },
  {
    "name" : "Pforzheim",
    "unCode" : "DE005858"
  },
  {
    "name" : "Karlsruhe",
    "unCode" : "DE005880"
  },
  {
    "name" : "AbfSt Flugh. Karlsruhe/Baden-Baden",
    "unCode" : "DE005881"
  },
  {
    "name" : "Heidelberg",
    "unCode" : "DE005901"
  },
  {
    "name" : "Mannheim",
    "unCode" : "DE005904"
  },
  {
    "name" : "Flensburg",
    "unCode" : "DE006133"
  },
  {
    "name" : "Brunsbüttel",
    "unCode" : "DE006151"
  },
  {
    "name" : "Husum",
    "unCode" : "DE006155"
  },
  {
    "name" : "Pinneberg",
    "unCode" : "DE006156"
  },
  {
    "name" : "Abfertigungsstelle Itzehoe",
    "unCode" : "DE006183"
  },
  {
    "name" : "Rendsburg",
    "unCode" : "DE006206"
  },
  {
    "name" : "Kiel",
    "unCode" : "DE006207"
  },
  {
    "name" : "Abfertigungsstelle Norwegenkai",
    "unCode" : "DE006231"
  },
  {
    "name" : "Heiligenhafen",
    "unCode" : "DE006302"
  },
  {
    "name" : "Mölln",
    "unCode" : "DE006310"
  },
  {
    "name" : "Zollamt Lübeck",
    "unCode" : "DE006332"
  },
  {
    "name" : "Lübeck",
    "unCode" : "DE006333"
  },
  {
    "name" : "Kaiserslautern",
    "unCode" : "DE006501"
  },
  {
    "name" : "Pirmasens",
    "unCode" : "DE006502"
  },
  {
    "name" : "Mainz",
    "unCode" : "DE006504"
  },
  {
    "name" : "Koblenz-Rheinhafen",
    "unCode" : "DE006551"
  },
  {
    "name" : "Kontrolleinheiten Flughafen Hahn",
    "unCode" : "DE006554"
  },
  {
    "name" : "Germersheim",
    "unCode" : "DE006653"
  },
  {
    "name" : "AbfSt IFS Speyer",
    "unCode" : "DE006681"
  },
  {
    "name" : "Idar-Oberstein",
    "unCode" : "DE006752"
  },
  {
    "name" : "Ehrang",
    "unCode" : "DE006753"
  },
  {
    "name" : "Hahn-Flughafen",
    "unCode" : "DE006756"
  },
  {
    "name" : "Heinsberg",
    "unCode" : "DE007053"
  },
  {
    "name" : "Charlottenburger Allee",
    "unCode" : "DE007054"
  },
  {
    "name" : "Düren",
    "unCode" : "DE007064"
  },
  {
    "name" : "Bonn",
    "unCode" : "DE007152"
  },
  {
    "name" : "Gummersbach",
    "unCode" : "DE007153"
  },
  {
    "name" : "Flughafen Köln/Bonn",
    "unCode" : "DE007154"
  },
  {
    "name" : "Wahn",
    "unCode" : "DE007157"
  },
  {
    "name" : "KE Flughafen Köln/Bonn",
    "unCode" : "DE007159"
  },
  {
    "name" : "Köln-Messe",
    "unCode" : "DE007181"
  },
  {
    "name" : "Köln-West",
    "unCode" : "DE007202"
  },
  {
    "name" : "Aschersleben",
    "unCode" : "DE007352"
  },
  {
    "name" : "Stendal",
    "unCode" : "DE007359"
  },
  {
    "name" : "Dessau-Ost",
    "unCode" : "DE007361"
  },
  {
    "name" : "Halle (Saale)",
    "unCode" : "DE007362"
  },
  {
    "name" : "Magdeburg-Rothensee",
    "unCode" : "DE007380"
  },
  {
    "name" : "Göggingen",
    "unCode" : "DE007401"
  },
  {
    "name" : "Donauwörth",
    "unCode" : "DE007402"
  },
  {
    "name" : "Ingolstadt",
    "unCode" : "DE007403"
  },
  {
    "name" : "Kontrolleinheit Flughafen Augsburg",
    "unCode" : "DE007423"
  },
  {
    "name" : "KE Flughafen Memmingerberg",
    "unCode" : "DE007424"
  },
  {
    "name" : "Abfertigungsstelle Flughafen",
    "unCode" : "DE007430"
  },
  {
    "name" : "Altötting (Autobahn)",
    "unCode" : "DE007455"
  },
  {
    "name" : "Bad Reichenhall-Autobahn",
    "unCode" : "DE007458"
  },
  {
    "name" : "Hallbergmoos",
    "unCode" : "DE007501"
  },
  {
    "name" : "Plattling",
    "unCode" : "DE007504"
  },
  {
    "name" : "Hörbranz-Autobahn",
    "unCode" : "DE007551"
  },
  {
    "name" : "Kempten",
    "unCode" : "DE007553"
  },
  {
    "name" : "AbfSt Flughafen Memmingerberg",
    "unCode" : "DE007554"
  },
  {
    "name" : "Memmingen",
    "unCode" : "DE007561"
  },
  {
    "name" : "Garching-Hochbrück",
    "unCode" : "DE007602"
  },
  {
    "name" : "Kontrolleinheiten Flughafen München",
    "unCode" : "DE007611"
  },
  {
    "name" : "Flughafen München",
    "unCode" : "DE007650"
  },
  {
    "name" : "Suben-Autobahn (österr. Gebiet)",
    "unCode" : "DE007701"
  },
  {
    "name" : "Passau",
    "unCode" : "DE007703"
  },
  {
    "name" : "Weilheim",
    "unCode" : "DE007751"
  },
  {
    "name" : "Reischenhart",
    "unCode" : "DE007755"
  },
  {
    "name" : "Bielefeld-Eckendorfer Straße",
    "unCode" : "DE008001"
  },
  {
    "name" : "KE Flughafen Paderborn/Lippstadt",
    "unCode" : "DE008002"
  },
  {
    "name" : "Lemgo",
    "unCode" : "DE008004"
  },
  {
    "name" : "Lübbecke",
    "unCode" : "DE008008"
  },
  {
    "name" : "Bochum",
    "unCode" : "DE008051"
  },
  {
    "name" : "Gelsenkirchen",
    "unCode" : "DE008052"
  },
  {
    "name" : "Hagen",
    "unCode" : "DE008101"
  },
  {
    "name" : "Dortmund-Ost",
    "unCode" : "DE008103"
  },
  {
    "name" : "Lüdenscheid",
    "unCode" : "DE008104"
  },
  {
    "name" : "Siegen",
    "unCode" : "DE008106"
  },
  {
    "name" : "KE Flughafen Dortmund",
    "unCode" : "DE008107"
  },
  {
    "name" : "Flughafen Dortmund",
    "unCode" : "DE008131"
  },
  {
    "name" : "Kontrolleinheit Flughafen Münster",
    "unCode" : "DE008301"
  },
  {
    "name" : "Bocholt",
    "unCode" : "DE008302"
  },
  {
    "name" : "Coesfeld",
    "unCode" : "DE008303"
  },
  {
    "name" : "Münster-Loddenheide",
    "unCode" : "DE008304"
  },
  {
    "name" : "Rheine",
    "unCode" : "DE008305"
  },
  {
    "name" : "Flughafen Münster",
    "unCode" : "DE008306"
  },
  {
    "name" : "Anröchte",
    "unCode" : "DE008351"
  },
  {
    "name" : "Arnsberg",
    "unCode" : "DE008352"
  },
  {
    "name" : "Paderborn",
    "unCode" : "DE008355"
  },
  {
    "name" : "Beckum",
    "unCode" : "DE008356"
  },
  {
    "name" : "Flughafen Paderborn",
    "unCode" : "DE008380"
  },
  {
    "name" : "Bamberg",
    "unCode" : "DE008601"
  },
  {
    "name" : "Bayreuth",
    "unCode" : "DE008602"
  },
  {
    "name" : "Coburg",
    "unCode" : "DE008605"
  },
  {
    "name" : "Hof-Marktredwitz",
    "unCode" : "DE008715"
  },
  {
    "name" : "Ansbach-Weißenburg",
    "unCode" : "DE008751"
  },
  {
    "name" : "Erlangen-Tennenlohe",
    "unCode" : "DE008752"
  },
  {
    "name" : "Flughafen Nürnberg",
    "unCode" : "DE008755"
  },
  {
    "name" : "Hafen",
    "unCode" : "DE008756"
  },
  {
    "name" : "KE Flughafen Nürnberg",
    "unCode" : "DE008757"
  },
  {
    "name" : "Oberpfalz",
    "unCode" : "DE008801"
  },
  {
    "name" : "Regensburg-Furth im Wald",
    "unCode" : "DE008804"
  },
  {
    "name" : "Aschaffenburg",
    "unCode" : "DE008851"
  },
  {
    "name" : "Schweinfurt-Londonstraße",
    "unCode" : "DE008853"
  },
  {
    "name" : "Dettelbach-Mainfrankenpark",
    "unCode" : "DE008857"
  },
  {
    "name" : "Pomellen",
    "unCode" : "DE009004"
  },
  {
    "name" : "Neubrandenburg",
    "unCode" : "DE009030"
  },
  {
    "name" : "Ludwigslust",
    "unCode" : "DE009101"
  },
  {
    "name" : "Laage",
    "unCode" : "DE009102"
  },
  {
    "name" : "Wismar",
    "unCode" : "DE009103"
  },
  {
    "name" : "Rostock",
    "unCode" : "DE009104"
  },
  {
    "name" : "Kontrolleinheit Flughafen Rostock",
    "unCode" : "DE009106"
  },
  {
    "name" : "Wolgast",
    "unCode" : "DE009152"
  },
  {
    "name" : "Mukran",
    "unCode" : "DE009154"
  },
  {
    "name" : "Stralsund-Dänholm",
    "unCode" : "DE009180"
  },
  {
    "name" : "Saarbrücken",
    "unCode" : "DE009303"
  },
  {
    "name" : "Flughafen Saarbrücken",
    "unCode" : "DE009304"
  },
  {
    "name" : "KE Flughafen Saarbrücken",
    "unCode" : "DE009305"
  },
  {
    "name" : "Bodensee-Oberschwaben",
    "unCode" : "DE009404"
  },
  {
    "name" : "Abfertigungsstelle Fähre",
    "unCode" : "DE009420"
  },
  {
    "name" : "Heilbronn",
    "unCode" : "DE009452"
  },
  {
    "name" : "Ludwigsburg",
    "unCode" : "DE009453"
  },
  {
    "name" : "Tauberbischofsheim",
    "unCode" : "DE009456"
  },
  {
    "name" : "Untermünkheim",
    "unCode" : "DE009459"
  },
  {
    "name" : "Albstadt",
    "unCode" : "DE009501"
  },
  {
    "name" : "Böblingen",
    "unCode" : "DE009551"
  },
  {
    "name" : "Stuttgart-Hafen",
    "unCode" : "DE009552"
  },
  {
    "name" : "Stuttgart-Zuffenhausen",
    "unCode" : "DE009554"
  },
  {
    "name" : "Flughafen Stuttgart",
    "unCode" : "DE009555"
  },
  {
    "name" : "Winnenden",
    "unCode" : "DE009556"
  },
  {
    "name" : "KE Flughafen Stuttgart",
    "unCode" : "DE009557"
  },
  {
    "name" : "Abfertigungsstelle Landesmesse",
    "unCode" : "DE009589"
  },
  {
    "name" : "Aalen",
    "unCode" : "DE009651"
  },
  {
    "name" : "Göppingen",
    "unCode" : "DE009652"
  },
  {
    "name" : "KE Flughafen Friedrichshafen",
    "unCode" : "DE009653"
  },
  {
    "name" : "Donautal",
    "unCode" : "DE009656"
  },
  {
    "name" : "Metzingen",
    "unCode" : "DE009680"
  },
  {
    "name" : "Bane",
    "unCode" : "DK000020"
  },
  {
    "name" : "Toldstyrelsen (old)",
    "unCode" : "DK000460"
  },
  {
    "name" : "Færgeterminalen ved DFDS (old)",
    "unCode" : "DK000461"
  },
  {
    "name" : "Told Frihavnen (old)",
    "unCode" : "DK000462"
  },
  {
    "name" : "Told Kystvejen (old)",
    "unCode" : "DK000463"
  },
  {
    "name" : "Told Frederikshavn",
    "unCode" : "DK003101"
  },
  {
    "name" : "Told Hirtshals",
    "unCode" : "DK003102"
  },
  {
    "name" : "Told Kvistgård (old)",
    "unCode" : "DK003761"
  },
  {
    "name" : "Told Bornholm (old)",
    "unCode" : "DK003762"
  },
  {
    "name" : "Told Billund Lufthavn (old)",
    "unCode" : "DK003862"
  },
  {
    "name" : "Told Esbjerg (old)",
    "unCode" : "DK003863"
  },
  {
    "name" : "Told Aarhus",
    "unCode" : "DK004701"
  },
  {
    "name" : "Told Køge (old)",
    "unCode" : "DK005160"
  },
  {
    "name" : "Told Nørre Alslev (old)",
    "unCode" : "DK005162"
  },
  {
    "name" : "Skattecenter Middelfart",
    "unCode" : "DK005600"
  },
  {
    "name" : "Told Padborg",
    "unCode" : "DK005604"
  },
  {
    "name" : "Told Billund Lufthavn",
    "unCode" : "DK005606"
  },
  {
    "name" : "Told Esbjerg Havn",
    "unCode" : "DK005607"
  },
  {
    "name" : "Esbjerg Lufthavn",
    "unCode" : "DK005612"
  },
  {
    "name" : "Told Køge",
    "unCode" : "DK006600"
  },
  {
    "name" : "Told Nørre Alslev",
    "unCode" : "DK006602"
  },
  {
    "name" : "Told Køge",
    "unCode" : "DK007900"
  },
  {
    "name" : "Færgeterminalen ved DFDS",
    "unCode" : "DK007901"
  },
  {
    "name" : "Told Frihavnen",
    "unCode" : "DK007902"
  },
  {
    "name" : "Told Kystvejen",
    "unCode" : "DK007903"
  },
  {
    "name" : "Told Kvistgård",
    "unCode" : "DK007908"
  },
  {
    "name" : "Told Bornholm",
    "unCode" : "DK007909"
  },
  {
    "name" : "Centerhavn Toldekspedition",
    "unCode" : "DK009262"
  },
  {
    "name" : "Told Padborg (old)",
    "unCode" : "DK009264"
  },
  {
    "name" : "Told Aalborg",
    "unCode" : "DK009760"
  },
  {
    "name" : "Told Frederikshavn (old)",
    "unCode" : "DK009761"
  },
  {
    "name" : "Told Hirtshals (old)",
    "unCode" : "DK009762"
  },
  {
    "name" : "Told Aarhus (old)",
    "unCode" : "DK009860"
  },
  {
    "name" : "Tolliformaalsuste osakond",
    "unCode" : "EE1000EE"
  },
  {
    "name" : "Kvaliteedi kontrolli üksus",
    "unCode" : "EE1110EE"
  },
  {
    "name" : "Lennujaama kontroll",
    "unCode" : "EE1111EE"
  },
  {
    "name" : "Uurimisosakond",
    "unCode" : "EE1112EE"
  },
  {
    "name" : "Sadamate kontroll",
    "unCode" : "EE1113EE"
  },
  {
    "name" : "Põhja II talitus",
    "unCode" : "EE1115EE"
  },
  {
    "name" : "Kaupade kontroll",
    "unCode" : "EE1116EE"
  },
  {
    "name" : "Paldiski piiripunkt",
    "unCode" : "EE1160EE"
  },
  {
    "name" : "Muuga tollipunkt",
    "unCode" : "EE1210EE"
  },
  {
    "name" : "Lennujaama tollipunkt",
    "unCode" : "EE1310EE"
  },
  {
    "name" : "Klienditeeninduse osakond",
    "unCode" : "EE3000EE"
  },
  {
    "name" : "Pärnu teenindusbüroo",
    "unCode" : "EE3300EE"
  },
  {
    "name" : "Kuressaare teenindusbüroo",
    "unCode" : "EE3310EE"
  },
  {
    "name" : "Lääne talitus",
    "unCode" : "EE3700EE"
  },
  {
    "name" : "Võru teenindusbüroo",
    "unCode" : "EE4100EE"
  },
  {
    "name" : "Valga teenindusbüroo",
    "unCode" : "EE4110EE"
  },
  {
    "name" : "Tartu teenindusbüroo",
    "unCode" : "EE4120EE"
  },
  {
    "name" : "Lõuna talitus",
    "unCode" : "EE4400EE"
  },
  {
    "name" : "Luhamaa tollipunkt",
    "unCode" : "EE4600EE"
  },
  {
    "name" : "Luhamaa piiripunkt",
    "unCode" : "EE4700EE"
  },
  {
    "name" : "Koidula maantee piiripunkt",
    "unCode" : "EE4800EE"
  },
  {
    "name" : "Koidula raudtee piiripunkt",
    "unCode" : "EE4810EE"
  },
  {
    "name" : "Narva teenindusbüroo",
    "unCode" : "EE5100EE"
  },
  {
    "name" : "Rakvere teenindusbüroo",
    "unCode" : "EE5110EE"
  },
  {
    "name" : "Sillamäe tollipunkt",
    "unCode" : "EE5130EE"
  },
  {
    "name" : "Narva raudtee piiripunkt",
    "unCode" : "EE5500EE"
  },
  {
    "name" : "Narva tollipunkt",
    "unCode" : "EE5600EE"
  },
  {
    "name" : "Ida talitus",
    "unCode" : "EE5800EE"
  },
  {
    "name" : "ADUANA AEROPUERTO VITORIA-FORONDA",
    "unCode" : "ES000101"
  },
  {
    "name" : "ADUANA DE VITORIA - CARRETERA",
    "unCode" : "ES000141"
  },
  {
    "name" : "ADUANA DE VITORIA DOMICILIACIÓN",
    "unCode" : "ES000150"
  },
  {
    "name" : "ADUANA DE ALBACETE DOMICILIACIÓN",
    "unCode" : "ES000241"
  },
  {
    "name" : "ADUANA AEROPUERTO ALICANTE-ELCHE",
    "unCode" : "ES000301"
  },
  {
    "name" : "ADUANA DE ALICANTE - MARÍTIMA",
    "unCode" : "ES000311"
  },
  {
    "name" : "ADUANA AEROPUERTO DE ALMERÍA",
    "unCode" : "ES000401"
  },
  {
    "name" : "ADUANA DE ALMERIA-MARÍTIMA",
    "unCode" : "ES000411"
  },
  {
    "name" : "ADUANA DE PUERTO DE GARRUCHA",
    "unCode" : "ES000412"
  },
  {
    "name" : "ALMERÍA-MARÍTIMA CARBONERAS",
    "unCode" : "ES000415"
  },
  {
    "name" : "ADUANA DE ALMERIA-CARRETERA",
    "unCode" : "ES000441"
  },
  {
    "name" : "ADUANA DE BADAJOZ-CARRETERA.",
    "unCode" : "ES000641"
  },
  {
    "name" : "ADUANA DE BADAJOZ-FERROCARRIL",
    "unCode" : "ES000671"
  },
  {
    "name" : "ADUANA AEROPUERTO PALMA MALLORCA",
    "unCode" : "ES000701"
  },
  {
    "name" : "ADUANA AEROPUERTO DE IBIZA",
    "unCode" : "ES000707"
  },
  {
    "name" : "ADUANA AEROPUERTO DE MAHÓN",
    "unCode" : "ES000708"
  },
  {
    "name" : "ADUANA DE PALMA DE MALLORCA",
    "unCode" : "ES000711"
  },
  {
    "name" : "ADUANA DE ALCUDIA",
    "unCode" : "ES000717"
  },
  {
    "name" : "ADUANA DE IBIZA MARITIMA",
    "unCode" : "ES000721"
  },
  {
    "name" : "ADUANA DE MAHON - MARITIMA",
    "unCode" : "ES000731"
  },
  {
    "name" : "ADUANA AEROPUERTO BARCELONA EL PRAT",
    "unCode" : "ES000801"
  },
  {
    "name" : "ADUANA DE BARCELONA - MARÍTIMA",
    "unCode" : "ES000811"
  },
  {
    "name" : "ADUANA DE BARCELONA-MARÍTIMA EXPORT",
    "unCode" : "ES000812"
  },
  {
    "name" : "ADUANA DE BARCELONA-ZONA FRANCA",
    "unCode" : "ES000821"
  },
  {
    "name" : "ADUANA DE BARCELONA - CARRETERA",
    "unCode" : "ES000841"
  },
  {
    "name" : "ADUANA DE BARCELONA FERIA MUESTRAS",
    "unCode" : "ES000851"
  },
  {
    "name" : "ADUANA DE BARCELONA-DOMICILIACIÓN",
    "unCode" : "ES000860"
  },
  {
    "name" : "ADUANA DE BARCELONA-FFCC.- MORROT",
    "unCode" : "ES000881"
  },
  {
    "name" : "ADUANA DE BURGOS CARRETERA",
    "unCode" : "ES000941"
  },
  {
    "name" : "ADUANA DE CÁCERES-CARRETERA",
    "unCode" : "ES001041"
  },
  {
    "name" : "ADUANA AEROPUERTO JEREZ DE LA FRONT",
    "unCode" : "ES001101"
  },
  {
    "name" : "ADUANA DE CADIZ - PRINCIPAL",
    "unCode" : "ES001111"
  },
  {
    "name" : "ADUANA DE CADIZ - ZONA FRANCA",
    "unCode" : "ES001115"
  },
  {
    "name" : "ADUANA DE ALGECIRAS DOMICILIACIÓN",
    "unCode" : "ES001130"
  },
  {
    "name" : "ADUANA DE ALGECIRAS MARÍTIMA",
    "unCode" : "ES001131"
  },
  {
    "name" : "ADUANA DE ALGECIRAS- TARIFA",
    "unCode" : "ES001133"
  },
  {
    "name" : "ADUANA DE CADIZ - CARRETERA",
    "unCode" : "ES001141"
  },
  {
    "name" : "ADUANA DE LÍNEA DE CONCEPCIÓN-MAR",
    "unCode" : "ES001161"
  },
  {
    "name" : "ADUANA DE LA LINEA DE LA CONCEPCIÓN",
    "unCode" : "ES001167"
  },
  {
    "name" : "ADUANA DE CASTELLON DE LA PLANA",
    "unCode" : "ES001211"
  },
  {
    "name" : "ADUANA DE CASTELLON - CARRETERA",
    "unCode" : "ES001241"
  },
  {
    "name" : "ADUANA DE CIUDAD REAL AEROPUERTO",
    "unCode" : "ES001301"
  },
  {
    "name" : "ADUANA DE CIUDAD REAL CARRETERA",
    "unCode" : "ES001341"
  },
  {
    "name" : "ADUANA DE CORDOBA CARRETERA",
    "unCode" : "ES001441"
  },
  {
    "name" : "ADUANA AEROPUERTO A CORUÑA-ALVEDRO",
    "unCode" : "ES001501"
  },
  {
    "name" : "ADUANA AEROPUERTO SANTIAGO-LABACOLL",
    "unCode" : "ES001507"
  },
  {
    "name" : "ADUANA DE A CORUÑA",
    "unCode" : "ES001511"
  },
  {
    "name" : "ADUANA DE A CORUÑA-DEPOSITO FRANCO",
    "unCode" : "ES001517"
  },
  {
    "name" : "ADUANA DE EL FERROL-MARITIMA",
    "unCode" : "ES001521"
  },
  {
    "name" : "ADUANA DE A CORUÑA CARRETERA",
    "unCode" : "ES001541"
  },
  {
    "name" : "ADUANA DE EL FERROL - CARRETERA",
    "unCode" : "ES001551"
  },
  {
    "name" : "ADUANA DE CUENCA CARRETERA",
    "unCode" : "ES001641"
  },
  {
    "name" : "ADUANA DE PALAMOS-MARITIMA",
    "unCode" : "ES001711"
  },
  {
    "name" : "ADUANA DE LA JUNQUERA",
    "unCode" : "ES001741"
  },
  {
    "name" : "ADUANA DE VILLAMALLA",
    "unCode" : "ES001761"
  },
  {
    "name" : "ADUANA DE PORT BOU - FERROCARRIL",
    "unCode" : "ES001771"
  },
  {
    "name" : "ADUANA DE MOTRIL",
    "unCode" : "ES001811"
  },
  {
    "name" : "ADUANA DE MOTRIL-CARRETERA",
    "unCode" : "ES001841"
  },
  {
    "name" : "ADUANA DE GUADALAJARA CARRETERA",
    "unCode" : "ES001941"
  },
  {
    "name" : "ADUANA DE GUADALAJARA DOMICILIACIÓN",
    "unCode" : "ES001950"
  },
  {
    "name" : "ADUANA AEROPUERTO IRÚN",
    "unCode" : "ES002001"
  },
  {
    "name" : "ADUANA DE PASAJES - MARÍTIMA",
    "unCode" : "ES002011"
  },
  {
    "name" : "ADUANA DE IRUN-ZAISA",
    "unCode" : "ES002045"
  },
  {
    "name" : "ADUANA DE PASAJES CARRETERA",
    "unCode" : "ES002051"
  },
  {
    "name" : "ADUANA DE IRÚN FERROCARRIL",
    "unCode" : "ES002071"
  },
  {
    "name" : "ADUANA DE HUELVA - PRINCIPAL",
    "unCode" : "ES002111"
  },
  {
    "name" : "ADUANA DE HUELVA - CARRETERA",
    "unCode" : "ES002141"
  },
  {
    "name" : "ADUANA DE JAÉN DOMICILIACIÓN",
    "unCode" : "ES002341"
  },
  {
    "name" : "ADUANA DE LEÓN CARRETERA",
    "unCode" : "ES002441"
  },
  {
    "name" : "ADUANA DE LA FARGA DE MOLES",
    "unCode" : "ES002541"
  },
  {
    "name" : "ADUANA DE LLEIDA CARRETERA",
    "unCode" : "ES002561"
  },
  {
    "name" : "ADUANA DE LOGROÑO",
    "unCode" : "ES002641"
  },
  {
    "name" : "ADUANA AEROPUERTO DE LA RIOJA",
    "unCode" : "ES002642"
  },
  {
    "name" : "ADUANA DE RIBADEO",
    "unCode" : "ES002711"
  },
  {
    "name" : "ADUANA AEROPUERTO MADRID-BARAJAS",
    "unCode" : "ES002801"
  },
  {
    "name" : "ADUANA POSTAL DE MADRID",
    "unCode" : "ES002803"
  },
  {
    "name" : "ADUANA DE MADRID-DOMICILIACIÓN",
    "unCode" : "ES002861"
  },
  {
    "name" : "ADUANA AEROPUERTO MÁLAGA",
    "unCode" : "ES002901"
  },
  {
    "name" : "ADUANA DE MALAGA-PRINCIPAL",
    "unCode" : "ES002911"
  },
  {
    "name" : "ADUANA DE MALAGA- DOMICILIACIÓN",
    "unCode" : "ES002915"
  },
  {
    "name" : "ADUANA DE MALAGA-CARRETERA",
    "unCode" : "ES002941"
  },
  {
    "name" : "ADUANA DE MURCIA AEROPUERTO INTERNA",
    "unCode" : "ES003001"
  },
  {
    "name" : "ADUANA DE CARTAGENA - PRINCIPAL",
    "unCode" : "ES003011"
  },
  {
    "name" : "ADUANA DE MURCIA - CARRETERA",
    "unCode" : "ES003051"
  },
  {
    "name" : "ADUANA DE PAMPLONA - IMARCOAÍN",
    "unCode" : "ES003161"
  },
  {
    "name" : "ADUANA DE PAMPLONA - NOAÍN FERROC.",
    "unCode" : "ES003171"
  },
  {
    "name" : "ADUANA DE OURENSE CARRETERA",
    "unCode" : "ES003241"
  },
  {
    "name" : "ADUANA AEROPUERTO DE ASTURIAS",
    "unCode" : "ES003301"
  },
  {
    "name" : "ADUANA DE GIJON -MARITIMA",
    "unCode" : "ES003311"
  },
  {
    "name" : "ADUANA DE AVILÉS MARÍTIMA",
    "unCode" : "ES003331"
  },
  {
    "name" : "ADUANA DE GIJÓN CARRETERA",
    "unCode" : "ES003341"
  },
  {
    "name" : "ADUANA DE AVILES CARRETERA",
    "unCode" : "ES003351"
  },
  {
    "name" : "ADUANA DE GIJON - FERROCARRIL",
    "unCode" : "ES003371"
  },
  {
    "name" : "ADUANA DE PALENCIA-CARRETERA",
    "unCode" : "ES003441"
  },
  {
    "name" : "ADUANA DE FUERTEVENTURA-MAR. (T1)",
    "unCode" : "ES003541"
  },
  {
    "name" : "ADUANA AEROPUERTO FUERTEVENTURA",
    "unCode" : "ES003551"
  },
  {
    "name" : "ADUANA DE LANZAROTE-MARITIMA (T1)",
    "unCode" : "ES003561"
  },
  {
    "name" : "ADUANA AEROPUERTO LANZAROTE",
    "unCode" : "ES003571"
  },
  {
    "name" : "ADUANA AEROPUERTO GRAN CANARIA",
    "unCode" : "ES003581"
  },
  {
    "name" : "ADUANA DE LAS PALMAS MARÍTIMA (T1)",
    "unCode" : "ES003591"
  },
  {
    "name" : "ADUANA DE GRAN CANARIA POSTAL",
    "unCode" : "ES003593"
  },
  {
    "name" : "ADUANA AEROPUERTO VIGO",
    "unCode" : "ES003601"
  },
  {
    "name" : "ADUANA DE VIGO-PRINCIPAL",
    "unCode" : "ES003611"
  },
  {
    "name" : "ADUANA DE MARIN",
    "unCode" : "ES003621"
  },
  {
    "name" : "ADUANA DE VILAGARCIA DE AROUSA-MAR.",
    "unCode" : "ES003631"
  },
  {
    "name" : "ADUANA DE VIGO CARRETERA",
    "unCode" : "ES003641"
  },
  {
    "name" : "ADUANA DE VILAGARCIA DE AROUSA CAR.",
    "unCode" : "ES003651"
  },
  {
    "name" : "ADUANA DE VIGO-ZONA FRANCA",
    "unCode" : "ES003681"
  },
  {
    "name" : "ADUANA DE VIGO DOMICILIACIÓN",
    "unCode" : "ES003691"
  },
  {
    "name" : "ADUANA DE SALAMANCA-CARRETERA",
    "unCode" : "ES003741"
  },
  {
    "name" : "ADUANA DE STA CRUZ DE PALMA-MAR.T1",
    "unCode" : "ES003861"
  },
  {
    "name" : "ADUANA AEROPUERTO LA PALMA",
    "unCode" : "ES003871"
  },
  {
    "name" : "ADUANA AEROPUERTO TENERIFE SUR",
    "unCode" : "ES003881"
  },
  {
    "name" : "ADUANA AEROPUERTO TENERIFE NORTE",
    "unCode" : "ES003883"
  },
  {
    "name" : "ADUANA DE TENERIFE-MARÍTIMA",
    "unCode" : "ES003891"
  },
  {
    "name" : "ADUANA DE TENERIFE POSTALES",
    "unCode" : "ES003893"
  },
  {
    "name" : "ADUANA AEROPUERTO SANTANDER",
    "unCode" : "ES003901"
  },
  {
    "name" : "ADUANA DE SANTANDER-MARITIMA",
    "unCode" : "ES003911"
  },
  {
    "name" : "ADUANA DE SANTANDER ZONA FRANCA",
    "unCode" : "ES003921"
  },
  {
    "name" : "ADUANA DE SANTANDER CARRETERA",
    "unCode" : "ES003941"
  },
  {
    "name" : "ADUANA AEROPUERTO SEVILLA",
    "unCode" : "ES004101"
  },
  {
    "name" : "ADUANA DE SEVILLA-PRINCIPAL",
    "unCode" : "ES004111"
  },
  {
    "name" : "SEVILLA-ZONA FRANCA",
    "unCode" : "ES004115"
  },
  {
    "name" : "ADUANA DE SEVILLA CARRETERA",
    "unCode" : "ES004141"
  },
  {
    "name" : "ADUANA DE TARRAGONA-MARITIMA",
    "unCode" : "ES004311"
  },
  {
    "name" : "ADUANA DE SAN CARLOS DE LA RÁPITA",
    "unCode" : "ES004321"
  },
  {
    "name" : "ADUANA DE TARRAGONA-CARRETERA",
    "unCode" : "ES004341"
  },
  {
    "name" : "ADUANA DE TARRAGONA-DOMICIL. Y DEP.",
    "unCode" : "ES004350"
  },
  {
    "name" : "ADUANA DE TARRAGONA-FEROCARRIL",
    "unCode" : "ES004371"
  },
  {
    "name" : "ADUANA DE TOLEDO DOMICILIACIÓN",
    "unCode" : "ES004541"
  },
  {
    "name" : "ADUANA AEROPUERTO VALENCIA",
    "unCode" : "ES004601"
  },
  {
    "name" : "ADUANA DE VALENCIA MARÍTIMA",
    "unCode" : "ES004611"
  },
  {
    "name" : "ADUANA DE SAGUNTO-MARITIMA",
    "unCode" : "ES004621"
  },
  {
    "name" : "ADUANA DE GANDIA-MARITIMA",
    "unCode" : "ES004631"
  },
  {
    "name" : "ADUANA DE VALENCIA CARRETERA",
    "unCode" : "ES004641"
  },
  {
    "name" : "ADUANA DE SILLA-CARRETERA",
    "unCode" : "ES004647"
  },
  {
    "name" : "ADUANA DE VALENCIA-DOMICILIACIÓN",
    "unCode" : "ES004650"
  },
  {
    "name" : "ADUANA DE VALLADOLID",
    "unCode" : "ES004741"
  },
  {
    "name" : "ADUANA AEROPUERTO BILBAO",
    "unCode" : "ES004801"
  },
  {
    "name" : "ADUANA DE BILBAO-MARITIMA",
    "unCode" : "ES004811"
  },
  {
    "name" : "ADUANA DE BILBAO-ZAL",
    "unCode" : "ES004825"
  },
  {
    "name" : "ADUANA DE BILBAO - CARRETERA",
    "unCode" : "ES004842"
  },
  {
    "name" : "ADUANA DE BILBAO DOMICILIACIÓN",
    "unCode" : "ES004850"
  },
  {
    "name" : "ADUANA AEROPUERTO ZARAGOZA",
    "unCode" : "ES005001"
  },
  {
    "name" : "ADUANA DE ZARAGOZA CARRETERA/TIR",
    "unCode" : "ES005041"
  },
  {
    "name" : "ADUANA DE ZARAGOZA-DOMICILIACION",
    "unCode" : "ES005060"
  },
  {
    "name" : "Meritulli Olympiaterminaali",
    "unCode" : "FI001400"
  },
  {
    "name" : "HELSINKI Katajanokka K7 Tulli",
    "unCode" : "FI001602"
  },
  {
    "name" : "Helsinki Tulli KatajanokkaK9",
    "unCode" : "FI001604"
  },
  {
    "name" : "Helsinki Tulli Länsisatama L5",
    "unCode" : "FI001802"
  },
  {
    "name" : "Tulliselvityskeskus",
    "unCode" : "FI002000"
  },
  {
    "name" : "Tulliselvityskeskus, TRA",
    "unCode" : "FI002006"
  },
  {
    "name" : "Helsinki Tulli",
    "unCode" : "FI005000"
  },
  {
    "name" : "Meritulli Vuosaari satama V6",
    "unCode" : "FI009801"
  },
  {
    "name" : "Meritulli Vuosaari Hansaterminaali",
    "unCode" : "FI009802"
  },
  {
    "name" : "Lentotulli Helsinki-Vantaa Rahti",
    "unCode" : "FI015300"
  },
  {
    "name" : "Lentotulli Hki-Vantaa Matkustaja",
    "unCode" : "FI015302"
  },
  {
    "name" : "Loviisa Satama Tulli",
    "unCode" : "FI079000"
  },
  {
    "name" : "Hanko Tulli",
    "unCode" : "FI109000"
  },
  {
    "name" : "Turku Tulli",
    "unCode" : "FI201000"
  },
  {
    "name" : "Turku Tulli",
    "unCode" : "FI201003"
  },
  {
    "name" : "Turku Lentotulli",
    "unCode" : "FI203600"
  },
  {
    "name" : "Naantalin satama Tulli",
    "unCode" : "FI211000"
  },
  {
    "name" : "Mariehamn Tull Hamnterminal",
    "unCode" : "FI221001"
  },
  {
    "name" : "Eckerö Tulli",
    "unCode" : "FI222700"
  },
  {
    "name" : "Långnäs Tulli",
    "unCode" : "FI226300"
  },
  {
    "name" : "Uusikaupunki satama Tulli",
    "unCode" : "FI235000"
  },
  {
    "name" : "Rauma Tulli",
    "unCode" : "FI261000"
  },
  {
    "name" : "PoriTulli",
    "unCode" : "FI288800"
  },
  {
    "name" : "Tampere Tulli",
    "unCode" : "FI339000"
  },
  {
    "name" : "Jyväskylä Tulli",
    "unCode" : "FI403200"
  },
  {
    "name" : "Kotka Hietasen satama Tulli",
    "unCode" : "FI482000"
  },
  {
    "name" : "Kotka Tulli",
    "unCode" : "FI483100"
  },
  {
    "name" : "Hamina Tulli",
    "unCode" : "FI494600"
  },
  {
    "name" : "Vaalimaa Tulli",
    "unCode" : "FI499300"
  },
  {
    "name" : "Nuijamaa Tulli",
    "unCode" : "FI542300"
  },
  {
    "name" : "Vainikkala Tulli",
    "unCode" : "FI542700"
  },
  {
    "name" : "Imatra Tulli",
    "unCode" : "FI556100"
  },
  {
    "name" : "Kaskisen satama Tulli",
    "unCode" : "FI642600"
  },
  {
    "name" : "Vaasa Tulli",
    "unCode" : "FI651700"
  },
  {
    "name" : "Kokkola Tulli",
    "unCode" : "FI671000"
  },
  {
    "name" : "Pietarsaaren satama Tulli",
    "unCode" : "FI686000"
  },
  {
    "name" : "Niirala Tulli",
    "unCode" : "FI826750"
  },
  {
    "name" : "Vartius Tulli",
    "unCode" : "FI889300"
  },
  {
    "name" : "Oulu Tulli",
    "unCode" : "FI904000"
  },
  {
    "name" : "OULU LENTOTULLI",
    "unCode" : "FI904001"
  },
  {
    "name" : "Kuusamo Tulli",
    "unCode" : "FI939990"
  },
  {
    "name" : "Kemin Satama Tulli",
    "unCode" : "FI941000"
  },
  {
    "name" : "Tornio Hallinto Tulli",
    "unCode" : "FI954000"
  },
  {
    "name" : "Tornio Tulli",
    "unCode" : "FI954001"
  },
  {
    "name" : "Salla Tulli",
    "unCode" : "FI989200"
  },
  {
    "name" : "Kivilompolo Tulli",
    "unCode" : "FI994400"
  },
  {
    "name" : "Kilpisjärvi Tulli",
    "unCode" : "FI994900"
  },
  {
    "name" : "Raja-Jooseppi Tulli",
    "unCode" : "FI998001"
  },
  {
    "name" : "Näätämö tulli",
    "unCode" : "FI998002"
  },
  {
    "name" : "Karigasniemi Tulli",
    "unCode" : "FI999500"
  },
  {
    "name" : "Utsjoki Tulli",
    "unCode" : "FI999800"
  },
  {
    "name" : "Polmak Tulli",
    "unCode" : "FI999801"
  },
  {
    "name" : "Ajaccio port",
    "unCode" : "FR000040"
  },
  {
    "name" : "Amiens bureau",
    "unCode" : "FR000100"
  },
  {
    "name" : "Angers bureau",
    "unCode" : "FR000120"
  },
  {
    "name" : "Angouleme bureau",
    "unCode" : "FR000130"
  },
  {
    "name" : "Annecy bureau",
    "unCode" : "FR000140"
  },
  {
    "name" : "Dunkerque energies bureau",
    "unCode" : "FR000170"
  },
  {
    "name" : "Avignon bureau",
    "unCode" : "FR000270"
  },
  {
    "name" : "Bale mulhouse aero bureau",
    "unCode" : "FR000340"
  },
  {
    "name" : "Bastia port",
    "unCode" : "FR000380"
  },
  {
    "name" : "Bayonne bureau",
    "unCode" : "FR000390"
  },
  {
    "name" : "Besancon bureau",
    "unCode" : "FR000460"
  },
  {
    "name" : "Bordeaux merignac bureau",
    "unCode" : "FR000600"
  },
  {
    "name" : "Bordeaux bassens pt bureau",
    "unCode" : "FR000610"
  },
  {
    "name" : "Boulogne bureau",
    "unCode" : "FR000630"
  },
  {
    "name" : "Brest bureau",
    "unCode" : "FR000690"
  },
  {
    "name" : "Caen bureau",
    "unCode" : "FR000720"
  },
  {
    "name" : "Calais bureau",
    "unCode" : "FR000740"
  },
  {
    "name" : "Cannes bureau",
    "unCode" : "FR000800"
  },
  {
    "name" : "Chambery bureau",
    "unCode" : "FR000870"
  },
  {
    "name" : "Chateauroux bureau",
    "unCode" : "FR000910"
  },
  {
    "name" : "Cherbourg bureau",
    "unCode" : "FR000950"
  },
  {
    "name" : "Clermont bureau",
    "unCode" : "FR000980"
  },
  {
    "name" : "Delle bureau",
    "unCode" : "FR001140"
  },
  {
    "name" : "Dijon bureau",
    "unCode" : "FR001170"
  },
  {
    "name" : "Donges raffinerie",
    "unCode" : "FR001200"
  },
  {
    "name" : "Dunkerque port bureau",
    "unCode" : "FR001260"
  },
  {
    "name" : "Ennery bureau",
    "unCode" : "FR001280"
  },
  {
    "name" : "Epinal bureau",
    "unCode" : "FR001290"
  },
  {
    "name" : "Ferney voltaire bureau",
    "unCode" : "FR001400"
  },
  {
    "name" : "Gonfreville raffinerie",
    "unCode" : "FR001560"
  },
  {
    "name" : "Grenoble bureau",
    "unCode" : "FR001610"
  },
  {
    "name" : "Ferriere sous jougne",
    "unCode" : "FR00201S"
  },
  {
    "name" : "L'isle d'abeau bureau",
    "unCode" : "FR002030"
  },
  {
    "name" : "La rochelle pallice bureau",
    "unCode" : "FR002090"
  },
  {
    "name" : "Le Havre Produits Pétroliers",
    "unCode" : "FR002270"
  },
  {
    "name" : "Le Havre Port bureau",
    "unCode" : "FR002300"
  },
  {
    "name" : "Le mans bureau",
    "unCode" : "FR002340"
  },
  {
    "name" : "Porta bureau",
    "unCode" : "FR002510"
  },
  {
    "name" : "Limoges bureau",
    "unCode" : "FR002540"
  },
  {
    "name" : "Lorient bureau",
    "unCode" : "FR002600"
  },
  {
    "name" : "Lyon St Exupery bureau",
    "unCode" : "FR002650"
  },
  {
    "name" : "Marignane aero bureau",
    "unCode" : "FR002710"
  },
  {
    "name" : "Marseille port bureau",
    "unCode" : "FR002730"
  },
  {
    "name" : "Monaco bureau",
    "unCode" : "FR002860"
  },
  {
    "name" : "Morteau bureau",
    "unCode" : "FR002970"
  },
  {
    "name" : "COL FRANCE BC",
    "unCode" : "FR00297S"
  },
  {
    "name" : "Mulhouse bureau",
    "unCode" : "FR002990"
  },
  {
    "name" : "Nancy bureau",
    "unCode" : "FR003000"
  },
  {
    "name" : "Nantes atlant. bureau",
    "unCode" : "FR003030"
  },
  {
    "name" : "Nice aero bureau",
    "unCode" : "FR003080"
  },
  {
    "name" : "Nimes bureau",
    "unCode" : "FR003120"
  },
  {
    "name" : "Orleans bureau",
    "unCode" : "FR003160"
  },
  {
    "name" : "Paris principal bureau",
    "unCode" : "FR003260"
  },
  {
    "name" : "Orly aero bureau",
    "unCode" : "FR003370"
  },
  {
    "name" : "Gennevilliers bureau",
    "unCode" : "FR003410"
  },
  {
    "name" : "Pau bureau",
    "unCode" : "FR003440"
  },
  {
    "name" : "Perpignan bureau",
    "unCode" : "FR003480"
  },
  {
    "name" : "Poitiers bureau",
    "unCode" : "FR003540"
  },
  {
    "name" : "Pontarlier bureau",
    "unCode" : "FR003550"
  },
  {
    "name" : "Port de Bouc Energies",
    "unCode" : "FR003620"
  },
  {
    "name" : "Port jerome raffinerie",
    "unCode" : "FR003630"
  },
  {
    "name" : "Fos port st louis pt bureau",
    "unCode" : "FR003680"
  },
  {
    "name" : "Port Vendres port bureau",
    "unCode" : "FR003690"
  },
  {
    "name" : "Reims bureau",
    "unCode" : "FR003790"
  },
  {
    "name" : "Rennes bureau",
    "unCode" : "FR003800"
  },
  {
    "name" : "Rouen port bureau",
    "unCode" : "FR003920"
  },
  {
    "name" : "St Etienne bureau",
    "unCode" : "FR003970"
  },
  {
    "name" : "St julien bardon. bureau",
    "unCode" : "FR004020"
  },
  {
    "name" : "St louis autoroute",
    "unCode" : "FR004050"
  },
  {
    "name" : "St malo bureau",
    "unCode" : "FR004060"
  },
  {
    "name" : "St nazaire montoir bureau",
    "unCode" : "FR004080"
  },
  {
    "name" : "Sete bureau",
    "unCode" : "FR004250"
  },
  {
    "name" : "STRASBOURG-ENTZHEIM BUREAU",
    "unCode" : "FR004310"
  },
  {
    "name" : "SAINT-GINGOLPH BC",
    "unCode" : "FR00439A"
  },
  {
    "name" : "Toulon la seyne bureau",
    "unCode" : "FR004430"
  },
  {
    "name" : "Toulouse blagnac aero bureau",
    "unCode" : "FR004440"
  },
  {
    "name" : "Troyes bureau",
    "unCode" : "FR004520"
  },
  {
    "name" : "Valence bureau",
    "unCode" : "FR004550"
  },
  {
    "name" : "Valenciennes bureau",
    "unCode" : "FR004560"
  },
  {
    "name" : "Brive bureau",
    "unCode" : "FR004960"
  },
  {
    "name" : "Compiegne bureau",
    "unCode" : "FR004990"
  },
  {
    "name" : "St quentin bureau",
    "unCode" : "FR005040"
  },
  {
    "name" : "Vatry bureau",
    "unCode" : "FR005061"
  },
  {
    "name" : "Niort bureau",
    "unCode" : "FR005070"
  },
  {
    "name" : "Agen bureau",
    "unCode" : "FR005130"
  },
  {
    "name" : "Grandpuits raffinerie",
    "unCode" : "FR005190"
  },
  {
    "name" : "Lons le saunier bureau",
    "unCode" : "FR005260"
  },
  {
    "name" : "Aulnay-sous-Bois bureau",
    "unCode" : "FR005340"
  },
  {
    "name" : "Lesquin bureau",
    "unCode" : "FR005350"
  },
  {
    "name" : "Corbeil evry bureau",
    "unCode" : "FR005440"
  },
  {
    "name" : "Cahors bureau",
    "unCode" : "FR005470"
  },
  {
    "name" : "Rodez bureau",
    "unCode" : "FR005480"
  },
  {
    "name" : "Haguenau bureau",
    "unCode" : "FR005580"
  },
  {
    "name" : "Trappes bureau",
    "unCode" : "FR005590"
  },
  {
    "name" : "Arras bureau",
    "unCode" : "FR005620"
  },
  {
    "name" : "Montauban bureau",
    "unCode" : "FR005680"
  },
  {
    "name" : "Albi bureau",
    "unCode" : "FR005800"
  },
  {
    "name" : "Auch bureau",
    "unCode" : "FR005810"
  },
  {
    "name" : "Gap bureau",
    "unCode" : "FR005830"
  },
  {
    "name" : "Mont de marsan bureau",
    "unCode" : "FR005850"
  },
  {
    "name" : "Rungis bureau",
    "unCode" : "FR006130"
  },
  {
    "name" : "Roissy France handling bureau",
    "unCode" : "FR00617C"
  },
  {
    "name" : "Roissy Fedex bureau",
    "unCode" : "FR00619C"
  },
  {
    "name" : "La roche sur yon bureau",
    "unCode" : "FR006240"
  },
  {
    "name" : "Marne la vallee bureau",
    "unCode" : "FR006270"
  },
  {
    "name" : "Le raizet bureau",
    "unCode" : "FR006330"
  },
  {
    "name" : "Fort de france port bureau",
    "unCode" : "FR006340"
  },
  {
    "name" : "Degrad d cannes port bureau",
    "unCode" : "FR006370"
  },
  {
    "name" : "Cayenne aero bureau",
    "unCode" : "FR006380"
  },
  {
    "name" : "St laurent maroni bureau",
    "unCode" : "FR006390"
  },
  {
    "name" : "Le port bureau",
    "unCode" : "FR006420"
  },
  {
    "name" : "Le lamentin aero bureau",
    "unCode" : "FR006440"
  },
  {
    "name" : "St denis aero",
    "unCode" : "FR006460"
  },
  {
    "name" : "Cayenne CDP",
    "unCode" : "FR006530"
  },
  {
    "name" : "La pointe-jarry port",
    "unCode" : "FR006610"
  },
  {
    "name" : "Vallard thonex bureau",
    "unCode" : "FR006670"
  },
  {
    "name" : "Montpellier Mediterranee aero bur",
    "unCode" : "FR006710"
  },
  {
    "name" : "St georges de l'oyapok bureau",
    "unCode" : "FR006750"
  },
  {
    "name" : "Roissy prise en charge",
    "unCode" : "FR00677A"
  },
  {
    "name" : "Wissous BDP",
    "unCode" : "FR006790"
  },
  {
    "name" : "Longoni port bureau",
    "unCode" : "FR006800"
  },
  {
    "name" : "Pamandzi bureau",
    "unCode" : "FR006810"
  },
  {
    "name" : "Cid Bureau fictif",
    "unCode" : "FR009990"
  },
  {
    "name" : "Montpellier mediterranee bur dedoua",
    "unCode" : "FR340002"
  },
  {
    "name" : "Dunkerque ferry bureau",
    "unCode" : "FR590002"
  },
  {
    "name" : "Calais port tunnel bureau",
    "unCode" : "FR620001"
  },
  {
    "name" : "Roissy Sogaris bureau",
    "unCode" : "FRA0617B"
  },
  {
    "name" : "Roissy CDP bureau",
    "unCode" : "FRA0617D"
  },
  {
    "name" : "Roissy Air France bureau",
    "unCode" : "FRA0619A"
  },
  {
    "name" : "Roissy Cargo centre bureau",
    "unCode" : "FRA0619B"
  },
  {
    "name" : "Roissy Sodexi bureau",
    "unCode" : "FRB0617A"
  },
  {
    "name" : "Roissy Chronopost bureau",
    "unCode" : "FRB0617D"
  },
  {
    "name" : "Roissy Cargo 7 bureau",
    "unCode" : "FRB0617E"
  },
  {
    "name" : "Roissy Banale bureau",
    "unCode" : "FRB0619A"
  },
  {
    "name" : "Roissy avitaillement",
    "unCode" : "FRB0677B"
  },
  {
    "name" : "Roissy Nord Gestion des procedures",
    "unCode" : "FRC0619A"
  },
  {
    "name" : "Le Havre Port - CREPS",
    "unCode" : "FRD02300"
  },
  {
    "name" : "Roissy OPCO Aerogares",
    "unCode" : "FRD0619A"
  },
  {
    "name" : "National Transit Movements",
    "unCode" : "GB000004"
  },
  {
    "name" : "Birmingham Airport",
    "unCode" : "GB000011"
  },
  {
    "name" : "UKBF, Bristol International Airport",
    "unCode" : "GB000029"
  },
  {
    "name" : "Ramsgate",
    "unCode" : "GB000047"
  },
  {
    "name" : "Felixstowe",
    "unCode" : "GB000051"
  },
  {
    "name" : "Harwich",
    "unCode" : "GB000052"
  },
  {
    "name" : "Cairnryan",
    "unCode" : "GB000053"
  },
  {
    "name" : "Glasgow Airport",
    "unCode" : "GB000054"
  },
  {
    "name" : "Aberdeen + Highlands & Island Ports",
    "unCode" : "GB000055"
  },
  {
    "name" : "Edinburgh Airport",
    "unCode" : "GB000058"
  },
  {
    "name" : "Grangemouth",
    "unCode" : "GB000059"
  },
  {
    "name" : "Dover/Folkestone Eurotunnel Freight",
    "unCode" : "GB000060"
  },
  {
    "name" : "Hull",
    "unCode" : "GB000072"
  },
  {
    "name" : "Immingham",
    "unCode" : "GB000074"
  },
  {
    "name" : "Liverpool",
    "unCode" : "GB000080"
  },
  {
    "name" : "UK North Auth Consignor/nees",
    "unCode" : "GB000081"
  },
  {
    "name" : "London Heathrow Cargo",
    "unCode" : "GB000084"
  },
  {
    "name" : "London Gatwick Airport Cargo Dist.",
    "unCode" : "GB000085"
  },
  {
    "name" : "Leeds Bradford",
    "unCode" : "GB000087"
  },
  {
    "name" : "Tilbury",
    "unCode" : "GB000093"
  },
  {
    "name" : "Luton Airport FCT",
    "unCode" : "GB000102"
  },
  {
    "name" : "London Heathrow Airport (Baggage)",
    "unCode" : "GB000120"
  },
  {
    "name" : "Stansted Airport FCT",
    "unCode" : "GB000121"
  },
  {
    "name" : "Cardiff Airport (including Barry)",
    "unCode" : "GB000122"
  },
  {
    "name" : "HOLYHEAD",
    "unCode" : "GB000124"
  },
  {
    "name" : "PEMBROKE DOCK",
    "unCode" : "GB000126"
  },
  {
    "name" : "Purfleet Thames Terminal",
    "unCode" : "GB000149"
  },
  {
    "name" : "Thamesport",
    "unCode" : "GB000150"
  },
  {
    "name" : "London Gateway Port",
    "unCode" : "GB000170"
  },
  {
    "name" : "Manchester",
    "unCode" : "GB000191"
  },
  {
    "name" : "Border Force, Port of Tyne",
    "unCode" : "GB000218"
  },
  {
    "name" : "Teesport",
    "unCode" : "GB000219"
  },
  {
    "name" : "UKBA East Midlands Airport",
    "unCode" : "GB000245"
  },
  {
    "name" : "UK South Auth Consignor/nees",
    "unCode" : "GB000246"
  },
  {
    "name" : "Southampton",
    "unCode" : "GB000290"
  },
  {
    "name" : "Poole Ferry Terminal",
    "unCode" : "GB000291"
  },
  {
    "name" : "Portsmouth",
    "unCode" : "GB000292"
  },
  {
    "name" : "Isle of Man Customs & Excise",
    "unCode" : "GB000450"
  },
  {
    "name" : "Guernsey Customs & Excise",
    "unCode" : "GB000461"
  },
  {
    "name" : "Jersey Customs & Immigration",
    "unCode" : "GB000465"
  },
  {
    "name" : "Plymouth Docks",
    "unCode" : "GB003050"
  },
  {
    "name" : "Newhaven",
    "unCode" : "GB003250"
  },
  {
    "name" : "Killingholme - Appointment only",
    "unCode" : "GB005170"
  },
  {
    "name" : "Fishguard",
    "unCode" : "GB005200"
  },
  {
    "name" : "Heysham",
    "unCode" : "GB005210"
  },
  {
    "name" : "BCP 'Tbilisi Airport'",
    "unCode" : "GEBCP001"
  },
  {
    "name" : "BCP 'Tsiteli Khidi'",
    "unCode" : "GEBCP002"
  },
  {
    "name" : "BCP “Sadakhlo – Motorway”",
    "unCode" : "GEBCP003"
  },
  {
    "name" : "BCP “Sadakhlo – Railway”",
    "unCode" : "GEBCP004"
  },
  {
    "name" : "BCP “Guguti”",
    "unCode" : "GEBCP005"
  },
  {
    "name" : "BCP “Gardabani”",
    "unCode" : "GEBCP009"
  },
  {
    "name" : "BCP “Lagodekhi”",
    "unCode" : "GEBCP010"
  },
  {
    "name" : "BCP “Kazbegi”",
    "unCode" : "GEBCP101"
  },
  {
    "name" : "BCP “Vale”",
    "unCode" : "GEBCP301"
  },
  {
    "name" : "BCP “Ninotsminda”",
    "unCode" : "GEBCP302"
  },
  {
    "name" : "BCP“Kartsakhi–Akhalkalaki Railway”",
    "unCode" : "GEBCP309"
  },
  {
    "name" : "BCP “Kartsakhi”",
    "unCode" : "GEBCP320"
  },
  {
    "name" : "BCP “Kutaisi and Senaki Airports",
    "unCode" : "GEBCP401"
  },
  {
    "name" : "BCP “Poti Sea Port'",
    "unCode" : "GEBCP501"
  },
  {
    "name" : "BCP “Kulevi Sea Port'",
    "unCode" : "GEBCP502"
  },
  {
    "name" : "BCP new sea port of Poti",
    "unCode" : "GEBCP504"
  },
  {
    "name" : "BCP “Sarpi”",
    "unCode" : "GEBCP601"
  },
  {
    "name" : "BCP ”Batumi Airport”",
    "unCode" : "GEBCP603"
  },
  {
    "name" : "BCP “Batumi Sea Port”",
    "unCode" : "GEBCP604"
  },
  {
    "name" : "CCD Rustavi",
    "unCode" : "GECCD014"
  },
  {
    "name" : "CCD Telavi",
    "unCode" : "GECCD017"
  },
  {
    "name" : "CCD Akhaltsikhe",
    "unCode" : "GECCD300"
  },
  {
    "name" : "CCD Kutaisi",
    "unCode" : "GECCD400"
  },
  {
    "name" : "CCZ Tbilisi",
    "unCode" : "GECCZ111"
  },
  {
    "name" : "CCZ Batumi",
    "unCode" : "GECCZ112"
  },
  {
    "name" : "CCZ Poti",
    "unCode" : "GECCZ113"
  },
  {
    "name" : "CCZ Airport",
    "unCode" : "GECCZ114"
  },
  {
    "name" : "CCZ Tbilisi 2",
    "unCode" : "GECCZ115"
  },
  {
    "name" : "CCZ Tbilisi 2",
    "unCode" : "GECCZ116"
  },
  {
    "name" : "CCZ E-GEZ",
    "unCode" : "GECCZ117"
  },
  {
    "name" : "FIZ 'Tbilisi Technology Park '",
    "unCode" : "GEFIZ110"
  },
  {
    "name" : "FIZ KUTAISI",
    "unCode" : "GEFIZ403"
  },
  {
    "name" : "FIZ hualing Kutaisi",
    "unCode" : "GEFIZ404"
  },
  {
    "name" : "FIZ POTI",
    "unCode" : "GEFIZ503"
  },
  {
    "name" : "ATHINON",
    "unCode" : "GR000102"
  },
  {
    "name" : "ASTAKOU",
    "unCode" : "GR000232"
  },
  {
    "name" : "MESOLOGIOU",
    "unCode" : "GR000234"
  },
  {
    "name" : "LAVRIOU",
    "unCode" : "GR000303"
  },
  {
    "name" : "A.I.A. 'ELEFTHERIOS VENIZELOS'",
    "unCode" : "GR000304"
  },
  {
    "name" : "RAFINAS",
    "unCode" : "GR000331"
  },
  {
    "name" : "NAFPLIOU",
    "unCode" : "GR000402"
  },
  {
    "name" : "ARTAS",
    "unCode" : "GR000631"
  },
  {
    "name" : "PATRON",
    "unCode" : "GR000701"
  },
  {
    "name" : "EGIOU",
    "unCode" : "GR000731"
  },
  {
    "name" : "ANTIKYRAS",
    "unCode" : "GR000831"
  },
  {
    "name" : "INOIS",
    "unCode" : "GR000832"
  },
  {
    "name" : "DRAMAS",
    "unCode" : "GR001002"
  },
  {
    "name" : "DYTIKIS ATTIKIS",
    "unCode" : "GR001102"
  },
  {
    "name" : "RODOU",
    "unCode" : "GR001202"
  },
  {
    "name" : "KALYMNOY",
    "unCode" : "GR001232"
  },
  {
    "name" : "KARPATHOU",
    "unCode" : "GR001233"
  },
  {
    "name" : "LEROU",
    "unCode" : "GR001234"
  },
  {
    "name" : "KO",
    "unCode" : "GR001235"
  },
  {
    "name" : "PATMOU",
    "unCode" : "GR001236"
  },
  {
    "name" : "SIMIS",
    "unCode" : "GR001237"
  },
  {
    "name" : "MEGISTIS",
    "unCode" : "GR001272"
  },
  {
    "name" : "ALEXANDROUPOLIS",
    "unCode" : "GR001302"
  },
  {
    "name" : "NEAS ORESTIADAS",
    "unCode" : "GR001331"
  },
  {
    "name" : "KIPON",
    "unCode" : "GR001332"
  },
  {
    "name" : "KASTANEON",
    "unCode" : "GR001336"
  },
  {
    "name" : "CHALKIDAS",
    "unCode" : "GR001402"
  },
  {
    "name" : "OREON",
    "unCode" : "GR001431"
  },
  {
    "name" : "ZAKYNTHOU",
    "unCode" : "GR001631"
  },
  {
    "name" : "KYLLINIS",
    "unCode" : "GR001732"
  },
  {
    "name" : "VERIAS",
    "unCode" : "GR001802"
  },
  {
    "name" : "IRAKLIOU",
    "unCode" : "GR001902"
  },
  {
    "name" : "1ο THESSALONIKIS",
    "unCode" : "GR002001"
  },
  {
    "name" : "2ο THESSALONIKIS",
    "unCode" : "GR002005"
  },
  {
    "name" : "3o THESSALONIKIS",
    "unCode" : "GR002006"
  },
  {
    "name" : "STAVROU",
    "unCode" : "GR002051"
  },
  {
    "name" : "IGOUMENITSAS",
    "unCode" : "GR002102"
  },
  {
    "name" : "MAVROMATIOU",
    "unCode" : "GR002132"
  },
  {
    "name" : "IOANNINON",
    "unCode" : "GR002202"
  },
  {
    "name" : "KAKAVIAS",
    "unCode" : "GR002203"
  },
  {
    "name" : "MERTZANIS",
    "unCode" : "GR002233"
  },
  {
    "name" : "KAVALAS",
    "unCode" : "GR002302"
  },
  {
    "name" : "KASTORIAS",
    "unCode" : "GR002501"
  },
  {
    "name" : "KERKYRAS",
    "unCode" : "GR002602"
  },
  {
    "name" : "ARGOSTOLIOU",
    "unCode" : "GR002731"
  },
  {
    "name" : "EVZONON",
    "unCode" : "GR002802"
  },
  {
    "name" : "DOIRANIS",
    "unCode" : "GR002803"
  },
  {
    "name" : "KILKIS",
    "unCode" : "GR002805"
  },
  {
    "name" : "PTOLEMAIDAS",
    "unCode" : "GR002931"
  },
  {
    "name" : "KORINTHOU",
    "unCode" : "GR003002"
  },
  {
    "name" : "SYROU",
    "unCode" : "GR003102"
  },
  {
    "name" : "MILOY",
    "unCode" : "GR003131"
  },
  {
    "name" : "PAROU",
    "unCode" : "GR003132"
  },
  {
    "name" : "MYKONOY",
    "unCode" : "GR003133"
  },
  {
    "name" : "NAXOU",
    "unCode" : "GR003134"
  },
  {
    "name" : "THIRAS",
    "unCode" : "GR003135"
  },
  {
    "name" : "GYTHIOU",
    "unCode" : "GR003201"
  },
  {
    "name" : "NEAPOLIS VION",
    "unCode" : "GR003232"
  },
  {
    "name" : "LARISAS",
    "unCode" : "GR003302"
  },
  {
    "name" : "AGIOU NIKOLAOU",
    "unCode" : "GR003431"
  },
  {
    "name" : "SHTEIAS",
    "unCode" : "GR003433"
  },
  {
    "name" : "MYTILINIS",
    "unCode" : "GR003502"
  },
  {
    "name" : "MYRINAS",
    "unCode" : "GR003532"
  },
  {
    "name" : "PLOMARIOU",
    "unCode" : "GR003575"
  },
  {
    "name" : "LEFKADAS",
    "unCode" : "GR003631"
  },
  {
    "name" : "VOLOU",
    "unCode" : "GR003702"
  },
  {
    "name" : "SKIATHOU",
    "unCode" : "GR003751"
  },
  {
    "name" : "KALAMATAS",
    "unCode" : "GR003802"
  },
  {
    "name" : "XANTHIS",
    "unCode" : "GR003931"
  },
  {
    "name" : "1ο PEIRAIA",
    "unCode" : "GR004001"
  },
  {
    "name" : "3ο PEIRAIA",
    "unCode" : "GR004005"
  },
  {
    "name" : "2ο PEIRAIA",
    "unCode" : "GR004006"
  },
  {
    "name" : "4ο PEIRAIA",
    "unCode" : "GR004007"
  },
  {
    "name" : "SKYDRAS",
    "unCode" : "GR004101"
  },
  {
    "name" : "KATERINIS",
    "unCode" : "GR004201"
  },
  {
    "name" : "PREVEZAS",
    "unCode" : "GR004302"
  },
  {
    "name" : "RETHYMNΟΥ",
    "unCode" : "GR004431"
  },
  {
    "name" : "KOMOTINIS",
    "unCode" : "GR004531"
  },
  {
    "name" : "SAMOU",
    "unCode" : "GR004631"
  },
  {
    "name" : "AGIOU KIRIKOU",
    "unCode" : "GR004671"
  },
  {
    "name" : "SERRON",
    "unCode" : "GR004701"
  },
  {
    "name" : "TRIKALA",
    "unCode" : "GR004831"
  },
  {
    "name" : "STYLIDAS",
    "unCode" : "GR004902"
  },
  {
    "name" : "KRYSTALOPIGIS",
    "unCode" : "GR005001"
  },
  {
    "name" : "FLORINAS",
    "unCode" : "GR005031"
  },
  {
    "name" : "NIKIS",
    "unCode" : "GR005032"
  },
  {
    "name" : "ITEAS",
    "unCode" : "GR005131"
  },
  {
    "name" : "DAFNI",
    "unCode" : "GR005201"
  },
  {
    "name" : "IERISSOU",
    "unCode" : "GR005233"
  },
  {
    "name" : "NEON MOUDANION",
    "unCode" : "GR005234"
  },
  {
    "name" : "HANION",
    "unCode" : "GR005302"
  },
  {
    "name" : "CHIOS",
    "unCode" : "GR005401"
  },
  {
    "name" : "SLUŽBA ZA RGP JANKOMIR I SL.ZONA",
    "unCode" : "HR030171"
  },
  {
    "name" : "SLUŽBA ZA RGP ŽITNJAK",
    "unCode" : "HR030228"
  },
  {
    "name" : "RGP ZRAČNA LUKA ZAGREB",
    "unCode" : "HR030236"
  },
  {
    "name" : "RGP POŠTA",
    "unCode" : "HR030244"
  },
  {
    "name" : "SLUŽBA ZA RGP KRAPINA I SL.ZONA",
    "unCode" : "HR030287"
  },
  {
    "name" : "SLUŽBA ZA RGP VARAŽDIN I SL.ZONA",
    "unCode" : "HR030325"
  },
  {
    "name" : "SLUŽBA ZA RGP ČAKOVEC",
    "unCode" : "HR030333"
  },
  {
    "name" : "SLUŽBA ZA RGP KOPRIVNICA",
    "unCode" : "HR030376"
  },
  {
    "name" : "SLUŽBA ZA RGP BJELOVAR",
    "unCode" : "HR030384"
  },
  {
    "name" : "SLUŽBA ZA RGP SISAK",
    "unCode" : "HR030422"
  },
  {
    "name" : "KONTROLNO MJESTO KUTINA",
    "unCode" : "HR030430"
  },
  {
    "name" : "KONTROLNO MJESTO CRNAC",
    "unCode" : "HR030449"
  },
  {
    "name" : "SLUŽBA ZA RGP KARLOVAC",
    "unCode" : "HR030481"
  },
  {
    "name" : "RGP JASENOVAC",
    "unCode" : "HR030503"
  },
  {
    "name" : "KONTROLNO MJESTO VOLINJA",
    "unCode" : "HR030538"
  },
  {
    "name" : "SLUŽBA ZA RGP ZAPADNI KOLODVOR",
    "unCode" : "HR030562"
  },
  {
    "name" : "RGP DVOR",
    "unCode" : "HR030600"
  },
  {
    "name" : "KONTROLNO MJESTO MACELJ",
    "unCode" : "HR030660"
  },
  {
    "name" : "KM I (RHEA-UPS)",
    "unCode" : "HR030724"
  },
  {
    "name" : "KM II (IN TIME-FEDEX I TNT)",
    "unCode" : "HR030732"
  },
  {
    "name" : "KM III (DHL)",
    "unCode" : "HR030740"
  },
  {
    "name" : "KM IV (LAGERMAX - DPD)",
    "unCode" : "HR030759"
  },
  {
    "name" : "KONTROLNO MJESTO KOTORIBA",
    "unCode" : "HR030767"
  },
  {
    "name" : "SLUŽBA ZA RGP LUKA RIJEKA",
    "unCode" : "HR060178"
  },
  {
    "name" : "KONTROLNO MJESTO ZRAČNA LUKA RIJEKA",
    "unCode" : "HR060186"
  },
  {
    "name" : "KONTROLNO MJESTO OMIŠALJ",
    "unCode" : "HR060208"
  },
  {
    "name" : "KONTROLNO MJESTO MALI LOŠINJ",
    "unCode" : "HR060216"
  },
  {
    "name" : "SLUŽBA ZA RGP ŠKRLJEVO",
    "unCode" : "HR060224"
  },
  {
    "name" : "SLUŽBA ZA RGP LUKA PULA - POLA",
    "unCode" : "HR060267"
  },
  {
    "name" : "KONTROLNO MJESTO LABIN",
    "unCode" : "HR060275"
  },
  {
    "name" : "KONTOLNO MJESTO ZRAČNA LUKA PULA",
    "unCode" : "HR060283"
  },
  {
    "name" : "KONTROLNO MJESTO BUJE",
    "unCode" : "HR060291"
  },
  {
    "name" : "KONTROLNO MJESTO BRŠICA",
    "unCode" : "HR060305"
  },
  {
    "name" : "KONTROLNO MJESTO UMAG",
    "unCode" : "HR060313"
  },
  {
    "name" : "SLUŽBA ZA RGP PAZIN",
    "unCode" : "HR060356"
  },
  {
    "name" : "SLUŽBA ZA RGP GOSPIĆ",
    "unCode" : "HR060399"
  },
  {
    "name" : "RGP LIČKO PETROVO SELO",
    "unCode" : "HR060410"
  },
  {
    "name" : "RGP MALJEVAC",
    "unCode" : "HR060461"
  },
  {
    "name" : "SLUŽBA ZA RGP OSIJEK I SL. ZONA",
    "unCode" : "HR070173"
  },
  {
    "name" : "KONTROLNO MJESTO ZRAČNA LUKA OSIJEK",
    "unCode" : "HR070181"
  },
  {
    "name" : "SLUŽBA ZA RGP VINKOVCI",
    "unCode" : "HR070203"
  },
  {
    "name" : "SLUŽBA ZA RGP SL. BROD I SL. ZONA",
    "unCode" : "HR070246"
  },
  {
    "name" : "SLUŽBA ZA RGP POŽEGA",
    "unCode" : "HR070254"
  },
  {
    "name" : "SLUŽBA ZA RGP VIROVITICA",
    "unCode" : "HR070297"
  },
  {
    "name" : "RGP BAJAKOVO",
    "unCode" : "HR070319"
  },
  {
    "name" : "RGP TOVARNIK",
    "unCode" : "HR070327"
  },
  {
    "name" : "SLUŽBA ZA RGP VUKOVAR I SL ZONA",
    "unCode" : "HR070343"
  },
  {
    "name" : "RGP BATINA",
    "unCode" : "HR070378"
  },
  {
    "name" : "RGP ILOK",
    "unCode" : "HR070386"
  },
  {
    "name" : "KONTROLNO MJESTO PRINCIPOVAC I",
    "unCode" : "HR070394"
  },
  {
    "name" : "KONTROLNO MJESTO PRINCIPOVAC II",
    "unCode" : "HR070408"
  },
  {
    "name" : "KONTROLNO MJESTO ILOK I",
    "unCode" : "HR070416"
  },
  {
    "name" : "RGP ŽUPANJA MOST",
    "unCode" : "HR070440"
  },
  {
    "name" : "RGP GUNJA",
    "unCode" : "HR070467"
  },
  {
    "name" : "KONTROLNO MJESTO Ž. KOL. DRENOVCI",
    "unCode" : "HR070483"
  },
  {
    "name" : "RGP SL. ŠAMAC I ŽELJ.KOL. SL. ŠAMAC",
    "unCode" : "HR070491"
  },
  {
    "name" : "RGP STARA GRADIŠKA",
    "unCode" : "HR070521"
  },
  {
    "name" : "RGP SLAVONSKI BROD I LUKA SL.BROD",
    "unCode" : "HR070548"
  },
  {
    "name" : "RGP SVILAJ",
    "unCode" : "HR070556"
  },
  {
    "name" : "KONTROLNO MJESTO LUKA DRAVA",
    "unCode" : "HR070572"
  },
  {
    "name" : "RGP ERDUT I Ž.KOLODVOR",
    "unCode" : "HR070599"
  },
  {
    "name" : "RGP GORNJI VAROŠ",
    "unCode" : "HR070637"
  },
  {
    "name" : "SLUŽBA ZA RGP ŽUPANJA",
    "unCode" : "HR070661"
  },
  {
    "name" : "KM TOVARNIK ŽELJEZNIČKI KOLODVOR",
    "unCode" : "HR070726"
  },
  {
    "name" : "SLUŽBA ZA RGP SPLIT",
    "unCode" : "HR080179"
  },
  {
    "name" : "SLUŽBA ZA RGP ZRAČNA LUKA SPLIT",
    "unCode" : "HR080209"
  },
  {
    "name" : "SLUŽBA ZA RGP ZADAR",
    "unCode" : "HR080314"
  },
  {
    "name" : "KONTROLNO MJESTO ZRAČNA LUKA ZADAR",
    "unCode" : "HR080322"
  },
  {
    "name" : "SLUŽBA ZA RGP LUKA PLOČE",
    "unCode" : "HR080381"
  },
  {
    "name" : "KONTROLNO MJESTO LUKA DUBROVNIK",
    "unCode" : "HR080438"
  },
  {
    "name" : "SLUŽBA ZA RGP KORČULA",
    "unCode" : "HR080446"
  },
  {
    "name" : "KONTROLNO MJESTO VELA LUKA",
    "unCode" : "HR080454"
  },
  {
    "name" : "KONT. MJESTO ZRAČNA LUKA DUBROVNIK",
    "unCode" : "HR080470"
  },
  {
    "name" : "RGP KAMENSKO",
    "unCode" : "HR080500"
  },
  {
    "name" : "RGP STRMICA",
    "unCode" : "HR080551"
  },
  {
    "name" : "RGP VINJANI DONJI",
    "unCode" : "HR080594"
  },
  {
    "name" : "RGP VINJANI GORNJI",
    "unCode" : "HR080632"
  },
  {
    "name" : "RGP METKOVIĆ - NOVA SELA",
    "unCode" : "HR080659"
  },
  {
    "name" : "RGP Ž. KOLODVOR I LUKA METKOVIĆ",
    "unCode" : "HR080683"
  },
  {
    "name" : "RGP KLEK",
    "unCode" : "HR080756"
  },
  {
    "name" : "RGP KARASOVIĆI",
    "unCode" : "HR080780"
  },
  {
    "name" : "RGP ZATON DOLI",
    "unCode" : "HR080810"
  },
  {
    "name" : "SLUŽBA ZA RGP ŠIBENIK",
    "unCode" : "HR080896"
  },
  {
    "name" : "SLUŽBA ZA RGP DUBROVNIK",
    "unCode" : "HR080918"
  },
  {
    "name" : "NAV Informatikai Intézet",
    "unCode" : "HU015000"
  },
  {
    "name" : "NAV Dél-Budapesti AVI",
    "unCode" : "HU101000"
  },
  {
    "name" : "NAV Dél-budapesti AVI Metrans Sz.h.",
    "unCode" : "HU101150"
  },
  {
    "name" : "NAV Dél-budapesti AVI Bilk Log. SZH",
    "unCode" : "HU101220"
  },
  {
    "name" : "NAV Dél-budapesti AVI BSZL Zrt. SZH",
    "unCode" : "HU101280"
  },
  {
    "name" : "NAV KAVIG",
    "unCode" : "HU102000"
  },
  {
    "name" : "NAV PVM AVI Masped Rt. SzH",
    "unCode" : "HU106200"
  },
  {
    "name" : "NAV Repülőtéri Igazgatósága",
    "unCode" : "HU121000"
  },
  {
    "name" : "NAV Kelet-Budapesti AVI",
    "unCode" : "HU160000"
  },
  {
    "name" : "NAV Észak-Budapesti AVI",
    "unCode" : "HU170000"
  },
  {
    "name" : "NAV Baranya Vármegyei AVI",
    "unCode" : "HU211000"
  },
  {
    "name" : "NAV BAVM AVI Mohácsi Hk.",
    "unCode" : "HU213000"
  },
  {
    "name" : "NAV Somogy Vármegyei AVI",
    "unCode" : "HU221000"
  },
  {
    "name" : "NAV Tolna Vármegyei AVI",
    "unCode" : "HU231000"
  },
  {
    "name" : "NAV BKKVM AVI Royal Sped Zrt. SzH",
    "unCode" : "HU311040"
  },
  {
    "name" : "NAV Bács-Kiskun Vármegyei AVI",
    "unCode" : "HU311500"
  },
  {
    "name" : "NAV BKKVM AVI Hercegszántói Hk.",
    "unCode" : "HU315000"
  },
  {
    "name" : "NAV BKKVM AVI Kelebia SzH",
    "unCode" : "HU316000"
  },
  {
    "name" : "NAV BKKVM AVI Tompai Hk.",
    "unCode" : "HU317000"
  },
  {
    "name" : "NAV JászNagykunSzolnok Vármegyei AV",
    "unCode" : "HU321000"
  },
  {
    "name" : "NAV JNSZVM AVI MB2001 Kft. SzH",
    "unCode" : "HU321010"
  },
  {
    "name" : "NAV BKKVM AVI Bajai SzH. I.",
    "unCode" : "HU331000"
  },
  {
    "name" : "NAV BKKVM AVI ÁTI DEPO Zrt. SzH.",
    "unCode" : "HU331010"
  },
  {
    "name" : "NAV BKKVM AVI Kiskőrösi SzH.",
    "unCode" : "HU332000"
  },
  {
    "name" : "NAV BorsodAbaújZemplénVármegyei AVI",
    "unCode" : "HU411000"
  },
  {
    "name" : "NAV BAZVM AVI ÁTI Depó SzH.",
    "unCode" : "HU411020"
  },
  {
    "name" : "NAV Heves Vármegyei AVI",
    "unCode" : "HU421000"
  },
  {
    "name" : "NAV Csongrád-Csanád Vármegyei AVI",
    "unCode" : "HU511000"
  },
  {
    "name" : "NAV CSCSVM AVI Zoll-Platz Kft. SzH",
    "unCode" : "HU511010"
  },
  {
    "name" : "NAV CSCSVM AVI Röszke Hk",
    "unCode" : "HU515000"
  },
  {
    "name" : "NAV CSCSVM AVI Röszke Hk Vasúti SzH",
    "unCode" : "HU515030"
  },
  {
    "name" : "NAV CSCSVM AVI Tiszaszigeti SzH",
    "unCode" : "HU517000"
  },
  {
    "name" : "NAV Békés Vármegyei AVI",
    "unCode" : "HU521000"
  },
  {
    "name" : "NAV BÉVM AVI Pintér Vám SzH",
    "unCode" : "HU521050"
  },
  {
    "name" : "NAV Győr-Moson-Sopron Vármegyei AVI",
    "unCode" : "HU611000"
  },
  {
    "name" : "NAVGYMSAVI QuehenbergerLogisticsKft",
    "unCode" : "HU611040"
  },
  {
    "name" : "NAV GYMSVM AVI Soproni SzH",
    "unCode" : "HU618000"
  },
  {
    "name" : "NAV GYMSVM AVI Gysev Cargo SzH",
    "unCode" : "HU618010"
  },
  {
    "name" : "NAV Komárom-Esztergom Vármegyei AVI",
    "unCode" : "HU621000"
  },
  {
    "name" : "NAV KEVM AVI ZEBRA NEO2014 SzH",
    "unCode" : "HU621030"
  },
  {
    "name" : "NAV KEVM AVI Esztergomi SzH",
    "unCode" : "HU624000"
  },
  {
    "name" : "NAV KEVM AVI Weskamp Bt. SzH",
    "unCode" : "HU624100"
  },
  {
    "name" : "NAV Veszprém Vármegyei AVI",
    "unCode" : "HU631000"
  },
  {
    "name" : "NAV VEVM AVI Pápai SzH",
    "unCode" : "HU634000"
  },
  {
    "name" : "NAV VEVM AVI Pápa Repülőtér",
    "unCode" : "HU634100"
  },
  {
    "name" : "NAV Hajdú-Bihar Vármegyei AVI",
    "unCode" : "HU711000"
  },
  {
    "name" : "NAV Hajdú-Bihar Vármegyei AVI e-Ker",
    "unCode" : "HU711030"
  },
  {
    "name" : "NAV Hajdú-Bihar Vm-i AVI Repülőtér",
    "unCode" : "HU711070"
  },
  {
    "name" : "NAV Szabolcs-Szatmár-Bereg VM AVI",
    "unCode" : "HU721000"
  },
  {
    "name" : "NAV SzabolcsSzatmárBereg VMAVI-EWG",
    "unCode" : "HU721070"
  },
  {
    "name" : "NAV SZSZBVM AVI Záhonyi Hk.",
    "unCode" : "HU724000"
  },
  {
    "name" : "NAV SZSZBVM AVI Eperjeskei SzH",
    "unCode" : "HU724010"
  },
  {
    "name" : "NAV SZSZBVM AVI Lónyai SzH",
    "unCode" : "HU726030"
  },
  {
    "name" : "NAV SZSZBVM AVI Beregsurányi Hk.",
    "unCode" : "HU726040"
  },
  {
    "name" : "NAV SZSZBVM AVI Tiszabecsi SzH",
    "unCode" : "HU727000"
  },
  {
    "name" : "NAV SZSZBVM AVI Nagyhódosi SzH.",
    "unCode" : "HU727010"
  },
  {
    "name" : "NAV Pest Vármegyei AVI",
    "unCode" : "HU811000"
  },
  {
    "name" : "NAV PVM AVI Depo-Zoll Kft. SzH",
    "unCode" : "HU811010"
  },
  {
    "name" : "NAV PVM AVI Schenker Kft.SzH",
    "unCode" : "HU811020"
  },
  {
    "name" : "NAV PVM AVI CECZ Kft. Szh.",
    "unCode" : "HU811030"
  },
  {
    "name" : "NAV DBP AVI Trimex Kft. Sz. Hely",
    "unCode" : "HU811190"
  },
  {
    "name" : "NAV Pest Vármegyei AVI e-Ker",
    "unCode" : "HU811500"
  },
  {
    "name" : "NAV Fejér Vármegyei AVI",
    "unCode" : "HU821000"
  },
  {
    "name" : "NAV FEM AVI LOGALBA Kft. SzH",
    "unCode" : "HU821060"
  },
  {
    "name" : "NAV Nógrád Vármegyei AVI",
    "unCode" : "HU831000"
  },
  {
    "name" : "NAV Vas Vármegyei AVI",
    "unCode" : "HU911000"
  },
  {
    "name" : "NAV VAVM AVI VÁMCO SzH",
    "unCode" : "HU911010"
  },
  {
    "name" : "NAV Zala Vármegyei AVI",
    "unCode" : "HU921000"
  },
  {
    "name" : "NAV ZAVM AVI Sármelléki Repülőtér",
    "unCode" : "HU921060"
  },
  {
    "name" : "NAV ZAVM AVI Nagykanizsai SzH",
    "unCode" : "HU922000"
  },
  {
    "name" : "NAV ZAVM AVI Nagykanizsa VSZ Zrt.Sz",
    "unCode" : "HU922050"
  },
  {
    "name" : "ACE/ACR ATHLONE",
    "unCode" : "IEATH200"
  },
  {
    "name" : "ACE/ACR Athy",
    "unCode" : "IEATY200"
  },
  {
    "name" : "Athy",
    "unCode" : "IEATY800"
  },
  {
    "name" : "Burtonport",
    "unCode" : "IEBTP100"
  },
  {
    "name" : "BANTRY, CORK",
    "unCode" : "IEBYT100"
  },
  {
    "name" : "Castletownbere Port",
    "unCode" : "IECBP100"
  },
  {
    "name" : "DROGHEDA PORT",
    "unCode" : "IEDRO100"
  },
  {
    "name" : "DUBLIN PORT",
    "unCode" : "IEDUB100"
  },
  {
    "name" : "ACE/ACR DUBLIN",
    "unCode" : "IEDUB200"
  },
  {
    "name" : "DUBLIN AIRPORT",
    "unCode" : "IEDUB400"
  },
  {
    "name" : "DUBLIN MAIL CENTRE",
    "unCode" : "IEDUB500"
  },
  {
    "name" : "FOYNES",
    "unCode" : "IEFOV100"
  },
  {
    "name" : "ACE/ACR FOYNES",
    "unCode" : "IEFOV200"
  },
  {
    "name" : "Greencastle Port",
    "unCode" : "IEGCP100"
  },
  {
    "name" : "GREENORE PORT, GOVT BLDGS,",
    "unCode" : "IEGRN100"
  },
  {
    "name" : "GALWAY",
    "unCode" : "IEGWY100"
  },
  {
    "name" : "ACE/ACR GALWAY",
    "unCode" : "IEGWY200"
  },
  {
    "name" : "HOWTH PORT",
    "unCode" : "IEHWP100"
  },
  {
    "name" : "KILLYBEGS",
    "unCode" : "IEKBS100"
  },
  {
    "name" : "Limerick Docks,",
    "unCode" : "IELMK100"
  },
  {
    "name" : "ACE/ACR LIMERICK",
    "unCode" : "IELMK200"
  },
  {
    "name" : "CORK AIRPORT",
    "unCode" : "IEORK400"
  },
  {
    "name" : "RINGASKIDDY",
    "unCode" : "IERIN100"
  },
  {
    "name" : "Rathmullen Port",
    "unCode" : "IERMP100"
  },
  {
    "name" : "Rosslare Harbour",
    "unCode" : "IEROS100"
  },
  {
    "name" : "ACE/ACR Rosslare",
    "unCode" : "IEROS200"
  },
  {
    "name" : "Rosamhil Port",
    "unCode" : "IERSP100"
  },
  {
    "name" : "Shannon Airport",
    "unCode" : "IESNN400"
  },
  {
    "name" : "TIVOLI",
    "unCode" : "IETIV100"
  },
  {
    "name" : "ACE/ACR Tvoli Cork",
    "unCode" : "IETIV200"
  },
  {
    "name" : "Waterford Government Buildings",
    "unCode" : "IEWAT100"
  },
  {
    "name" : "Belview, Waterford",
    "unCode" : "IEWAT101"
  },
  {
    "name" : "ACE/ACR Waterford",
    "unCode" : "IEWAT200"
  },
  {
    "name" : "Ireland West East",
    "unCode" : "IEWSE100"
  },
  {
    "name" : "ACE/ACR Ireland West East",
    "unCode" : "IEWSE200"
  },
  {
    "name" : "Reykjavik toll",
    "unCode" : "IS000100"
  },
  {
    "name" : "PUGLIA 2 FOGGIA",
    "unCode" : "IT014100"
  },
  {
    "name" : "MANFREDONIA",
    "unCode" : "IT014101"
  },
  {
    "name" : "PUGLIA 3 BRINDISI",
    "unCode" : "IT015100"
  },
  {
    "name" : "AEREOPORTO BRINDISI",
    "unCode" : "IT015101"
  },
  {
    "name" : "COSTA MORENA",
    "unCode" : "IT015102"
  },
  {
    "name" : "PUGLIA 4 LECCE",
    "unCode" : "IT016100"
  },
  {
    "name" : "GALLIPOLI",
    "unCode" : "IT016101"
  },
  {
    "name" : "OTRANTO",
    "unCode" : "IT016102"
  },
  {
    "name" : "PUGLIA 5 TARANTO",
    "unCode" : "IT017100"
  },
  {
    "name" : "PUGLIA 1 BARI",
    "unCode" : "IT018100"
  },
  {
    "name" : "AEROPORTO BARI",
    "unCode" : "IT018101"
  },
  {
    "name" : "BARLETTA",
    "unCode" : "IT018102"
  },
  {
    "name" : "MONOPOLI",
    "unCode" : "IT018105"
  },
  {
    "name" : "BASILICATA - POTENZA",
    "unCode" : "IT019100"
  },
  {
    "name" : "MATERA",
    "unCode" : "IT019102"
  },
  {
    "name" : "EMILIA 3 PARMA",
    "unCode" : "IT028100"
  },
  {
    "name" : "EMILIA 2 PIACENZA",
    "unCode" : "IT029100"
  },
  {
    "name" : "RESIA",
    "unCode" : "IT034101"
  },
  {
    "name" : "AEROPORTO BOLZANO",
    "unCode" : "IT034102"
  },
  {
    "name" : "MAGAZZINI GENERALI BOLZANO",
    "unCode" : "IT034103"
  },
  {
    "name" : "BRESSANONE",
    "unCode" : "IT034104"
  },
  {
    "name" : "BRUNICO",
    "unCode" : "IT034105"
  },
  {
    "name" : "CAMPO DI TRENS",
    "unCode" : "IT034106"
  },
  {
    "name" : "MERANO",
    "unCode" : "IT034107"
  },
  {
    "name" : "TUBRE",
    "unCode" : "IT034108"
  },
  {
    "name" : "INTERPORTO",
    "unCode" : "IT035101"
  },
  {
    "name" : "SARDEGNA 2 SASSARI",
    "unCode" : "IT043100"
  },
  {
    "name" : "PORTO TORRES",
    "unCode" : "IT043101"
  },
  {
    "name" : "PORTO ALGHERO",
    "unCode" : "IT043102"
  },
  {
    "name" : "LA MADDALENA",
    "unCode" : "IT043103"
  },
  {
    "name" : "PORTO OLBIA",
    "unCode" : "IT043104"
  },
  {
    "name" : "SARDEGNA 1 CAGLIARI",
    "unCode" : "IT044100"
  },
  {
    "name" : "AEROPORTO DI CAGLIARI",
    "unCode" : "IT044101"
  },
  {
    "name" : "ORISTANO",
    "unCode" : "IT044103"
  },
  {
    "name" : "PORTO CANALE",
    "unCode" : "IT044106"
  },
  {
    "name" : "TOSCANA 3 PISA",
    "unCode" : "IT054100"
  },
  {
    "name" : "AEROPORTO PISA",
    "unCode" : "IT054101"
  },
  {
    "name" : "MASSA CARRARA",
    "unCode" : "IT054104"
  },
  {
    "name" : "LUCCA - VIAREGGIO",
    "unCode" : "IT054105"
  },
  {
    "name" : "TOSCANA 2 LIVORNO",
    "unCode" : "IT055100"
  },
  {
    "name" : "GROSSETO",
    "unCode" : "IT055103"
  },
  {
    "name" : "PIOMBINO - PORTOFERRAIO",
    "unCode" : "IT055104"
  },
  {
    "name" : "TOSCANA 4 PRATO",
    "unCode" : "IT056100"
  },
  {
    "name" : "LIGURIA 2 LA SPEZIA",
    "unCode" : "IT068100"
  },
  {
    "name" : "CAMPANIA 2 SALERNO",
    "unCode" : "IT084100"
  },
  {
    "name" : "CALABRIA 2 CATANZARO",
    "unCode" : "IT085100"
  },
  {
    "name" : "AEREOPORTO LAMEZIA TERME",
    "unCode" : "IT085101"
  },
  {
    "name" : "COSENZA",
    "unCode" : "IT085102"
  },
  {
    "name" : "CROTONE",
    "unCode" : "IT085103"
  },
  {
    "name" : "PORTO CORIGLIANO",
    "unCode" : "IT085104"
  },
  {
    "name" : "CAMPANIA 3 CASERTA",
    "unCode" : "IT088100"
  },
  {
    "name" : "SICILIA 6 PORTO EMPEDOCLE",
    "unCode" : "IT096100"
  },
  {
    "name" : "GELA",
    "unCode" : "IT096101"
  },
  {
    "name" : "SCIACCA",
    "unCode" : "IT096102"
  },
  {
    "name" : "LICATA",
    "unCode" : "IT096103"
  },
  {
    "name" : "SICILIA 4 MESSINA",
    "unCode" : "IT098100"
  },
  {
    "name" : "MILAZZO",
    "unCode" : "IT098101"
  },
  {
    "name" : "LIPARI",
    "unCode" : "IT098103"
  },
  {
    "name" : "S. AGATA DI MILITELLO",
    "unCode" : "IT098104"
  },
  {
    "name" : "SICILIA 3 SIRACUSA",
    "unCode" : "IT099100"
  },
  {
    "name" : "PORTO AUGUSTA",
    "unCode" : "IT099101"
  },
  {
    "name" : "POZZALLO",
    "unCode" : "IT099102"
  },
  {
    "name" : "RAGUSA",
    "unCode" : "IT099103"
  },
  {
    "name" : "VALLE D'AOSTA",
    "unCode" : "IT118100"
  },
  {
    "name" : "TRAFORO GRAN S. BERNARDO",
    "unCode" : "IT118101"
  },
  {
    "name" : "PIEMONTE 5 DOMODOSSOLA",
    "unCode" : "IT119100"
  },
  {
    "name" : "PIAGGIO VALMARA",
    "unCode" : "IT119101"
  },
  {
    "name" : "ISELLE TRASQUERA",
    "unCode" : "IT119102"
  },
  {
    "name" : "FRIULI-VENEZIA GIULIA 3 GORIZIA",
    "unCode" : "IT127100"
  },
  {
    "name" : "PORTO MONFALCONE",
    "unCode" : "IT127101"
  },
  {
    "name" : "AER. GIULIANO RONCHI DEI LEGIONARI",
    "unCode" : "IT127102"
  },
  {
    "name" : "VENETO 4 TREVISO",
    "unCode" : "IT134100"
  },
  {
    "name" : "AEROPORTO DI TREVISO",
    "unCode" : "IT134101"
  },
  {
    "name" : "SEDICO",
    "unCode" : "IT134102"
  },
  {
    "name" : "VENETO 3 VICENZA",
    "unCode" : "IT135100"
  },
  {
    "name" : "VENETO 2 VERONA",
    "unCode" : "IT136100"
  },
  {
    "name" : "AEROPORTO DI VERONA",
    "unCode" : "IT136101"
  },
  {
    "name" : "MM. GG DI VERONA",
    "unCode" : "IT136102"
  },
  {
    "name" : "VENETO 1 VENEZIA",
    "unCode" : "IT137100"
  },
  {
    "name" : "AEROPORTO DI VENEZIA",
    "unCode" : "IT137101"
  },
  {
    "name" : "CHIOGGIA",
    "unCode" : "IT137102"
  },
  {
    "name" : "INTERPORTO DI MARGHERA",
    "unCode" : "IT137103"
  },
  {
    "name" : "PORTOGRUARO",
    "unCode" : "IT137104"
  },
  {
    "name" : "STAZIONE MARITTIMA DI VENEZIA",
    "unCode" : "IT137105"
  },
  {
    "name" : "VENETO 5 PADOVA",
    "unCode" : "IT138100"
  },
  {
    "name" : "ROVIGO",
    "unCode" : "IT138101"
  },
  {
    "name" : "CALABRIA 1 GIOIA TAURO",
    "unCode" : "IT172100"
  },
  {
    "name" : "PORTO DI VIBO VALENTIA",
    "unCode" : "IT172101"
  },
  {
    "name" : "CALABRIA 3 REGGIO CALABRIA",
    "unCode" : "IT173100"
  },
  {
    "name" : "AEROPORTO REGGIO CALABRIA",
    "unCode" : "IT173101"
  },
  {
    "name" : "ROCCELLA JONICA",
    "unCode" : "IT173102"
  },
  {
    "name" : "NAPOLI",
    "unCode" : "IT182100"
  },
  {
    "name" : "AEROPORTO DI NAPOLI",
    "unCode" : "IT182101"
  },
  {
    "name" : "INTERPORTO DI NOLA",
    "unCode" : "IT182102"
  },
  {
    "name" : "CAMPANIA 1 NAPOLI",
    "unCode" : "IT183100"
  },
  {
    "name" : "T. ANNUNZIATA - C.MARE DI STABIA",
    "unCode" : "IT183101"
  },
  {
    "name" : "CAMPANIA 4 BENEVENTO",
    "unCode" : "IT184100"
  },
  {
    "name" : "AVELLINO",
    "unCode" : "IT184101"
  },
  {
    "name" : "TOSCANA 1 FIRENZE",
    "unCode" : "IT201100"
  },
  {
    "name" : "AEROPORTO FIRENZE",
    "unCode" : "IT201101"
  },
  {
    "name" : "AREZZO",
    "unCode" : "IT201102"
  },
  {
    "name" : "SIENA",
    "unCode" : "IT201103"
  },
  {
    "name" : "UMBRIA - PERUGIA",
    "unCode" : "IT202100"
  },
  {
    "name" : "TERNI",
    "unCode" : "IT202102"
  },
  {
    "name" : "PORTO GENOVA PASSO NUOVO",
    "unCode" : "IT211101"
  },
  {
    "name" : "PORTO GENOVA PRA",
    "unCode" : "IT211102"
  },
  {
    "name" : "LIGURIA 1 GENOVA",
    "unCode" : "IT212100"
  },
  {
    "name" : "AEROPORTO GENOVA",
    "unCode" : "IT212101"
  },
  {
    "name" : "LIGURIA 3 SAVONA",
    "unCode" : "IT213100"
  },
  {
    "name" : "VADO LIGURE",
    "unCode" : "IT213101"
  },
  {
    "name" : "IMPERIA",
    "unCode" : "IT213102"
  },
  {
    "name" : "SANREMO",
    "unCode" : "IT213103"
  },
  {
    "name" : "ROMAGNA 1 RAVENNA",
    "unCode" : "IT221100"
  },
  {
    "name" : "AEROPORTO DI BOLOGNA",
    "unCode" : "IT223101"
  },
  {
    "name" : "INTERPORTO DI BOLOGNA",
    "unCode" : "IT223102"
  },
  {
    "name" : "FERRARA",
    "unCode" : "IT223103"
  },
  {
    "name" : "EMILIA 4 MODENA",
    "unCode" : "IT224100"
  },
  {
    "name" : "REGGIO EMILIA",
    "unCode" : "IT224101"
  },
  {
    "name" : "ROMAGNA 2 RIMINI",
    "unCode" : "IT225100"
  },
  {
    "name" : "FORLI'-CESENA",
    "unCode" : "IT225101"
  },
  {
    "name" : "PIEMONTE 2 ALESSANDRIA",
    "unCode" : "IT231100"
  },
  {
    "name" : "ASTI",
    "unCode" : "IT231101"
  },
  {
    "name" : "RIVALTA SCRIVIA",
    "unCode" : "IT231102"
  },
  {
    "name" : "POZZOLO FORMIGARO",
    "unCode" : "IT231103"
  },
  {
    "name" : "PIEMONTE 3 NOVARA",
    "unCode" : "IT232100"
  },
  {
    "name" : "VERCELLI",
    "unCode" : "IT232101"
  },
  {
    "name" : "MAGAZZINI GENERALI DEI TRAFORI",
    "unCode" : "IT232102"
  },
  {
    "name" : "BIELLA",
    "unCode" : "IT232103"
  },
  {
    "name" : "LOMBARDIA 9 TIRANO",
    "unCode" : "IT272100"
  },
  {
    "name" : "PASSO DEL FOSCAGNO",
    "unCode" : "IT272101"
  },
  {
    "name" : "VILLA DI CHIAVENNA",
    "unCode" : "IT272103"
  },
  {
    "name" : "LOMBARDIA 4 VARESE",
    "unCode" : "IT273100"
  },
  {
    "name" : "BUSTO ARSIZIO",
    "unCode" : "IT273101"
  },
  {
    "name" : "GAGGIOLO",
    "unCode" : "IT273102"
  },
  {
    "name" : "LUINO",
    "unCode" : "IT273104"
  },
  {
    "name" : "PONTE TRESA",
    "unCode" : "IT273105"
  },
  {
    "name" : "LOMBARDIA 8 COMO",
    "unCode" : "IT275100"
  },
  {
    "name" : "LECCO",
    "unCode" : "IT275102"
  },
  {
    "name" : "MONTANO LUCINO",
    "unCode" : "IT275103"
  },
  {
    "name" : "ORIA VALSOLDA",
    "unCode" : "IT275104"
  },
  {
    "name" : "PONTE CHIASSO",
    "unCode" : "IT275105"
  },
  {
    "name" : "CAMPIONE D'ITALIA",
    "unCode" : "IT275106"
  },
  {
    "name" : "LOMBARDIA 6 BERGAMO",
    "unCode" : "IT276100"
  },
  {
    "name" : "AEROPORTO BERGAMO",
    "unCode" : "IT276101"
  },
  {
    "name" : "MILANO",
    "unCode" : "IT277100"
  },
  {
    "name" : "O.N.T. MAGAZZINI GENERALI",
    "unCode" : "IT277102"
  },
  {
    "name" : "LOMBARDIA 3 MALPENSA",
    "unCode" : "IT279100"
  },
  {
    "name" : "SICILIA 2 CATANIA",
    "unCode" : "IT291100"
  },
  {
    "name" : "AEROPORTO CATANIA",
    "unCode" : "IT291101"
  },
  {
    "name" : "RIPOSTO",
    "unCode" : "IT291102"
  },
  {
    "name" : "SICILIA 1 PALERMO",
    "unCode" : "IT292100"
  },
  {
    "name" : "AEROPORTO PALERMO",
    "unCode" : "IT292101"
  },
  {
    "name" : "PORTO TERMINI IMERESE",
    "unCode" : "IT292102"
  },
  {
    "name" : "SICILIA 5 TRAPANI",
    "unCode" : "IT294100"
  },
  {
    "name" : "MARSALA",
    "unCode" : "IT294101"
  },
  {
    "name" : "MAZARA DEL VALLO",
    "unCode" : "IT294102"
  },
  {
    "name" : "PANTELLERIA",
    "unCode" : "IT294103"
  },
  {
    "name" : "LAMPEDUSA",
    "unCode" : "IT295100"
  },
  {
    "name" : "MOLISE - CAMPOBASSO",
    "unCode" : "IT303100"
  },
  {
    "name" : "TERMOLI",
    "unCode" : "IT303101"
  },
  {
    "name" : "MARCHE 1 ANCONA",
    "unCode" : "IT305100"
  },
  {
    "name" : "AEROPORTO DI ANCONA",
    "unCode" : "IT305101"
  },
  {
    "name" : "FABRIANO",
    "unCode" : "IT305103"
  },
  {
    "name" : "PESARO-FANO",
    "unCode" : "IT305106"
  },
  {
    "name" : "MARCHE 2 CIVITANOVA MARCHE",
    "unCode" : "IT308100"
  },
  {
    "name" : "SAN BENEDETTO DEL TRONTO",
    "unCode" : "IT308101"
  },
  {
    "name" : "PIEMONTE 4 CUNEO",
    "unCode" : "IT311100"
  },
  {
    "name" : "ALBA",
    "unCode" : "IT311101"
  },
  {
    "name" : "PIEMONTE 1 TORINO",
    "unCode" : "IT314100"
  },
  {
    "name" : "AEROPORTO TORINO",
    "unCode" : "IT314101"
  },
  {
    "name" : "INTERPORTO ORBASSANO",
    "unCode" : "IT314102"
  },
  {
    "name" : "PORTO INDUSTRIALE DI TRIESTE",
    "unCode" : "IT322101"
  },
  {
    "name" : "PORTO FRANCO NUOVO DI TRIESTE",
    "unCode" : "IT322102"
  },
  {
    "name" : "PORTO FRANCO VECCHIO DI TRIESTE",
    "unCode" : "IT322103"
  },
  {
    "name" : "INTERPORTO DI FERNETTI",
    "unCode" : "IT322104"
  },
  {
    "name" : "PROSECCO",
    "unCode" : "IT322105"
  },
  {
    "name" : "PONTEBBA",
    "unCode" : "IT323101"
  },
  {
    "name" : "PORTO NOGARO",
    "unCode" : "IT323102"
  },
  {
    "name" : "Z.A.U.",
    "unCode" : "IT323103"
  },
  {
    "name" : "PORDENONE",
    "unCode" : "IT323104"
  },
  {
    "name" : "LOMBARDIA 2 LINATE",
    "unCode" : "IT371100"
  },
  {
    "name" : "MELZO",
    "unCode" : "IT371101"
  },
  {
    "name" : "LOMBARDIA 1 MILANO",
    "unCode" : "IT372100"
  },
  {
    "name" : "CONCOREZZO",
    "unCode" : "IT372101"
  },
  {
    "name" : "FIERA RHO",
    "unCode" : "IT372102"
  },
  {
    "name" : "Vittuone-Turbigo",
    "unCode" : "IT372103"
  },
  {
    "name" : "PAVIA",
    "unCode" : "IT372104"
  },
  {
    "name" : "SANNAZZARO DE' BURGONDI",
    "unCode" : "IT372105"
  },
  {
    "name" : "VIGEVANO",
    "unCode" : "IT372106"
  },
  {
    "name" : "VOGHERA",
    "unCode" : "IT372107"
  },
  {
    "name" : "LOMBARDIA 5 MANTOVA",
    "unCode" : "IT373100"
  },
  {
    "name" : "CREMONA",
    "unCode" : "IT373101"
  },
  {
    "name" : "LOMBARDIA 7 BRESCIA",
    "unCode" : "IT374100"
  },
  {
    "name" : "AEROPORTO BRESCIA",
    "unCode" : "IT374101"
  },
  {
    "name" : "LAZIO 1 ROMA",
    "unCode" : "IT402100"
  },
  {
    "name" : "AEROPORTO CIAMPINO",
    "unCode" : "IT402101"
  },
  {
    "name" : "POMEZIA - ANZIO",
    "unCode" : "IT402102"
  },
  {
    "name" : "GUIDONIA",
    "unCode" : "IT402103"
  },
  {
    "name" : "LAZIO 2 FIUMICINO",
    "unCode" : "IT403100"
  },
  {
    "name" : "AEROPORTO FIUMICINO",
    "unCode" : "IT403101"
  },
  {
    "name" : "LAZIO 3 CIVITAVECCHIA",
    "unCode" : "IT404100"
  },
  {
    "name" : "VITERBO",
    "unCode" : "IT404101"
  },
  {
    "name" : "RIETI",
    "unCode" : "IT404102"
  },
  {
    "name" : "LAZIO 4 GAETA",
    "unCode" : "IT405100"
  },
  {
    "name" : "APRILIA",
    "unCode" : "IT405101"
  },
  {
    "name" : "LATINA",
    "unCode" : "IT405102"
  },
  {
    "name" : "FROSINONE",
    "unCode" : "IT405103"
  },
  {
    "name" : "ABRUZZO - PESCARA",
    "unCode" : "IT406100"
  },
  {
    "name" : "AEREOPORTO PESCARA",
    "unCode" : "IT406101"
  },
  {
    "name" : "GIULIANOVA",
    "unCode" : "IT406102"
  },
  {
    "name" : "ORTONA",
    "unCode" : "IT406103"
  },
  {
    "name" : "VASTO",
    "unCode" : "IT406104"
  },
  {
    "name" : "L'AQUILA",
    "unCode" : "IT406105"
  },
  {
    "name" : "AVEZZANO",
    "unCode" : "IT406106"
  },
  {
    "name" : "Kauno oro uosto postas",
    "unCode" : "LTKA1000"
  },
  {
    "name" : "Kybartų geležinkelio postas",
    "unCode" : "LTKG3000"
  },
  {
    "name" : "Kybartų kelio postas",
    "unCode" : "LTKK2000"
  },
  {
    "name" : "Ramoniškių kelio postas",
    "unCode" : "LTKK3000"
  },
  {
    "name" : "Krovinių postas Tiekimas",
    "unCode" : "LTKR2000"
  },
  {
    "name" : "MTV KIT",
    "unCode" : "LTKR2004"
  },
  {
    "name" : "MTV Lavisa",
    "unCode" : "LTKR2006"
  },
  {
    "name" : "MTV Lavisos LEZ",
    "unCode" : "LTKR2008"
  },
  {
    "name" : "MTV Jovarai",
    "unCode" : "LTKR2009"
  },
  {
    "name" : "Marijampolės krovinių postas",
    "unCode" : "LTKR5000"
  },
  {
    "name" : "Palangos oro uosto postas",
    "unCode" : "LTLA1000"
  },
  {
    "name" : "MTV Būtingė",
    "unCode" : "LTLA1001"
  },
  {
    "name" : "Pagėgių geležinkelio postas",
    "unCode" : "LTLG3000"
  },
  {
    "name" : "Nidos kelio postas",
    "unCode" : "LTLK1000"
  },
  {
    "name" : "Panemunės kelio postas",
    "unCode" : "LTLK4000"
  },
  {
    "name" : "MTV Gollner Spedition",
    "unCode" : "LTLR1006"
  },
  {
    "name" : "Nidos upių uosto postas",
    "unCode" : "LTLU4000"
  },
  {
    "name" : "Malkų įlankos jūrų uosto postas",
    "unCode" : "LTLU9000"
  },
  {
    "name" : "Molo jūrų uosto postas",
    "unCode" : "LTLUA000"
  },
  {
    "name" : "MTV Burės",
    "unCode" : "LTLUA001"
  },
  {
    "name" : "Pilies jūrų uosto postas",
    "unCode" : "LTLUB000"
  },
  {
    "name" : "Nemuno upių uosto postas",
    "unCode" : "LTLUC000"
  },
  {
    "name" : "Rusnės upių uosto postas",
    "unCode" : "LTLUD000"
  },
  {
    "name" : "Panevėžio 1 kat. krovinių postas",
    "unCode" : "LTPR2000"
  },
  {
    "name" : "Šiaulių oro uosto postas",
    "unCode" : "LTSA1000"
  },
  {
    "name" : "Radviliškio geležinkelio postas",
    "unCode" : "LTSG3000"
  },
  {
    "name" : "MTV Aloyzo Grigaliūno transportas",
    "unCode" : "LTSG3001"
  },
  {
    "name" : "Bugenių geležinkelio postas",
    "unCode" : "LTSG4000"
  },
  {
    "name" : "MTV Plungės kooperatinė prekyba",
    "unCode" : "LTSG4001"
  },
  {
    "name" : "Šiaulių 1 kat. krovinių postas",
    "unCode" : "LTSR1000"
  },
  {
    "name" : "MTV Šiaulių tiekimo bazė",
    "unCode" : "LTSR1001"
  },
  {
    "name" : "Vilniaus oro uosto postas",
    "unCode" : "LTVA1000"
  },
  {
    "name" : "Kenos geležinkelio postas",
    "unCode" : "LTVG1000"
  },
  {
    "name" : "Vaidotų geležinkelio postas",
    "unCode" : "LTVG2000"
  },
  {
    "name" : "Stasylų geležinkelio postas",
    "unCode" : "LTVG3000"
  },
  {
    "name" : "Lavoriškių kelio postas",
    "unCode" : "LTVK1000"
  },
  {
    "name" : "Medininkų kelio postas",
    "unCode" : "LTVK2000"
  },
  {
    "name" : "Šalčininkų kelio postas",
    "unCode" : "LTVK3000"
  },
  {
    "name" : "Raigardo kelio postas",
    "unCode" : "LTVK8000"
  },
  {
    "name" : "Šumsko kelio postas",
    "unCode" : "LTVKB000"
  },
  {
    "name" : "Tverečiaus kelio postas",
    "unCode" : "LTVKB100"
  },
  {
    "name" : "Vilniaus pašto postas",
    "unCode" : "LTVP1000"
  },
  {
    "name" : "Krovinių postas Savanoriai",
    "unCode" : "LTVR1000"
  },
  {
    "name" : "Krovinių postas Kirtimai",
    "unCode" : "LTVR3000"
  },
  {
    "name" : "Krovinių postas Žirmūnai",
    "unCode" : "LTVR4000"
  },
  {
    "name" : "Krovinių postas Paneriai",
    "unCode" : "LTVR5000"
  },
  {
    "name" : "Švendubrės upių uosto postas",
    "unCode" : "LTVU0100"
  },
  {
    "name" : "Road/Rail",
    "unCode" : "LU701000"
  },
  {
    "name" : "Accises",
    "unCode" : "LU704000"
  },
  {
    "name" : "Nord",
    "unCode" : "LU708000"
  },
  {
    "name" : "Airport",
    "unCode" : "LU715000"
  },
  {
    "name" : "ŠĶIROTAVAS MKP",
    "unCode" : "LV000207"
  },
  {
    "name" : "RĪGAS BRĪVOSTAS MKP",
    "unCode" : "LV000210"
  },
  {
    "name" : "LIDOSTAS MKP",
    "unCode" : "LV000240"
  },
  {
    "name" : "VENTSPILS OSTAS MKP",
    "unCode" : "LV000311"
  },
  {
    "name" : "LIEPĀJAS OSTAS MKP",
    "unCode" : "LV000411"
  },
  {
    "name" : "VIENTUĻU MKP",
    "unCode" : "LV000712"
  },
  {
    "name" : "GREBŅEVAS MKP",
    "unCode" : "LV000721"
  },
  {
    "name" : "TEREHOVAS MKP",
    "unCode" : "LV000722"
  },
  {
    "name" : "ZILUPES MKP",
    "unCode" : "LV000723"
  },
  {
    "name" : "KĀRSAVAS MKP",
    "unCode" : "LV000724"
  },
  {
    "name" : "PĀTERNIEKU MKP",
    "unCode" : "LV000731"
  },
  {
    "name" : "RĒZEKNES 2 MKP",
    "unCode" : "LV000742"
  },
  {
    "name" : "SILENES MKP",
    "unCode" : "LV000814"
  },
  {
    "name" : "DAUGAVPILS PREČU STACIJAS MKP",
    "unCode" : "LV000816"
  },
  {
    "name" : "INDRAS MKP",
    "unCode" : "LV000817"
  },
  {
    "name" : "VID MUITAS PĀRVALDE",
    "unCode" : "LV009999"
  },
  {
    "name" : "COSTESTI",
    "unCode" : "MD101000"
  },
  {
    "name" : "LIPCANI",
    "unCode" : "MD102000"
  },
  {
    "name" : "CRIVA 1",
    "unCode" : "MD103000"
  },
  {
    "name" : "BRICENI",
    "unCode" : "MD107000"
  },
  {
    "name" : "OCNITA 1",
    "unCode" : "MD109000"
  },
  {
    "name" : "OCNITA 2",
    "unCode" : "MD110000"
  },
  {
    "name" : "VOLCINET",
    "unCode" : "MD111000"
  },
  {
    "name" : "OTACI",
    "unCode" : "MD112000"
  },
  {
    "name" : "SOROCA",
    "unCode" : "MD115000"
  },
  {
    "name" : "SOROCA",
    "unCode" : "MD115100"
  },
  {
    "name" : "BRICENI",
    "unCode" : "MD116000"
  },
  {
    "name" : "BALTI",
    "unCode" : "MD117000"
  },
  {
    "name" : "CCZ DROCHIA, BALTI",
    "unCode" : "MD117100"
  },
  {
    "name" : "FEZ BALTI",
    "unCode" : "MD119000"
  },
  {
    "name" : "CCZ ALBINETUL VECHI",
    "unCode" : "MD119100"
  },
  {
    "name" : "MARCULESTI AIRPORT",
    "unCode" : "MD120000"
  },
  {
    "name" : "SCULENI",
    "unCode" : "MD201000"
  },
  {
    "name" : "UNGHENI",
    "unCode" : "MD202000"
  },
  {
    "name" : "ZCV UNGHENI",
    "unCode" : "MD202100"
  },
  {
    "name" : "LEUSENI",
    "unCode" : "MD203000"
  },
  {
    "name" : "PALANCA",
    "unCode" : "MD204000"
  },
  {
    "name" : "TUDORA",
    "unCode" : "MD205000"
  },
  {
    "name" : "CHISINAU 1",
    "unCode" : "MD207000"
  },
  {
    "name" : "ZCV CALEA FERATA, CHISINĂU 1",
    "unCode" : "MD207100"
  },
  {
    "name" : "CHISINAU 2",
    "unCode" : "MD208000"
  },
  {
    "name" : "ZCV IALOVENI, CHISINAU 3",
    "unCode" : "MD209100"
  },
  {
    "name" : "ZCV HINCESTI, CHISINAU 3",
    "unCode" : "MD209200"
  },
  {
    "name" : "ZCV HINCESTI 1 (UNGHENI-BUSINESS)",
    "unCode" : "MD209300"
  },
  {
    "name" : "CHISINAU4 POSTA",
    "unCode" : "MD210000"
  },
  {
    "name" : "CHISINAU RAILWAY STATION 4",
    "unCode" : "MD210100"
  },
  {
    "name" : "SUBZONA 'SUD-EST'",
    "unCode" : "MD211000"
  },
  {
    "name" : "CHISINAU Subzona 11 ZEL BALTI",
    "unCode" : "MD211100"
  },
  {
    "name" : "STRASENI (SUBZONA 4,5 ZEL BALTI)",
    "unCode" : "MD212000"
  },
  {
    "name" : "ORHEI (SUBZONA 6 ZEL BALTI)",
    "unCode" : "MD213000"
  },
  {
    "name" : "ORHEI SUBZONA 6 ZEL BALTI",
    "unCode" : "MD213100"
  },
  {
    "name" : "ZEL UNGHENI",
    "unCode" : "MD214000"
  },
  {
    "name" : "Calarasi CCZ, Ungheni FEZ",
    "unCode" : "MD214100"
  },
  {
    "name" : "CAUSENI",
    "unCode" : "MD215000"
  },
  {
    "name" : "BULBOACA",
    "unCode" : "MD217000"
  },
  {
    "name" : "BENDER 2",
    "unCode" : "MD218000"
  },
  {
    "name" : "REZINA",
    "unCode" : "MD219000"
  },
  {
    "name" : "RIBNITA",
    "unCode" : "MD220000"
  },
  {
    "name" : "REZINA POD",
    "unCode" : "MD222000"
  },
  {
    "name" : "CRIULENI (14,18)",
    "unCode" : "MD224000"
  },
  {
    "name" : "CCZ CRIULENI (Criuleni 14,18)",
    "unCode" : "MD224100"
  },
  {
    "name" : "HIRBOVAT",
    "unCode" : "MD227000"
  },
  {
    "name" : "HAGIMUS",
    "unCode" : "MD228000"
  },
  {
    "name" : "CHISINAU INTERNATIONAL AIRPORT",
    "unCode" : "MD230000"
  },
  {
    "name" : "CUCIURGAN",
    "unCode" : "MD232000"
  },
  {
    "name" : "PLATONOVO",
    "unCode" : "MD234000"
  },
  {
    "name" : "STEFAN VODA (FEZ BALTI)",
    "unCode" : "MD235000"
  },
  {
    "name" : "NOVOSAVITCAIA",
    "unCode" : "MD236000"
  },
  {
    "name" : "CAHUL",
    "unCode" : "MD301000"
  },
  {
    "name" : "GIURGIULESTI 1",
    "unCode" : "MD302000"
  },
  {
    "name" : "GIURGIULESTI 2",
    "unCode" : "MD303000"
  },
  {
    "name" : "PIL GIURGIULESTI",
    "unCode" : "MD304000"
  },
  {
    "name" : "CCZ GIURGIULESTI PIL GIURGIULESTI",
    "unCode" : "MD304100"
  },
  {
    "name" : "GIURGIULESTI PORT",
    "unCode" : "MD304200"
  },
  {
    "name" : "PIL GIURGIULESTI TRANZIT",
    "unCode" : "MD304300"
  },
  {
    "name" : "BASARABEASCA",
    "unCode" : "MD305000"
  },
  {
    "name" : "CEADIR-LUNGA 2",
    "unCode" : "MD307000"
  },
  {
    "name" : "MIRNOE",
    "unCode" : "MD308000"
  },
  {
    "name" : "VULCANESTI",
    "unCode" : "MD309000"
  },
  {
    "name" : "ETULIA",
    "unCode" : "MD310000"
  },
  {
    "name" : "CISMICHIOI",
    "unCode" : "MD311000"
  },
  {
    "name" : "CAHUL",
    "unCode" : "MD312000"
  },
  {
    "name" : "COMRAT",
    "unCode" : "MD313000"
  },
  {
    "name" : "CCZ CEADIR-LUNGA, COMRAT",
    "unCode" : "MD313100"
  },
  {
    "name" : "FAZ TARACLIA",
    "unCode" : "MD314000"
  },
  {
    "name" : "FAZ VALCANES",
    "unCode" : "MD315000"
  },
  {
    "name" : "FAZ TVARDITA",
    "unCode" : "MD316000"
  },
  {
    "name" : "CAHUL (SUBZONE No. 7 BALTI FEZ)",
    "unCode" : "MD317000"
  },
  {
    "name" : "Comrat Subzone (Vulcanesti FEZ)",
    "unCode" : "MD318000"
  },
  {
    "name" : "BASARABEASCA 1",
    "unCode" : "MD319000"
  },
  {
    "name" : "CI Terminal Podgorica",
    "unCode" : "ME035025"
  },
  {
    "name" : "CI Željeznička stanica Podgorica",
    "unCode" : "ME035037"
  },
  {
    "name" : "CI Božaj",
    "unCode" : "ME035041"
  },
  {
    "name" : "CI Danilovgrad",
    "unCode" : "ME035050"
  },
  {
    "name" : "CI Nikšić",
    "unCode" : "ME035076"
  },
  {
    "name" : "CI Cetinje",
    "unCode" : "ME035084"
  },
  {
    "name" : "CI Aerodrom Podgorica",
    "unCode" : "ME035092"
  },
  {
    "name" : "CI Pošta Podgorica",
    "unCode" : "ME035106"
  },
  {
    "name" : "CI Željeznička stanica Tuzi",
    "unCode" : "ME035149"
  },
  {
    "name" : "CI Šćepan Polje",
    "unCode" : "ME035173"
  },
  {
    "name" : "CI Vraćenovići",
    "unCode" : "ME035181"
  },
  {
    "name" : "CI Ilino Brdo",
    "unCode" : "ME035203"
  },
  {
    "name" : "CI Bar",
    "unCode" : "ME036021"
  },
  {
    "name" : "CI Slobodna zona Bar",
    "unCode" : "ME036072"
  },
  {
    "name" : "CF Budva",
    "unCode" : "ME036080"
  },
  {
    "name" : "CF Putnički terminal",
    "unCode" : "ME036094"
  },
  {
    "name" : "CI Aerodrom Tivat",
    "unCode" : "ME037010"
  },
  {
    "name" : "CI Bijela",
    "unCode" : "ME037028"
  },
  {
    "name" : "CI Zelenika",
    "unCode" : "ME037044"
  },
  {
    "name" : "CI Terminal Kotor",
    "unCode" : "ME037052"
  },
  {
    "name" : "CI Debeli Brijeg",
    "unCode" : "ME037095"
  },
  {
    "name" : "CI Luka Tivat",
    "unCode" : "ME037207"
  },
  {
    "name" : "CI Luka Kotor",
    "unCode" : "ME037255"
  },
  {
    "name" : "CF Kumbor",
    "unCode" : "ME037303"
  },
  {
    "name" : "CI Bijelo Polje",
    "unCode" : "ME038016"
  },
  {
    "name" : "CI Željeznička stanica B. Polje",
    "unCode" : "ME038059"
  },
  {
    "name" : "CI Dobrakovo",
    "unCode" : "ME038075"
  },
  {
    "name" : "Carinska ispostava Pljevlja",
    "unCode" : "ME038121"
  },
  {
    "name" : "Carinska ispostava Metaljka",
    "unCode" : "ME038156"
  },
  {
    "name" : "Carinska ispostava Ranče",
    "unCode" : "ME038164"
  },
  {
    "name" : "Carinska ispostava Berane",
    "unCode" : "ME038300"
  },
  {
    "name" : "Carinska ispostava Rožaje",
    "unCode" : "ME038334"
  },
  {
    "name" : "Carinska ispostava Kula",
    "unCode" : "ME038350"
  },
  {
    "name" : "Carinska ispostava Dračenovac",
    "unCode" : "ME038385"
  },
  {
    "name" : "Skopje 1",
    "unCode" : "MK001010"
  },
  {
    "name" : "Skopje 3",
    "unCode" : "MK001013"
  },
  {
    "name" : "Skopje 4",
    "unCode" : "MK001014"
  },
  {
    "name" : "Skopje 2",
    "unCode" : "MK001015"
  },
  {
    "name" : "Slobodna zona Bunardzik",
    "unCode" : "MK001020"
  },
  {
    "name" : "Carinska ispostava Posta",
    "unCode" : "MK001025"
  },
  {
    "name" : "CI Aerodrom Skopje stokovo",
    "unCode" : "MK001050"
  },
  {
    "name" : "CI Aerodrom Skopje Patnicki",
    "unCode" : "MK001051"
  },
  {
    "name" : "CI Blace patnicki",
    "unCode" : "MK001071"
  },
  {
    "name" : "CI Blace stokovo",
    "unCode" : "MK001075"
  },
  {
    "name" : "CI Tetovo",
    "unCode" : "MK001080"
  },
  {
    "name" : "CI Jazince",
    "unCode" : "MK001091"
  },
  {
    "name" : "CI Kumanovo",
    "unCode" : "MK002010"
  },
  {
    "name" : "CI Zeleznicka stanicaTabanovci",
    "unCode" : "MK002021"
  },
  {
    "name" : "CI Tabanovce stokovo",
    "unCode" : "MK002030"
  },
  {
    "name" : "CI Tabanovce patnicki",
    "unCode" : "MK002031"
  },
  {
    "name" : "CI Deve Bair stokovo",
    "unCode" : "MK002050"
  },
  {
    "name" : "CI Deve Bair- Patnicki",
    "unCode" : "MK002051"
  },
  {
    "name" : "CI Stip",
    "unCode" : "MK003010"
  },
  {
    "name" : "CI Delcevo stokovo",
    "unCode" : "MK003030"
  },
  {
    "name" : "CI Delcevo patnicki",
    "unCode" : "MK003031"
  },
  {
    "name" : "CI Veles",
    "unCode" : "MK003050"
  },
  {
    "name" : "CI Bogorodica patnicki",
    "unCode" : "MK004010"
  },
  {
    "name" : "CI Bogorodica stokovo",
    "unCode" : "MK004015"
  },
  {
    "name" : "CI Gevgelija",
    "unCode" : "MK004020"
  },
  {
    "name" : "CI Zeleznicka stanica Gevgelija",
    "unCode" : "MK004021"
  },
  {
    "name" : "CI Dojran",
    "unCode" : "MK004031"
  },
  {
    "name" : "CI Kavadarci",
    "unCode" : "MK004040"
  },
  {
    "name" : "CI Ctrumica",
    "unCode" : "MK004050"
  },
  {
    "name" : "CI Novo Selo stokovo",
    "unCode" : "MK004060"
  },
  {
    "name" : "CI Novo Selo patnicki",
    "unCode" : "MK004061"
  },
  {
    "name" : "CI Bitola",
    "unCode" : "MK005010"
  },
  {
    "name" : "CI Medzitlija stokovo",
    "unCode" : "MK005020"
  },
  {
    "name" : "CI Medzitlija patnicki",
    "unCode" : "MK005021"
  },
  {
    "name" : "CI Prilep",
    "unCode" : "MK005030"
  },
  {
    "name" : "CI Ohrid",
    "unCode" : "MK005040"
  },
  {
    "name" : "CI Aerodrom Ohrid",
    "unCode" : "MK005042"
  },
  {
    "name" : "CI Sveti Naum",
    "unCode" : "MK005051"
  },
  {
    "name" : "CI Struga",
    "unCode" : "MK005060"
  },
  {
    "name" : "CI Kafasan stokovo",
    "unCode" : "MK005070"
  },
  {
    "name" : "CI Kafasan patnicki",
    "unCode" : "MK005071"
  },
  {
    "name" : "CI Stenje",
    "unCode" : "MK005081"
  },
  {
    "name" : "CI Blato",
    "unCode" : "MK005091"
  },
  {
    "name" : "Airfreight",
    "unCode" : "MT000102"
  },
  {
    "name" : "Grand Harbour Seaport",
    "unCode" : "MT000103"
  },
  {
    "name" : "MIA Arrivals",
    "unCode" : "MT000104"
  },
  {
    "name" : "Deep Water Quay",
    "unCode" : "MT000107"
  },
  {
    "name" : "Laboratory Wharf",
    "unCode" : "MT000109"
  },
  {
    "name" : "Malta Freeport Main Gate",
    "unCode" : "MT000113"
  },
  {
    "name" : "Parcel Post Office - Malta",
    "unCode" : "MT000114"
  },
  {
    "name" : "Customs Express Freight Office",
    "unCode" : "MT000117"
  },
  {
    "name" : "MIA Departures",
    "unCode" : "MT000123"
  },
  {
    "name" : "Special Procedures Unit",
    "unCode" : "MT000124"
  },
  {
    "name" : "Containers & Groupage Section",
    "unCode" : "MT000600"
  },
  {
    "name" : "Koeriers simplified proc.",
    "unCode" : "NL000144"
  },
  {
    "name" : "Koeriers Normal proc.",
    "unCode" : "NL000155"
  },
  {
    "name" : "Kantoor Groningen (TIR)",
    "unCode" : "NL000184"
  },
  {
    "name" : "JFC HQ Brunssum",
    "unCode" : "NL000187"
  },
  {
    "name" : "Kantoor Venlo",
    "unCode" : "NL000205"
  },
  {
    "name" : "Schiphol Cargo",
    "unCode" : "NL000432"
  },
  {
    "name" : "Reeweg simplified proc.",
    "unCode" : "NL000510"
  },
  {
    "name" : "Reeweg normal proc.",
    "unCode" : "NL000511"
  },
  {
    "name" : "Kantoor De Lutte",
    "unCode" : "NL000851"
  },
  {
    "name" : "Kantoor Rotterdam The Hague Airport",
    "unCode" : "NL000853"
  },
  {
    "name" : "Kantoor Amsterdam",
    "unCode" : "NL000854"
  },
  {
    "name" : "Kantoor Moerdijk",
    "unCode" : "NL000855"
  },
  {
    "name" : "Tromsø GNTR",
    "unCode" : "NO321001"
  },
  {
    "name" : "Helligskogen GNTR",
    "unCode" : "NO321002"
  },
  {
    "name" : "Tromsø Lufthavn, Simpl. Proc.",
    "unCode" : "NO321003"
  },
  {
    "name" : "Hammerfest GNVF",
    "unCode" : "NO322001"
  },
  {
    "name" : "Alta, Simpl. Proc.",
    "unCode" : "NO322002"
  },
  {
    "name" : "Neiden GNNE",
    "unCode" : "NO323001"
  },
  {
    "name" : "Storskog GNST",
    "unCode" : "NO324001"
  },
  {
    "name" : "Kirkenes simpl. procedure GNST",
    "unCode" : "NO324002"
  },
  {
    "name" : "Polmak GNPO",
    "unCode" : "NO325001"
  },
  {
    "name" : "Karigasniemi tulli GDN",
    "unCode" : "NO329901"
  },
  {
    "name" : "Kivilompolo GDN",
    "unCode" : "NO329902"
  },
  {
    "name" : "Utsjok tulli GDN",
    "unCode" : "NO329903"
  },
  {
    "name" : "Bjørnfjell GMBJ",
    "unCode" : "NO331001"
  },
  {
    "name" : "Narvik Simplified proc. GMBJ",
    "unCode" : "NO331002"
  },
  {
    "name" : "Evenes, Simpl. Proc.",
    "unCode" : "NO331003"
  },
  {
    "name" : "Junkerdal GMHS",
    "unCode" : "NO332001"
  },
  {
    "name" : "Bodø GMHS",
    "unCode" : "NO332002"
  },
  {
    "name" : "Mo GMHS",
    "unCode" : "NO332003"
  },
  {
    "name" : "Bodø Lufthavn, Simpl. Proc.",
    "unCode" : "NO332004"
  },
  {
    "name" : "Værnes GDM",
    "unCode" : "NO333001"
  },
  {
    "name" : "Trondheim GDM",
    "unCode" : "NO333002"
  },
  {
    "name" : "Vauldalen GMRØ",
    "unCode" : "NO334001"
  },
  {
    "name" : "Røros Lufthavn, Simpl. Proc.",
    "unCode" : "NO334002"
  },
  {
    "name" : "Storlien tullexpedisjon GMD",
    "unCode" : "NO339901"
  },
  {
    "name" : "Tärnaby tullexpedition GMD",
    "unCode" : "NO339902"
  },
  {
    "name" : "Ålesund GVÅL",
    "unCode" : "NO341001"
  },
  {
    "name" : "Ålesund Lufthavn Vigra, Simpl. Proc",
    "unCode" : "NO341002"
  },
  {
    "name" : "Molde Lufthavn Årø, Simpl. Proc.",
    "unCode" : "NO341003"
  },
  {
    "name" : "Kristiansund Lufthavn, Simpl. Proc.",
    "unCode" : "NO341004"
  },
  {
    "name" : "Bergen GVMI Maritim innsatsseksjon",
    "unCode" : "NO342001"
  },
  {
    "name" : "Bergen Lufthavn Flesland Simp. Proc",
    "unCode" : "NO343001"
  },
  {
    "name" : "Haugesund GVHA",
    "unCode" : "NO344001"
  },
  {
    "name" : "Haugesund Lufthavn, Simpl. Proc.",
    "unCode" : "NO344002"
  },
  {
    "name" : "Tananger GVSO",
    "unCode" : "NO345001"
  },
  {
    "name" : "Stavanger Lufthavn Sola, Simpl Proc",
    "unCode" : "NO345002"
  },
  {
    "name" : "Oslo Gardermoen GDG",
    "unCode" : "NO351001"
  },
  {
    "name" : "Eggemoen flyplass, Simpl. Proc.",
    "unCode" : "NO351003"
  },
  {
    "name" : "Oslo Lufthavn, Post, Simpl. Proc.",
    "unCode" : "NO355001"
  },
  {
    "name" : "Kristiansand GDO",
    "unCode" : "NO361001"
  },
  {
    "name" : "Kristiansand lufthavn Kjevik, Simpl",
    "unCode" : "NO361002"
  },
  {
    "name" : "Grenland GDO",
    "unCode" : "NO362001"
  },
  {
    "name" : "Langesund Simpl. Proc. GDO",
    "unCode" : "NO362002"
  },
  {
    "name" : "Torp Sandefjord Lufthavn, Simpl Pro",
    "unCode" : "NO363001"
  },
  {
    "name" : "Sandefjord GDO",
    "unCode" : "NO364001"
  },
  {
    "name" : "Larvik Simpl. Proc. GDO",
    "unCode" : "NO364002"
  },
  {
    "name" : "Oslo Helsfyr Simpl. proc. GDO",
    "unCode" : "NO365001"
  },
  {
    "name" : "Oslo Utstikker 2 GDO",
    "unCode" : "NO365002"
  },
  {
    "name" : "Oslo-Hjortnes GDO",
    "unCode" : "NO365003"
  },
  {
    "name" : "Oslo ALNABRU Simpl. procedure GDO",
    "unCode" : "NO365004"
  },
  {
    "name" : "Drammen GDO",
    "unCode" : "NO368001"
  },
  {
    "name" : "Svinesund GDØ",
    "unCode" : "NO371001"
  },
  {
    "name" : "Moss Simpl. Proc. GDØ",
    "unCode" : "NO371002"
  },
  {
    "name" : "Ørje GDØ",
    "unCode" : "NO372001"
  },
  {
    "name" : "Kongsvinger GDØ",
    "unCode" : "NO373001"
  },
  {
    "name" : "Åsnes GDØ",
    "unCode" : "NO373002"
  },
  {
    "name" : "Østby GØTR",
    "unCode" : "NO374001"
  },
  {
    "name" : "Svinesund tullexpedition GDØ",
    "unCode" : "NO379901"
  },
  {
    "name" : "Hån tullexpedition GDØ",
    "unCode" : "NO379902"
  },
  {
    "name" : "Eda tullexpedition GDØ",
    "unCode" : "NO379903"
  },
  {
    "name" : "Idre tullexpedition GDØ",
    "unCode" : "NO379904"
  },
  {
    "name" : "BIAŁA PODLASKA OC",
    "unCode" : "PL301010"
  },
  {
    "name" : "MALASZEWICZE OC",
    "unCode" : "PL301020"
  },
  {
    "name" : "KOROSZCZYN OC",
    "unCode" : "PL301040"
  },
  {
    "name" : "TERESPOL OC",
    "unCode" : "PL301050"
  },
  {
    "name" : "TERESPOL OC DROGOWY",
    "unCode" : "PL301060"
  },
  {
    "name" : "SŁAWATYCZE OC",
    "unCode" : "PL301070"
  },
  {
    "name" : "DOROHUSK OC",
    "unCode" : "PL302050"
  },
  {
    "name" : "DOROHUSK OC DROGOWY",
    "unCode" : "PL302060"
  },
  {
    "name" : "OC PORT LOTNICZY LUBLIN-ŚWIDNIK",
    "unCode" : "PL302070"
  },
  {
    "name" : "Lublin OC Pocztowy",
    "unCode" : "PL302080"
  },
  {
    "name" : "HREBENNE OC",
    "unCode" : "PL303020"
  },
  {
    "name" : "HRUBIESZÓW OC",
    "unCode" : "PL303030"
  },
  {
    "name" : "ZOSIN OC",
    "unCode" : "PL303040"
  },
  {
    "name" : "DOŁHOBYCZÓW OC",
    "unCode" : "PL303091"
  },
  {
    "name" : "BIAŁYSTOK OC",
    "unCode" : "PL311010"
  },
  {
    "name" : "KUŹNICA OC KOLEJOWY",
    "unCode" : "PL311020"
  },
  {
    "name" : "KUŹNICA OC DROGOWY",
    "unCode" : "PL311030"
  },
  {
    "name" : "SIEMIANÓWKA OC",
    "unCode" : "PL311050"
  },
  {
    "name" : "POŁOWCE OC",
    "unCode" : "PL311060"
  },
  {
    "name" : "BOBROWNIKI OC",
    "unCode" : "PL311070"
  },
  {
    "name" : "GDYNIA OC BASEN V",
    "unCode" : "PL321010"
  },
  {
    "name" : "GDYNIA OC BAZA KONTENEROWA",
    "unCode" : "PL321030"
  },
  {
    "name" : "GDYNIA OC BASEN IV",
    "unCode" : "PL321050"
  },
  {
    "name" : "GDYNIA OC NABRZEŻE BUŁGARSKIE",
    "unCode" : "PL321070"
  },
  {
    "name" : "GDAŃSK OC OPŁOTKI",
    "unCode" : "PL322010"
  },
  {
    "name" : "OC PORT GDAŃSK",
    "unCode" : "PL322030"
  },
  {
    "name" : "GDAŃSK-RĘBIECHOWO OC PORT LOTNICZY",
    "unCode" : "PL322050"
  },
  {
    "name" : "GDAŃSK OC TERMINAL KONTENEROWY",
    "unCode" : "PL322080"
  },
  {
    "name" : "PRUSZCZ GDAŃSKI OC POCZTOWY",
    "unCode" : "PL322090"
  },
  {
    "name" : "TYCHY OC",
    "unCode" : "PL331020"
  },
  {
    "name" : "OC TOWAROWY PORT LOTNICZY PYRZOWICE",
    "unCode" : "PL331040"
  },
  {
    "name" : "OC OSOBOWY PORT LOTNICZY PYRZOWICE",
    "unCode" : "PL331050"
  },
  {
    "name" : "ZABRZE OC POCZTOWY",
    "unCode" : "PL332040"
  },
  {
    "name" : "CZECHOWICE-DZIEDZICE OC",
    "unCode" : "PL335010"
  },
  {
    "name" : "KIELCE OC",
    "unCode" : "PL341010"
  },
  {
    "name" : "KRAKÓW OC II",
    "unCode" : "PL351020"
  },
  {
    "name" : "KRAKÓW-BALICE OC PORT LOTNICZY",
    "unCode" : "PL351030"
  },
  {
    "name" : "ŁÓDŹ OC I",
    "unCode" : "PL361010"
  },
  {
    "name" : "LUBLINEK - OC PORT LOTNICZY",
    "unCode" : "PL362040"
  },
  {
    "name" : "OLSZTYN OC",
    "unCode" : "PL371010"
  },
  {
    "name" : "KORSZE OC",
    "unCode" : "PL371020"
  },
  {
    "name" : "BEZLEDY OC",
    "unCode" : "PL371030"
  },
  {
    "name" : "GOŁDAP OC",
    "unCode" : "PL371060"
  },
  {
    "name" : "ELBLĄG OC",
    "unCode" : "PL372010"
  },
  {
    "name" : "BRANIEWO OC",
    "unCode" : "PL372020"
  },
  {
    "name" : "GRONOWO OC",
    "unCode" : "PL372030"
  },
  {
    "name" : "GRZECHOTKI OC",
    "unCode" : "PL372050"
  },
  {
    "name" : "OPOLE OC",
    "unCode" : "PL381010"
  },
  {
    "name" : "POZNAŃ OC",
    "unCode" : "PL391010"
  },
  {
    "name" : "POZNAŃ OC MTP",
    "unCode" : "PL391020"
  },
  {
    "name" : "POZNAŃ-ŁAWICA OC PORT LOTNICZY",
    "unCode" : "PL391030"
  },
  {
    "name" : "KALISZ OC",
    "unCode" : "PL394010"
  },
  {
    "name" : "PRZEMYŚL OC",
    "unCode" : "PL401010"
  },
  {
    "name" : "MEDYKA OC",
    "unCode" : "PL401030"
  },
  {
    "name" : "PRZEMYŚL-MEDYKA OC KOLEJOWY",
    "unCode" : "PL401040"
  },
  {
    "name" : "KORCZOWA OC",
    "unCode" : "PL401060"
  },
  {
    "name" : "BUDOMIERZ OC",
    "unCode" : "PL401080"
  },
  {
    "name" : "PRZEMYŚL OC POCZTOWY",
    "unCode" : "PL401090"
  },
  {
    "name" : "RZESZÓW OC",
    "unCode" : "PL402010"
  },
  {
    "name" : "RZESZÓW-JASIONKA OC PORT LOTNICZY",
    "unCode" : "PL402020"
  },
  {
    "name" : "KROŚCIENKO OC",
    "unCode" : "PL404030"
  },
  {
    "name" : "ŚWIECKO OC",
    "unCode" : "PL412020"
  },
  {
    "name" : "SZCZECIN OC",
    "unCode" : "PL421010"
  },
  {
    "name" : "SZCZECIN OC NABRZEŻE ŁASZTOWNIA",
    "unCode" : "PL421030"
  },
  {
    "name" : "SZCZECIN-GOLENIÓW OC PORT LOTNICZY",
    "unCode" : "PL421050"
  },
  {
    "name" : "SWINOUJŚCIE OC",
    "unCode" : "PL421080"
  },
  {
    "name" : "KOŁOBRZEG OC",
    "unCode" : "PL422020"
  },
  {
    "name" : "BYDGOSZCZ OC II",
    "unCode" : "PL431020"
  },
  {
    "name" : "OC Port Lotniczy Bydgoszcz",
    "unCode" : "PL431040"
  },
  {
    "name" : "WARSZAWA OC I POCZTOWY",
    "unCode" : "PL441010"
  },
  {
    "name" : "WARSZAWA OC VI",
    "unCode" : "PL442020"
  },
  {
    "name" : "WARSZAWA OC OSOBOWY",
    "unCode" : "PL443010"
  },
  {
    "name" : "WARSZAWA OC TOWAROWY I",
    "unCode" : "PL443020"
  },
  {
    "name" : "WARSZAWA OC PORT LOTNICZY MODLIN",
    "unCode" : "PL443050"
  },
  {
    "name" : "PRUSZKÓW OC I",
    "unCode" : "PL445010"
  },
  {
    "name" : "WROCŁAW OC I",
    "unCode" : "PL451010"
  },
  {
    "name" : "WROCŁAW-STRACHOWICE OC TOWAROWY",
    "unCode" : "PL451030"
  },
  {
    "name" : "WROCŁAW-STRACHOWICE OC OSOBOWY",
    "unCode" : "PL451040"
  },
  {
    "name" : "Delegação Aduaneira Aeroporto Faro",
    "unCode" : "PT000005"
  },
  {
    "name" : "Posto Aduaneiro Aeroporto de Beja",
    "unCode" : "PT000006"
  },
  {
    "name" : "Delegação Adu. Aeroporto da Madeira",
    "unCode" : "PT000010"
  },
  {
    "name" : "Alfândega do Aeroporto de Lisboa",
    "unCode" : "PT000015"
  },
  {
    "name" : "Alfândega do Aeroporto do Porto",
    "unCode" : "PT000020"
  },
  {
    "name" : "Delegação Aduaneira de Porto Santo",
    "unCode" : "PT000025"
  },
  {
    "name" : "Delegação Ad. Aeroporto Santa Maria",
    "unCode" : "PT000030"
  },
  {
    "name" : "Alfândega Marítima de Lisboa",
    "unCode" : "PT000040"
  },
  {
    "name" : "Alfândega do Funchal",
    "unCode" : "PT000070"
  },
  {
    "name" : "Alfândega de Ponta Delgada",
    "unCode" : "PT000080"
  },
  {
    "name" : "Alfândega de Alverca",
    "unCode" : "PT000088"
  },
  {
    "name" : "Delegação Adua. Angra do Heroísmo",
    "unCode" : "PT000095"
  },
  {
    "name" : "Posto Aduaneiro da Bobadela",
    "unCode" : "PT000098"
  },
  {
    "name" : "Alfândega de Aveiro",
    "unCode" : "PT000115"
  },
  {
    "name" : "Alfândega de Braga",
    "unCode" : "PT000164"
  },
  {
    "name" : "Delegação Aduaneira de Bragança",
    "unCode" : "PT000167"
  },
  {
    "name" : "Delegação Aduaneira de Elvas",
    "unCode" : "PT000170"
  },
  {
    "name" : "Delegação Aduaneira da Covilhã",
    "unCode" : "PT000227"
  },
  {
    "name" : "Alfândega de Faro",
    "unCode" : "PT000265"
  },
  {
    "name" : "Delegação Aduaneira Figueira da Foz",
    "unCode" : "PT000275"
  },
  {
    "name" : "Alfândega do Freixieiro",
    "unCode" : "PT000284"
  },
  {
    "name" : "Delegação Aduaneira da Horta",
    "unCode" : "PT000295"
  },
  {
    "name" : "Alfândega do Jardim do Tabaco",
    "unCode" : "PT000305"
  },
  {
    "name" : "Alfândega de Leixões",
    "unCode" : "PT000340"
  },
  {
    "name" : "Alfândega de Peniche",
    "unCode" : "PT000455"
  },
  {
    "name" : "Delegação Aduaneira Peso da Régua",
    "unCode" : "PT000459"
  },
  {
    "name" : "Posto Aduaneiro de Riachos",
    "unCode" : "PT000461"
  },
  {
    "name" : "Delegação Aduaneira de Portimão",
    "unCode" : "PT000500"
  },
  {
    "name" : "Posto Aduaneiro Praia da Graciosa",
    "unCode" : "PT000510"
  },
  {
    "name" : "Posto Aduaneiro Lajes das Flores",
    "unCode" : "PT000574"
  },
  {
    "name" : "Posto Aduaneiro S. Roque do Pico",
    "unCode" : "PT000650"
  },
  {
    "name" : "Alfândega de Setúbal",
    "unCode" : "PT000665"
  },
  {
    "name" : "Delegação Aduaneira de Sines",
    "unCode" : "PT000670"
  },
  {
    "name" : "Posto Aduaneiro Velas de S. Jorge",
    "unCode" : "PT000745"
  },
  {
    "name" : "Alfândega de Viana do Castelo",
    "unCode" : "PT000750"
  },
  {
    "name" : "Delegação Aduaneira Vilar Formoso",
    "unCode" : "PT000830"
  },
  {
    "name" : "Delegação Ad. Zona Franca Madeira",
    "unCode" : "PT000855"
  },
  {
    "name" : "OTOPENI CALATORI",
    "unCode" : "ROBU1030"
  },
  {
    "name" : "BANEASA",
    "unCode" : "ROBU1040"
  },
  {
    "name" : "ILFOV",
    "unCode" : "ROBU1200"
  },
  {
    "name" : "BUCURESTI POSTA",
    "unCode" : "ROBU1380"
  },
  {
    "name" : "BUCURESTI",
    "unCode" : "ROBU1400"
  },
  {
    "name" : "GIURGIU",
    "unCode" : "ROBU3910"
  },
  {
    "name" : "ZONA LIBERA GIURGIU",
    "unCode" : "ROBU3980"
  },
  {
    "name" : "PRAHOVA",
    "unCode" : "ROBU7100"
  },
  {
    "name" : "DAMBOVITA",
    "unCode" : "ROBU8600"
  },
  {
    "name" : "ALBA IULIA",
    "unCode" : "ROBV0300"
  },
  {
    "name" : "BRASOV",
    "unCode" : "ROBV0900"
  },
  {
    "name" : "BRASOV AEROPORT",
    "unCode" : "ROBV0910"
  },
  {
    "name" : "HARGHITA",
    "unCode" : "ROBV5600"
  },
  {
    "name" : "COVASNA",
    "unCode" : "ROBV7820"
  },
  {
    "name" : "SIBIU",
    "unCode" : "ROBV7900"
  },
  {
    "name" : "SIBIU AEROPORT",
    "unCode" : "ROBV7910"
  },
  {
    "name" : "MURES",
    "unCode" : "ROBV8800"
  },
  {
    "name" : "TARGU-MURES AEROPORT",
    "unCode" : "ROBV8820"
  },
  {
    "name" : "BISTRITA NASAUD",
    "unCode" : "ROCJ0400"
  },
  {
    "name" : "MARAMURES",
    "unCode" : "ROCJ0500"
  },
  {
    "name" : "CLUJ",
    "unCode" : "ROCJ1800"
  },
  {
    "name" : "CLUJ NAPOCA AEROPORT",
    "unCode" : "ROCJ1810"
  },
  {
    "name" : "HALMEU",
    "unCode" : "ROCJ4310"
  },
  {
    "name" : "BIHOR",
    "unCode" : "ROCJ6570"
  },
  {
    "name" : "ORADEA AEROPORT",
    "unCode" : "ROCJ6580"
  },
  {
    "name" : "SATU MARE",
    "unCode" : "ROCJ7810"
  },
  {
    "name" : "SIGHET",
    "unCode" : "ROCJ8000"
  },
  {
    "name" : "SALAJ",
    "unCode" : "ROCJ9700"
  },
  {
    "name" : "TELEORMAN",
    "unCode" : "ROCR0310"
  },
  {
    "name" : "DOLJ",
    "unCode" : "ROCR2100"
  },
  {
    "name" : "CRAIOVA AEROPORT",
    "unCode" : "ROCR2110"
  },
  {
    "name" : "ARGES",
    "unCode" : "ROCR7000"
  },
  {
    "name" : "PORTILE DE FIER II",
    "unCode" : "ROCR7200"
  },
  {
    "name" : "PORTILE DE FIER I",
    "unCode" : "ROCR7270"
  },
  {
    "name" : "ORSOVA",
    "unCode" : "ROCR7280"
  },
  {
    "name" : "RAMNICU VALCEA",
    "unCode" : "ROCR7700"
  },
  {
    "name" : "OLT",
    "unCode" : "ROCR8210"
  },
  {
    "name" : "GORJ",
    "unCode" : "ROCR8810"
  },
  {
    "name" : "MEHEDINTI",
    "unCode" : "ROCR9000"
  },
  {
    "name" : "CALARASI",
    "unCode" : "ROCT1710"
  },
  {
    "name" : "CONSTANTA SUD",
    "unCode" : "ROCT1900"
  },
  {
    "name" : "CONSTANTA",
    "unCode" : "ROCT1970"
  },
  {
    "name" : "MIHAIL KOGALNICEANU",
    "unCode" : "ROCT5100"
  },
  {
    "name" : "MANGALIA",
    "unCode" : "ROCT5400"
  },
  {
    "name" : "IALOMITA",
    "unCode" : "ROCT8220"
  },
  {
    "name" : "SULINA",
    "unCode" : "ROCT8300"
  },
  {
    "name" : "BRAILA",
    "unCode" : "ROGL0700"
  },
  {
    "name" : "BUZAU",
    "unCode" : "ROGL1500"
  },
  {
    "name" : "VRANCEA",
    "unCode" : "ROGL3600"
  },
  {
    "name" : "OANCEA",
    "unCode" : "ROGL3610"
  },
  {
    "name" : "GALATI",
    "unCode" : "ROGL3800"
  },
  {
    "name" : "GALATI ZONA LIBERA",
    "unCode" : "ROGL3810"
  },
  {
    "name" : "GALATI-GIURGIULESTI",
    "unCode" : "ROGL3850"
  },
  {
    "name" : "TULCEA",
    "unCode" : "ROGL8900"
  },
  {
    "name" : "ISACCEA",
    "unCode" : "ROGL8920"
  },
  {
    "name" : "ALBITA",
    "unCode" : "ROIS0100"
  },
  {
    "name" : "BACAU",
    "unCode" : "ROIS0600"
  },
  {
    "name" : "BACAU AEROPORT",
    "unCode" : "ROIS0620"
  },
  {
    "name" : "BOTOSANI",
    "unCode" : "ROIS1600"
  },
  {
    "name" : "STANCA COSTESTI",
    "unCode" : "ROIS1610"
  },
  {
    "name" : "RADAUTI PRUT",
    "unCode" : "ROIS1620"
  },
  {
    "name" : "RACOVAT",
    "unCode" : "ROIS1630"
  },
  {
    "name" : "DORNESTI",
    "unCode" : "ROIS2700"
  },
  {
    "name" : "FĂLCIU",
    "unCode" : "ROIS4600"
  },
  {
    "name" : "IASI",
    "unCode" : "ROIS4650"
  },
  {
    "name" : "IASI AEROPORT",
    "unCode" : "ROIS4660"
  },
  {
    "name" : "SCULENI",
    "unCode" : "ROIS4990"
  },
  {
    "name" : "PIATRA NEAMT",
    "unCode" : "ROIS7400"
  },
  {
    "name" : "SIRET",
    "unCode" : "ROIS8200"
  },
  {
    "name" : "SUCEAVA",
    "unCode" : "ROIS8230"
  },
  {
    "name" : "SUCEAVA AEROPORT",
    "unCode" : "ROIS8250"
  },
  {
    "name" : "VASLUI",
    "unCode" : "ROIS9610"
  },
  {
    "name" : "VICOVU DE SUS",
    "unCode" : "ROIS9620"
  },
  {
    "name" : "ARAD",
    "unCode" : "ROTM0200"
  },
  {
    "name" : "JIMBOLIA",
    "unCode" : "ROTM5010"
  },
  {
    "name" : "MORAVITA",
    "unCode" : "ROTM5510"
  },
  {
    "name" : "NAIDAS",
    "unCode" : "ROTM6100"
  },
  {
    "name" : "CARAS-SEVERIN",
    "unCode" : "ROTM7600"
  },
  {
    "name" : "HUNEDOARA",
    "unCode" : "ROTM8100"
  },
  {
    "name" : "TIMIS",
    "unCode" : "ROTM8720"
  },
  {
    "name" : "TIMISOARA AEROPORT",
    "unCode" : "ROTM8730"
  },
  {
    "name" : "CI LUKA BEOGRAD",
    "unCode" : "RS011029"
  },
  {
    "name" : "CI PANČEVO",
    "unCode" : "RS011037"
  },
  {
    "name" : "CI POŠTA BEOGRAD",
    "unCode" : "RS011045"
  },
  {
    "name" : "CI RANŽIRNA ŽEL.STANICA MAKIŠ-BEOG",
    "unCode" : "RS011096"
  },
  {
    "name" : "CI OSTRUŽNICA",
    "unCode" : "RS011118"
  },
  {
    "name" : "CI TERMINAL II",
    "unCode" : "RS011126"
  },
  {
    "name" : "CI SKLADIŠTA",
    "unCode" : "RS011134"
  },
  {
    "name" : "CI ZA POSLOVE CAR. NADZORA-BEOGRAD",
    "unCode" : "RS011207"
  },
  {
    "name" : "CR SAVSKO PRISTANIŠTE",
    "unCode" : "RS011240"
  },
  {
    "name" : "CI AERODROM NIKOLA TESLA",
    "unCode" : "RS011274"
  },
  {
    "name" : "CI ZA KURIRSKE POŠILJKE-DHL",
    "unCode" : "RS011282"
  },
  {
    "name" : "CI BEOGRAD",
    "unCode" : "RS011347"
  },
  {
    "name" : "CI AERODROM BEOGRAD",
    "unCode" : "RS011410"
  },
  {
    "name" : "CI TERMINAL BEOGRAD",
    "unCode" : "RS011568"
  },
  {
    "name" : "CR INTERMODALNI TERMINAL",
    "unCode" : "RS011754"
  },
  {
    "name" : "CI MOKRANJE",
    "unCode" : "RS012033"
  },
  {
    "name" : "CI PRAHOVO",
    "unCode" : "RS012041"
  },
  {
    "name" : "CI VELIKO GRADIŠTE",
    "unCode" : "RS012068"
  },
  {
    "name" : "CR ĐERDAP 2",
    "unCode" : "RS012084"
  },
  {
    "name" : "CR MAJDANPEK",
    "unCode" : "RS012092"
  },
  {
    "name" : "CI ĐERDAP",
    "unCode" : "RS012289"
  },
  {
    "name" : "CR BOR",
    "unCode" : "RS012297"
  },
  {
    "name" : "CI VRŠKA ČUKA",
    "unCode" : "RS012319"
  },
  {
    "name" : "CR ZAJEČAR",
    "unCode" : "RS012327"
  },
  {
    "name" : "CARINSKI REFERAT DONJI MILANOVAC",
    "unCode" : "RS012343"
  },
  {
    "name" : "CI TERMINAL GRADINA",
    "unCode" : "RS013013"
  },
  {
    "name" : "CI ŽELEZNIČKA STANICA DIMITROVGRAD",
    "unCode" : "RS013021"
  },
  {
    "name" : "CI SLOBODNA ZONA PIROT",
    "unCode" : "RS013030"
  },
  {
    "name" : "CR PIROT",
    "unCode" : "RS013048"
  },
  {
    "name" : "CI GRADINA",
    "unCode" : "RS013277"
  },
  {
    "name" : "CR RAŠKA",
    "unCode" : "RS014010"
  },
  {
    "name" : "CI KRALJEVO",
    "unCode" : "RS014052"
  },
  {
    "name" : "CI ČAČAK",
    "unCode" : "RS014060"
  },
  {
    "name" : "CI NOVI PAZAR",
    "unCode" : "RS014109"
  },
  {
    "name" : "CI GORNJI MILANOVAC",
    "unCode" : "RS014176"
  },
  {
    "name" : "CP RUDNICA",
    "unCode" : "RS014320"
  },
  {
    "name" : "CI ŠPILJANI",
    "unCode" : "RS014338"
  },
  {
    "name" : "CP BRNJAČKI MOST",
    "unCode" : "RS014346"
  },
  {
    "name" : "CR TUTIN",
    "unCode" : "RS014460"
  },
  {
    "name" : "CI LESKOVAC",
    "unCode" : "RS015024"
  },
  {
    "name" : "CR RIBARCI",
    "unCode" : "RS015032"
  },
  {
    "name" : "CR STREZIMIROVCI",
    "unCode" : "RS015040"
  },
  {
    "name" : "CR ŽELEZNIČKA STANICA NIŠ",
    "unCode" : "RS015075"
  },
  {
    "name" : "CR POŠTA NIŠ",
    "unCode" : "RS015083"
  },
  {
    "name" : "CR KNJAŽEVAC",
    "unCode" : "RS015113"
  },
  {
    "name" : "CI VRANJE",
    "unCode" : "RS015121"
  },
  {
    "name" : "CI TERMINAL NIŠ",
    "unCode" : "RS015156"
  },
  {
    "name" : "CI PREŠEVO",
    "unCode" : "RS015172"
  },
  {
    "name" : "CR ŽELEZNIČKA STANICA RISTOVAC",
    "unCode" : "RS015288"
  },
  {
    "name" : "CI PROKUPLJE",
    "unCode" : "RS015407"
  },
  {
    "name" : "CR DUVANSKA NIŠ",
    "unCode" : "RS015423"
  },
  {
    "name" : "CR AERODROM KONSTANTIN VELIKI",
    "unCode" : "RS015431"
  },
  {
    "name" : "CI KRAGUJEVAC",
    "unCode" : "RS017019"
  },
  {
    "name" : "CR JAGODINA",
    "unCode" : "RS017027"
  },
  {
    "name" : "CR SMEDEREVSKA PALANKA",
    "unCode" : "RS017035"
  },
  {
    "name" : "CR ŽELEZNIČKA STANICA KRAGUJEVAC",
    "unCode" : "RS017043"
  },
  {
    "name" : "CR LAPOVO",
    "unCode" : "RS017078"
  },
  {
    "name" : "CARINSKI REFERAT VELIKA PLANA",
    "unCode" : "RS017094"
  },
  {
    "name" : "CARINSKI REFERAT SVILAJNAC",
    "unCode" : "RS017108"
  },
  {
    "name" : "CR ARANĐELOVAC",
    "unCode" : "RS017256"
  },
  {
    "name" : "CR MLADENOVAC",
    "unCode" : "RS017329"
  },
  {
    "name" : "CR POŽAREVAC",
    "unCode" : "RS017337"
  },
  {
    "name" : "CI SMEDEREVO",
    "unCode" : "RS017345"
  },
  {
    "name" : "CR ŽELEZARA SMEDEREVO",
    "unCode" : "RS017353"
  },
  {
    "name" : "CR SLOBODNA ZONA KRAGUJEVAC",
    "unCode" : "RS017370"
  },
  {
    "name" : "CR SLOBODNA ZONA SMEDEREVO",
    "unCode" : "RS017388"
  },
  {
    "name" : "CI LUKA I SKLADIŠTA NOVI SAD",
    "unCode" : "RS021016"
  },
  {
    "name" : "CI BAČKA PALANKA",
    "unCode" : "RS021024"
  },
  {
    "name" : "CR VRBAS",
    "unCode" : "RS021040"
  },
  {
    "name" : "CR POŠTA NOVI SAD",
    "unCode" : "RS021059"
  },
  {
    "name" : "CI RANŽIRNA ŽELEZ. STANICA NOVI SAD",
    "unCode" : "RS021067"
  },
  {
    "name" : "CI ŽELEZNIČKA STANICA ŠID",
    "unCode" : "RS021083"
  },
  {
    "name" : "CI BATROVCI",
    "unCode" : "RS021091"
  },
  {
    "name" : "CI MOST BAČKA PALANKA",
    "unCode" : "RS021105"
  },
  {
    "name" : "CR NEŠTIN",
    "unCode" : "RS021156"
  },
  {
    "name" : "CR ZA POSLOVE CAR. NADZORA NOVI SAD",
    "unCode" : "RS021202"
  },
  {
    "name" : "CR SOT",
    "unCode" : "RS021270"
  },
  {
    "name" : "CR LJUBA",
    "unCode" : "RS021300"
  },
  {
    "name" : "CI ŠID",
    "unCode" : "RS021342"
  },
  {
    "name" : "CR BEČEJ",
    "unCode" : "RS021369"
  },
  {
    "name" : "CR SLOBODNA ZONA NOVI SAD",
    "unCode" : "RS021377"
  },
  {
    "name" : "CARINSKI REFERAT INĐIJA",
    "unCode" : "RS021385"
  },
  {
    "name" : "CR ZA REČNI SAOBRAĆAJ NOVI SAD",
    "unCode" : "RS021440"
  },
  {
    "name" : "CR NOVI SAD",
    "unCode" : "RS021458"
  },
  {
    "name" : "CR APATIN",
    "unCode" : "RS022012"
  },
  {
    "name" : "CI BAČKI BREG",
    "unCode" : "RS022020"
  },
  {
    "name" : "CI BEZDAN-MOHAČ",
    "unCode" : "RS022039"
  },
  {
    "name" : "CR SOMBOR",
    "unCode" : "RS022047"
  },
  {
    "name" : "CI BOGOJEVO",
    "unCode" : "RS022128"
  },
  {
    "name" : "CR BEZDAN",
    "unCode" : "RS022144"
  },
  {
    "name" : "CR ŽELEZNIČKA STANICA BOGOJEVO",
    "unCode" : "RS022292"
  },
  {
    "name" : "CI KALUĐEROVO",
    "unCode" : "RS023019"
  },
  {
    "name" : "CI VATIN",
    "unCode" : "RS023027"
  },
  {
    "name" : "CI ŽELEZNIČKA STANICA VRŠAC",
    "unCode" : "RS023035"
  },
  {
    "name" : "CI HEMOFARM",
    "unCode" : "RS023043"
  },
  {
    "name" : "CI KIKINDA",
    "unCode" : "RS024015"
  },
  {
    "name" : "CI ZRENJANIN",
    "unCode" : "RS024023"
  },
  {
    "name" : "CI SRPSKA CRNJA",
    "unCode" : "RS024031"
  },
  {
    "name" : "CR SLOBODNA ZONA ZRENJANIN",
    "unCode" : "RS024287"
  },
  {
    "name" : "CI TERMINAL HORGOŠ",
    "unCode" : "RS025011"
  },
  {
    "name" : "JAVNA SKLADIŠTA SUBOTICA",
    "unCode" : "RS025038"
  },
  {
    "name" : "CI ŽELEZNIČKA STANICA SUBOTICA",
    "unCode" : "RS025046"
  },
  {
    "name" : "CI TERMINAL KELEBIJA",
    "unCode" : "RS025054"
  },
  {
    "name" : "CI SENTA",
    "unCode" : "RS025062"
  },
  {
    "name" : "CI HORGOŠ",
    "unCode" : "RS025151"
  },
  {
    "name" : "CI SLOBODNA ZONA SUBOTICA",
    "unCode" : "RS025160"
  },
  {
    "name" : "CI KELEBIJA",
    "unCode" : "RS025267"
  },
  {
    "name" : "CP MERDARE",
    "unCode" : "RS031305"
  },
  {
    "name" : "CP DEPCE",
    "unCode" : "RS031321"
  },
  {
    "name" : "CP KONČULJ",
    "unCode" : "RS031330"
  },
  {
    "name" : "CI ŠABAC",
    "unCode" : "RS042056"
  },
  {
    "name" : "CI SREMSKA MITROVICA",
    "unCode" : "RS042072"
  },
  {
    "name" : "CI SREMSKA RAČA",
    "unCode" : "RS042102"
  },
  {
    "name" : "CI VALJEVO",
    "unCode" : "RS042145"
  },
  {
    "name" : "CI MALI ZVORNIK",
    "unCode" : "RS042153"
  },
  {
    "name" : "CI BADOVINCI",
    "unCode" : "RS042188"
  },
  {
    "name" : "CI TRBUŠNICA",
    "unCode" : "RS042196"
  },
  {
    "name" : "CI LJUBOVIJA",
    "unCode" : "RS042200"
  },
  {
    "name" : "CR SLOBODNA ZONA ŠABAC",
    "unCode" : "RS042277"
  },
  {
    "name" : "CI KRUŠEVAC",
    "unCode" : "RS045047"
  },
  {
    "name" : "CR PARAĆIN",
    "unCode" : "RS045055"
  },
  {
    "name" : "CR TRSTENIK",
    "unCode" : "RS045063"
  },
  {
    "name" : "CR SLOBODNA ZONA KRUŠEVAC",
    "unCode" : "RS045110"
  },
  {
    "name" : "CI UŽICE",
    "unCode" : "RS046027"
  },
  {
    "name" : "CR POŽEGA",
    "unCode" : "RS046035"
  },
  {
    "name" : "CI PRIJEPOLJE",
    "unCode" : "RS046043"
  },
  {
    "name" : "CR JABUKA",
    "unCode" : "RS046051"
  },
  {
    "name" : "CR ŽELEZ. STAN. PRIJEPOLJE KOLOVRAT",
    "unCode" : "RS046060"
  },
  {
    "name" : "CI GOSTUN",
    "unCode" : "RS046078"
  },
  {
    "name" : "CR BAJINA BAŠTA",
    "unCode" : "RS046086"
  },
  {
    "name" : "CI KOTROMAN",
    "unCode" : "RS046094"
  },
  {
    "name" : "CI UVAC",
    "unCode" : "RS046108"
  },
  {
    "name" : "CR SLOBODNA ZONA UŽICE",
    "unCode" : "RS046124"
  },
  {
    "name" : "CR SLOBODNA ZONA PRIBOJ",
    "unCode" : "RS046159"
  },
  {
    "name" : "MALMÖ TULLVERKET",
    "unCode" : "SE000050"
  },
  {
    "name" : "HAPARANDA",
    "unCode" : "SE001033"
  },
  {
    "name" : "ARLANDA TULLVERKET",
    "unCode" : "SE003033"
  },
  {
    "name" : "NORRKÖPING TULLVERKET",
    "unCode" : "SE004134"
  },
  {
    "name" : "TÄRNABY TULLVERKET",
    "unCode" : "SE010332"
  },
  {
    "name" : "BJÖRNFJELL TOLLSTED",
    "unCode" : "SE010333"
  },
  {
    "name" : "JUNKERDAL TOLLSTED",
    "unCode" : "SE010334"
  },
  {
    "name" : "STORLIEN TULLVERKET",
    "unCode" : "SE020342"
  },
  {
    "name" : "VAULDALEN TOLLSTED",
    "unCode" : "SE020344"
  },
  {
    "name" : "IDRE",
    "unCode" : "SE020423"
  },
  {
    "name" : "HÅN TULLVERKET",
    "unCode" : "SE060335"
  },
  {
    "name" : "SVINESUND TOLLSTED",
    "unCode" : "SE060340"
  },
  {
    "name" : "ÖRJE TOLLSTED",
    "unCode" : "SE060341"
  },
  {
    "name" : "STOCKHOLM TULLVERKET",
    "unCode" : "SE303400"
  },
  {
    "name" : "GÖTEBORG TULLVERKET",
    "unCode" : "SE603303"
  },
  {
    "name" : "Tullverket Svinesund",
    "unCode" : "SE603340"
  },
  {
    "name" : "STRÖMSTAD TULLVERKET",
    "unCode" : "SE603342"
  },
  {
    "name" : "EDA TULLVERKET",
    "unCode" : "SE603360"
  },
  {
    "name" : "ÖSTBY TOLLSTED",
    "unCode" : "SE603362"
  },
  {
    "name" : "ÅSNES TOLLSTED",
    "unCode" : "SE603363"
  },
  {
    "name" : "KRANJ",
    "unCode" : "SI001026"
  },
  {
    "name" : "LETALIŠČE BRNIK",
    "unCode" : "SI001034"
  },
  {
    "name" : "POŠTNIH POŠILJK",
    "unCode" : "SI001042"
  },
  {
    "name" : "NOVO MESTO",
    "unCode" : "SI001050"
  },
  {
    "name" : "METLIKA",
    "unCode" : "SI001115"
  },
  {
    "name" : "OBREŽJE",
    "unCode" : "SI001123"
  },
  {
    "name" : "LJUBLJANA",
    "unCode" : "SI001913"
  },
  {
    "name" : "CELJE",
    "unCode" : "SI002022"
  },
  {
    "name" : "DRAVOGRAD",
    "unCode" : "SI003053"
  },
  {
    "name" : "MURSKA SOBOTA",
    "unCode" : "SI004017"
  },
  {
    "name" : "JESENICE",
    "unCode" : "SI005080"
  },
  {
    "name" : "KOPER",
    "unCode" : "SI006036"
  },
  {
    "name" : "LUKA KOPER",
    "unCode" : "SI006044"
  },
  {
    "name" : "OBMORSKI MEJNI PREHOD PIRAN",
    "unCode" : "SI006090"
  },
  {
    "name" : "MEJNI PREHOD LETALIŠČE PORTOROŽ",
    "unCode" : "SI006170"
  },
  {
    "name" : "MEJNI PREHOD LETALIŠČE MARIBOR",
    "unCode" : "SI007040"
  },
  {
    "name" : "MARIBOR",
    "unCode" : "SI007067"
  },
  {
    "name" : "GRUŠKOVJE",
    "unCode" : "SI007075"
  },
  {
    "name" : "IDRIJA",
    "unCode" : "SI008071"
  },
  {
    "name" : "VRTOJBA",
    "unCode" : "SI008128"
  },
  {
    "name" : "SEŽANA",
    "unCode" : "SI009043"
  },
  {
    "name" : "LUČENEC NS",
    "unCode" : "SK517200"
  },
  {
    "name" : "Zvolen NS",
    "unCode" : "SK517700"
  },
  {
    "name" : "BRATISLAVA - LETISKO",
    "unCode" : "SK524200"
  },
  {
    "name" : "Bratislava - Pošta",
    "unCode" : "SK525100"
  },
  {
    "name" : "BRATISLAVA - PRÍSTAV",
    "unCode" : "SK526400"
  },
  {
    "name" : "BRATISLAVA Jonáša",
    "unCode" : "SK526700"
  },
  {
    "name" : "ČIERNA NAD TISOU -ŽELEZNICA A",
    "unCode" : "SK531100"
  },
  {
    "name" : "ČIERNA NAD TISOU-ŠIROKÝ ROZCHOD 'C'",
    "unCode" : "SK531102"
  },
  {
    "name" : "ČIERNA NAD TISOU - TKD DOBRÁ",
    "unCode" : "SK531103"
  },
  {
    "name" : "MAŤOVCE - ŽELEZNICA",
    "unCode" : "SK531400"
  },
  {
    "name" : "VYŠNÉ NEMECKÉ",
    "unCode" : "SK532100"
  },
  {
    "name" : "UBĽA",
    "unCode" : "SK532300"
  },
  {
    "name" : "MICHALOVCE",
    "unCode" : "SK536100"
  },
  {
    "name" : "KOŠICE - LETISKO",
    "unCode" : "SK564100"
  },
  {
    "name" : "KOŠICE POŠTA",
    "unCode" : "SK565100"
  },
  {
    "name" : "Košice - Haniska",
    "unCode" : "SK565300"
  },
  {
    "name" : "PCÚ Košice Haniska - pracovisko ŠRT",
    "unCode" : "SK565301"
  },
  {
    "name" : "SPIŠSKÁ NOVÁ VES",
    "unCode" : "SK567100"
  },
  {
    "name" : "DUNAJSKÁ STREDA",
    "unCode" : "SK586100"
  },
  {
    "name" : "DUNAJSKÁ STREDA - METRANS",
    "unCode" : "SK586101"
  },
  {
    "name" : "TRNAVA",
    "unCode" : "SK586400"
  },
  {
    "name" : "SENICA",
    "unCode" : "SK586500"
  },
  {
    "name" : "Senica - Skalica",
    "unCode" : "SK586501"
  },
  {
    "name" : "GALANTA",
    "unCode" : "SK587100"
  },
  {
    "name" : "MARTIN",
    "unCode" : "SK606300"
  },
  {
    "name" : "ŽILINA - NS",
    "unCode" : "SK606900"
  },
  {
    "name" : "TRSTENÁ",
    "unCode" : "SK607600"
  },
  {
    "name" : "RUŽOMBEROK",
    "unCode" : "SK607700"
  },
  {
    "name" : "KOMÁRNO",
    "unCode" : "SK615500"
  },
  {
    "name" : "LEVICE",
    "unCode" : "SK615700"
  },
  {
    "name" : "NOVÉ ZÁMKY - NS",
    "unCode" : "SK615800"
  },
  {
    "name" : "TOPOĽČANY",
    "unCode" : "SK616300"
  },
  {
    "name" : "NITRA",
    "unCode" : "SK616500"
  },
  {
    "name" : "PREŠOV NS",
    "unCode" : "SK626300"
  },
  {
    "name" : "STARÁ ĽUBOVŇA",
    "unCode" : "SK627200"
  },
  {
    "name" : "POPRAD",
    "unCode" : "SK627300"
  },
  {
    "name" : "TRENČÍN KASÁRENSKÁ",
    "unCode" : "SK666100"
  },
  {
    "name" : "NOVÉ MESTO NAD VÁHOM",
    "unCode" : "SK666300"
  },
  {
    "name" : "PÚCHOV",
    "unCode" : "SK666500"
  },
  {
    "name" : "PRIEVIDZA",
    "unCode" : "SK666700"
  },
  {
    "name" : "Ufficio Tributario Rep. San Marino",
    "unCode" : "SM000001"
  },
  {
    "name" : "Ufficio Tributario Rep. San Marino",
    "unCode" : "SM000002"
  },
  {
    "name" : "Ufficio Tributario Rep. San Marino",
    "unCode" : "SM000008"
  },
  {
    "name" : "Ufficio Tributario Rep. San Marino",
    "unCode" : "SM000009"
  },
  {
    "name" : "DOĞUBEYAZIT GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR041500"
  },
  {
    "name" : "GÜRBULAK GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR041600"
  },
  {
    "name" : "ERZURUM GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR041700"
  },
  {
    "name" : "DİLUCU GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR041800"
  },
  {
    "name" : "KARS GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR041900"
  },
  {
    "name" : "IĞDIR GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR042200"
  },
  {
    "name" : "ESENBOĞA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR060200"
  },
  {
    "name" : "KONYA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR060500"
  },
  {
    "name" : "KAYSERİ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR060600"
  },
  {
    "name" : "ÜRGÜP GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR060700"
  },
  {
    "name" : "AKSARAY GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR061000"
  },
  {
    "name" : "KIRIKKALE O.A.R. GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR061300"
  },
  {
    "name" : "ANKARA GAR GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR061500"
  },
  {
    "name" : "ANKARA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR061600"
  },
  {
    "name" : "KARAMAN GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR062100"
  },
  {
    "name" : "KIRŞEHİR GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR062200"
  },
  {
    "name" : "NİĞDE GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR062300"
  },
  {
    "name" : "KAYSERİ SERBEST BÖLGE MÜDÜRLÜĞÜ",
    "unCode" : "TR062400"
  },
  {
    "name" : "KONYA EREĞLİ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR062500"
  },
  {
    "name" : "ANTALYA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR070100"
  },
  {
    "name" : "ANTALYA HAVALİMANI GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR070200"
  },
  {
    "name" : "ANTALYA SERBEST BÖLGE GÜMRÜK MDR",
    "unCode" : "TR070300"
  },
  {
    "name" : "ALANYA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR070400"
  },
  {
    "name" : "KAŞ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR070500"
  },
  {
    "name" : "FİNİKE GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR070600"
  },
  {
    "name" : "ISPARTA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR070700"
  },
  {
    "name" : "DALAMAN HAVALİMANI GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR070800"
  },
  {
    "name" : "FETHİYE GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR070900"
  },
  {
    "name" : "BODRUM GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR071000"
  },
  {
    "name" : "MİLAS HAVALİMANI GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR071300"
  },
  {
    "name" : "MARMARİS GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR071400"
  },
  {
    "name" : "HOPA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR080100"
  },
  {
    "name" : "SARP GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR080200"
  },
  {
    "name" : "AKTAŞ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR080300"
  },
  {
    "name" : "TÜRKGÖZÜ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR080400"
  },
  {
    "name" : "RİZE GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR080500"
  },
  {
    "name" : "BURSA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR160100"
  },
  {
    "name" : "MUDANYA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR160200"
  },
  {
    "name" : "GEMLİK GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR160400"
  },
  {
    "name" : "BANDIRMA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR160600"
  },
  {
    "name" : "ESKİŞEHİR GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR160700"
  },
  {
    "name" : "BALIKESİR GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR161200"
  },
  {
    "name" : "YALOVA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR161500"
  },
  {
    "name" : "AYVALIK GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR161600"
  },
  {
    "name" : "İNEGÖL GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR161700"
  },
  {
    "name" : "KÜTAHYA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR161900"
  },
  {
    "name" : "BOZÜYÜK GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR162100"
  },
  {
    "name" : "DİYARBAKIR GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR210100"
  },
  {
    "name" : "MARDİN GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR210200"
  },
  {
    "name" : "NUSAYBİN GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR210300"
  },
  {
    "name" : "HABUR GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR210400"
  },
  {
    "name" : "BATMAN GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR210500"
  },
  {
    "name" : "SİLOPİ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR210600"
  },
  {
    "name" : "KAPIKULE YOLCU SALONU GÜMRÜK MÜD",
    "unCode" : "TR220100"
  },
  {
    "name" : "KAPIKULE TIR GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR220200"
  },
  {
    "name" : "KAPIKULE GAR GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR220400"
  },
  {
    "name" : "İPSALA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR220500"
  },
  {
    "name" : "UZUNKÖPRÜ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR220600"
  },
  {
    "name" : "PAZARKULE GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR220700"
  },
  {
    "name" : "DEREKÖY GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR220800"
  },
  {
    "name" : "HAMZABEYLİ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR221300"
  },
  {
    "name" : "GAZİANTEP GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR270100"
  },
  {
    "name" : "İSLAHİYE GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR270200"
  },
  {
    "name" : "ÖNCÜPINAR GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR270300"
  },
  {
    "name" : "ÇOBANBEY GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR270400"
  },
  {
    "name" : "AKÇAKALE GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR270600"
  },
  {
    "name" : "ŞANLIURFA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR270900"
  },
  {
    "name" : "KARKAMIŞ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR271000"
  },
  {
    "name" : "GAZİANTEP HAVALİMANI GÜMRÜK MDR",
    "unCode" : "TR271100"
  },
  {
    "name" : "ADIYAMAN GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR271200"
  },
  {
    "name" : "NİZİP GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR271300"
  },
  {
    "name" : "İSKENDERUN GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR310100"
  },
  {
    "name" : "CİLVEGÖZÜ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR310400"
  },
  {
    "name" : "YAYLADAĞI GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR310500"
  },
  {
    "name" : "İSDEMİR GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR310600"
  },
  {
    "name" : "ANTAKYA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR310800"
  },
  {
    "name" : "OSMANİYE GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR311200"
  },
  {
    "name" : "MERSİN GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR330100"
  },
  {
    "name" : "MERSİN SERBEST BÖLGE GÜMRÜK MDR",
    "unCode" : "TR330500"
  },
  {
    "name" : "MERSİN AKARYAKIT GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR330600"
  },
  {
    "name" : "TAŞUCU GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR330700"
  },
  {
    "name" : "ADANA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR330900"
  },
  {
    "name" : "İNCİRLİK GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR331000"
  },
  {
    "name" : "BOTAŞ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR331400"
  },
  {
    "name" : "YUMURTALIK SERBEST BÖLGE GÜMRÜK MDR",
    "unCode" : "TR331500"
  },
  {
    "name" : "GÖLOVASI GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR331900"
  },
  {
    "name" : "ATATURK HAVA LİM. YOL. SAL. GÜM.MÜD",
    "unCode" : "TR340100"
  },
  {
    "name" : "ATATÜRK HAVALİMANI KARGO GÜMRÜK MDR",
    "unCode" : "TR340300"
  },
  {
    "name" : "İSTANBUL POSTA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR340600"
  },
  {
    "name" : "BEYLİKDÜZÜ AKARYAKIT GÜMRÜK MÜDÜR.",
    "unCode" : "TR340700"
  },
  {
    "name" : "KARAKÖY YOLCU SALONU GÜMRÜK MÜD",
    "unCode" : "TR340800"
  },
  {
    "name" : "HAYDARPAŞA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR340900"
  },
  {
    "name" : "ERENKÖY GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR341200"
  },
  {
    "name" : "MURATBEY GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR341300"
  },
  {
    "name" : "İSTANBUL HAVALİMANI GÜMRÜK MÜDÜRLÜĞ",
    "unCode" : "TR341453"
  },
  {
    "name" : "İSTANBUL HAVALİMANI YOLCU SALONU GM",
    "unCode" : "TR341454"
  },
  {
    "name" : "TRAKYA SERBEST BÖLGE GÜMRÜK MDR",
    "unCode" : "TR342000"
  },
  {
    "name" : "İSTANBUL END. VE TIC. SERBEST BÖLGE",
    "unCode" : "TR342200"
  },
  {
    "name" : "YEŞİLKÖY GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR342400"
  },
  {
    "name" : "İSTANBUL İHTİSAS SERBEST BÖLGE",
    "unCode" : "TR342800"
  },
  {
    "name" : "AMBARLI GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR343100"
  },
  {
    "name" : "SABİHA GÖKÇEN GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR343200"
  },
  {
    "name" : "ZEYTİNBURNU GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR343300"
  },
  {
    "name" : "PENDİK GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR343400"
  },
  {
    "name" : "HALKALI GAR GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR343500"
  },
  {
    "name" : "İZMİR GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR350300"
  },
  {
    "name" : "İZMİR YOLCU SALONU GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR350500"
  },
  {
    "name" : "ADNAN MENDERES GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR350700"
  },
  {
    "name" : "DİKİLİ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR350900"
  },
  {
    "name" : "ÇEŞME GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR351000"
  },
  {
    "name" : "FOÇA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR351100"
  },
  {
    "name" : "MANİSA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR351700"
  },
  {
    "name" : "KUŞADASI GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR351800"
  },
  {
    "name" : "ALİAĞA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR351900"
  },
  {
    "name" : "DENİZLİ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR352100"
  },
  {
    "name" : "EGE SERBEST BÖLGE GÜMRÜK MDR",
    "unCode" : "TR352200"
  },
  {
    "name" : "UŞAK GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR352800"
  },
  {
    "name" : "AFYONKARAHİSAR GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR352900"
  },
  {
    "name" : "İZMİR SERBEST BÖLGE GÜMRÜK MDR",
    "unCode" : "TR353100"
  },
  {
    "name" : "İZMİR TIR GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR353200"
  },
  {
    "name" : "ALAŞEHİR GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR353300"
  },
  {
    "name" : "AYDIN GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR353400"
  },
  {
    "name" : "İZMİT GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR410100"
  },
  {
    "name" : "DERİNCE GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR410300"
  },
  {
    "name" : "DİLOVASI GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR410500"
  },
  {
    "name" : "SAKARYA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR410700"
  },
  {
    "name" : "KARASU GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR410800"
  },
  {
    "name" : "GEBZE GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR411300"
  },
  {
    "name" : "KÖRFEZ PETROKİMYA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR411400"
  },
  {
    "name" : "KARADENİZ EREĞLİ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR411500"
  },
  {
    "name" : "ZONGULDAK GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR411600"
  },
  {
    "name" : "KARABÜK GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR411700"
  },
  {
    "name" : "BARTIN GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR411800"
  },
  {
    "name" : "BOLU GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR411900"
  },
  {
    "name" : "MALATYA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR440100"
  },
  {
    "name" : "KAHRAMANMARAŞ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR440200"
  },
  {
    "name" : "ELAZIĞ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR440300"
  },
  {
    "name" : "SİVAS GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR440400"
  },
  {
    "name" : "BİNGÖL GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR440500"
  },
  {
    "name" : "SAMSUN GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR550100"
  },
  {
    "name" : "ORDU GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR550200"
  },
  {
    "name" : "ÜNYE GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR550300"
  },
  {
    "name" : "ÇORUM GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR550700"
  },
  {
    "name" : "AMASYA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR551000"
  },
  {
    "name" : "İNEBOLU GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR551100"
  },
  {
    "name" : "SİNOP GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR551200"
  },
  {
    "name" : "ORDU-GİRESUN HAVALİMANI GÜM. MÜD.",
    "unCode" : "TR551300"
  },
  {
    "name" : "TEKİRDAĞ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR590100"
  },
  {
    "name" : "ÇORLU HAVALİMANI GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR590200"
  },
  {
    "name" : "AVRUPA SERBEST BÖLGE GÜMRÜK MDR",
    "unCode" : "TR590300"
  },
  {
    "name" : "ÇERKEZKÖY GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR590400"
  },
  {
    "name" : "ÇANAKKALE GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR590500"
  },
  {
    "name" : "BİGA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR590800"
  },
  {
    "name" : "MARMARAEREĞLİSİ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR590900"
  },
  {
    "name" : "TRABZON GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR610100"
  },
  {
    "name" : "GİRESUN GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR610400"
  },
  {
    "name" : "VAN GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR650800"
  },
  {
    "name" : "ESENDERE GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR650900"
  },
  {
    "name" : "KAPIKÖY GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR651000"
  },
  {
    "name" : "YÜKSEKOVA GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR651300"
  },
  {
    "name" : "ÜZÜMLÜ GÜMRÜK MÜDÜRLÜĞÜ",
    "unCode" : "TR651500"
  },
  {
    "name" : "BCP Boryspil CP Boryspil",
    "unCode" : "UA100040"
  },
  {
    "name" : "CCD 1 CP Vіshneve",
    "unCode" : "UA100060"
  },
  {
    "name" : "CCD 2 CP Vіshneve",
    "unCode" : "UA100070"
  },
  {
    "name" : "CCD 1 CP Zakhidnyi",
    "unCode" : "UA100100"
  },
  {
    "name" : "CCD 2 CP Zakhidnyi",
    "unCode" : "UA100110"
  },
  {
    "name" : "CCD 3 CP Zakhidnyi",
    "unCode" : "UA100120"
  },
  {
    "name" : "CCD 4 CP Zakhidnyi",
    "unCode" : "UA100130"
  },
  {
    "name" : "CCD 1 CP Kyiv-tsentralnyi",
    "unCode" : "UA100140"
  },
  {
    "name" : "BCP Richport CP Kyiv-tsentralnyi",
    "unCode" : "UA100150"
  },
  {
    "name" : "CCD 3 CP Kyiv-tsentralnyi",
    "unCode" : "UA100160"
  },
  {
    "name" : "CCD 1 CP Lisky",
    "unCode" : "UA100180"
  },
  {
    "name" : "CCD 2 CP Lisky",
    "unCode" : "UA100190"
  },
  {
    "name" : "CCD 3 CP Lisky",
    "unCode" : "UA100200"
  },
  {
    "name" : "CCD 4 CP Lisky",
    "unCode" : "UA100210"
  },
  {
    "name" : "CCD 1 CP Рivdennyi",
    "unCode" : "UA100230"
  },
  {
    "name" : "CCD 2 CP Рivdennyi",
    "unCode" : "UA100240"
  },
  {
    "name" : "CCD 3 CP Рivdennyi",
    "unCode" : "UA100250"
  },
  {
    "name" : "CCS 1 CP Рivdennyi",
    "unCode" : "UA100260"
  },
  {
    "name" : "CCS 2 CP Рivdennyi",
    "unCode" : "UA100270"
  },
  {
    "name" : "CCD 1 CP Spetsializovanyi",
    "unCode" : "UA100290"
  },
  {
    "name" : "CCD 2 CP Spetsializovanyi",
    "unCode" : "UA100300"
  },
  {
    "name" : "CCD 3 CP Spetsializovanyi",
    "unCode" : "UA100310"
  },
  {
    "name" : "CCD 1 CP Stolychnyi",
    "unCode" : "UA100320"
  },
  {
    "name" : "CCD 2 CP Stolychnyi",
    "unCode" : "UA100330"
  },
  {
    "name" : "CCD 1 CP Skhidnyi",
    "unCode" : "UA100340"
  },
  {
    "name" : "CCD 2 CP Skhidnyi",
    "unCode" : "UA100350"
  },
  {
    "name" : "CCD 3 CP Skhidnyi",
    "unCode" : "UA100360"
  },
  {
    "name" : "CP UkrРoshta",
    "unCode" : "UA100370"
  },
  {
    "name" : "CCD 1 CP Chaiky",
    "unCode" : "UA100380"
  },
  {
    "name" : "CCD 2 Chaiky",
    "unCode" : "UA100390"
  },
  {
    "name" : "CCS 1CP Chaiky",
    "unCode" : "UA100400"
  },
  {
    "name" : "CCS 2 CP Chaiky",
    "unCode" : "UA100410"
  },
  {
    "name" : "CCD 3 CP Vishneve",
    "unCode" : "UA100430"
  },
  {
    "name" : "CCD 4 CP Vishneve",
    "unCode" : "UA100440"
  },
  {
    "name" : "CCS 1 CP Lisky",
    "unCode" : "UA100450"
  },
  {
    "name" : "CCD 1 CP Zhytomyr",
    "unCode" : "UA101020"
  },
  {
    "name" : "CCD 3 CP Zhytomyr",
    "unCode" : "UA101030"
  },
  {
    "name" : "CCD 2 CP Zhytomyr",
    "unCode" : "UA101040"
  },
  {
    "name" : "CCD 1 CP Pivnichnyi",
    "unCode" : "UA101070"
  },
  {
    "name" : "CCD 2 CP Pivnichnyi",
    "unCode" : "UA101080"
  },
  {
    "name" : "CP Zviahel",
    "unCode" : "UA101090"
  },
  {
    "name" : "CCD 3 CP Pivnichniy",
    "unCode" : "UA101130"
  },
  {
    "name" : "CCD 4 CP Pivnichniy",
    "unCode" : "UA101150"
  },
  {
    "name" : "CP Kozelets",
    "unCode" : "UA102020"
  },
  {
    "name" : "CCS CP Kozelets",
    "unCode" : "UA102030"
  },
  {
    "name" : "CCD 1 CP Pryluky",
    "unCode" : "UA102080"
  },
  {
    "name" : "CCD 2 CP Pryluky",
    "unCode" : "UA102090"
  },
  {
    "name" : "CCS 2 CP Pryluky",
    "unCode" : "UA102100"
  },
  {
    "name" : "CCS 1 CP Pryluky",
    "unCode" : "UA102110"
  },
  {
    "name" : "CCD 1 CP Snovsk",
    "unCode" : "UA102160"
  },
  {
    "name" : "ContrPt At Chernihiv Station",
    "unCode" : "UA102170"
  },
  {
    "name" : "CP Chernihiv",
    "unCode" : "UA102210"
  },
  {
    "name" : "CCD 2 CP Snovsk",
    "unCode" : "UA102220"
  },
  {
    "name" : "CP Kamianske",
    "unCode" : "UA110020"
  },
  {
    "name" : "CCS 1 CP Kamianske",
    "unCode" : "UA110030"
  },
  {
    "name" : "CCS 2 CP Kamianske",
    "unCode" : "UA110040"
  },
  {
    "name" : "CP Samar",
    "unCode" : "UA110050"
  },
  {
    "name" : "CCS 1 CP Samar",
    "unCode" : "UA110060"
  },
  {
    "name" : "CCD 1 CP Kryvyi Rih",
    "unCode" : "UA110070"
  },
  {
    "name" : "CCD 2 CP Kryvyi Rih",
    "unCode" : "UA110080"
  },
  {
    "name" : "CCD 3 CP Kryvyi Rih",
    "unCode" : "UA110090"
  },
  {
    "name" : "CP Lisky",
    "unCode" : "UA110110"
  },
  {
    "name" : "CP Nikopol",
    "unCode" : "UA110120"
  },
  {
    "name" : "CCD 1 CP Slobozhans'kyi",
    "unCode" : "UA110130"
  },
  {
    "name" : "CCD 2 CP Slobozhans'kyi",
    "unCode" : "UA110140"
  },
  {
    "name" : "CP Dnipro-Pravoberezhnyi",
    "unCode" : "UA110150"
  },
  {
    "name" : "CCS 1 CP Slobozhans`kyi",
    "unCode" : "UA110180"
  },
  {
    "name" : "CP Zaporizhzhia-Aeroport",
    "unCode" : "UA112030"
  },
  {
    "name" : "CP Zaporizhzhia",
    "unCode" : "UA112080"
  },
  {
    "name" : "CCD 1 CP Rivne",
    "unCode" : "UA204020"
  },
  {
    "name" : "CCD 2 CP Rivne",
    "unCode" : "UA204030"
  },
  {
    "name" : "CCS 1 CP Rivne",
    "unCode" : "UA204040"
  },
  {
    "name" : "CP Sarny",
    "unCode" : "UA204060"
  },
  {
    "name" : "CP Dubno",
    "unCode" : "UA204080"
  },
  {
    "name" : "CCD 3 CP Rivne",
    "unCode" : "UA204130"
  },
  {
    "name" : "CCS 2 CP Rivne",
    "unCode" : "UA204140"
  },
  {
    "name" : "CCD 4 CP Rivne",
    "unCode" : "UA204150"
  },
  {
    "name" : "BCP Yahodyn-Dorohusk CCD 3-6",
    "unCode" : "UA205020"
  },
  {
    "name" : "CCD 1 CP Yahodyn",
    "unCode" : "UA205030"
  },
  {
    "name" : "BCP Yahodyn-Dorohusk CCD 2",
    "unCode" : "UA205040"
  },
  {
    "name" : "CCD 3 CP Kovel",
    "unCode" : "UA205050"
  },
  {
    "name" : "CCD 1 CP Volodymyr",
    "unCode" : "UA205080"
  },
  {
    "name" : "BCP Volodymyr-Volynskyi-Khrubeshuv",
    "unCode" : "UA205090"
  },
  {
    "name" : "CCD 3 CP Volodymyr",
    "unCode" : "UA205100"
  },
  {
    "name" : "BCP Ustyluh-Zosin CCD 1-4",
    "unCode" : "UA205110"
  },
  {
    "name" : "CCD 1 CP Lutsk",
    "unCode" : "UA205140"
  },
  {
    "name" : "CCD 2 CP Lutsk",
    "unCode" : "UA205150"
  },
  {
    "name" : "CCD 3 CP Lutsk",
    "unCode" : "UA205170"
  },
  {
    "name" : "CCD 2 CP Kovel",
    "unCode" : "UA205180"
  },
  {
    "name" : "CCD 1 CP Kovel",
    "unCode" : "UA205190"
  },
  {
    "name" : "CCD 2 CP Prykarpattia",
    "unCode" : "UA206020"
  },
  {
    "name" : "CCD 3 CP Prykarpattia",
    "unCode" : "UA206030"
  },
  {
    "name" : "CCD 1 CP Prykarpattia",
    "unCode" : "UA206050"
  },
  {
    "name" : "CP Kalush",
    "unCode" : "UA206060"
  },
  {
    "name" : "CP Dolyna",
    "unCode" : "UA206070"
  },
  {
    "name" : "CP Kolomyia",
    "unCode" : "UA206080"
  },
  {
    "name" : "BCP Krakivets-Korchova",
    "unCode" : "UA209030"
  },
  {
    "name" : "BCP Shehyni-Medyka CP Mostyska",
    "unCode" : "UA209040"
  },
  {
    "name" : "BCP Mostyska-Pshemysl",
    "unCode" : "UA209050"
  },
  {
    "name" : "BCP Rava-Ruska-Khrebenne",
    "unCode" : "UA209060"
  },
  {
    "name" : "BCP Rava-Ruska-Khrebenne, Werchrata",
    "unCode" : "UA209070"
  },
  {
    "name" : "BCP Smilnytsia-Krostsenko",
    "unCode" : "UA209080"
  },
  {
    "name" : "BCP Hrushiv-Budomiezh",
    "unCode" : "UA209090"
  },
  {
    "name" : "BCP Uhryniv-Dolhobychuv CP Uhryniv",
    "unCode" : "UA209100"
  },
  {
    "name" : "CCD 2 CP Lviv-Pivdennyi",
    "unCode" : "UA209110"
  },
  {
    "name" : "CCD 3 CP Lviv-Pivnichnyi",
    "unCode" : "UA209130"
  },
  {
    "name" : "CCD 4 CP Lviv-Pivnichnyi",
    "unCode" : "UA209140"
  },
  {
    "name" : "CCD 5 CP Lviv-Pivnichnyi",
    "unCode" : "UA209150"
  },
  {
    "name" : "CCD 2 CP Lviv-Pivnichnyi",
    "unCode" : "UA209160"
  },
  {
    "name" : "CCD 1 CP Horodok",
    "unCode" : "UA209170"
  },
  {
    "name" : "CCD 2 CP Horodok",
    "unCode" : "UA209180"
  },
  {
    "name" : "CCD 3 CP Horodok",
    "unCode" : "UA209190"
  },
  {
    "name" : "CCD 4 CP Horodok",
    "unCode" : "UA209200"
  },
  {
    "name" : "CP Lviv-Poshtovyi",
    "unCode" : "UA209210"
  },
  {
    "name" : "CCD 1 CP Lviv-Pivnichnyi",
    "unCode" : "UA209230"
  },
  {
    "name" : "CCD CP Mostyska",
    "unCode" : "UA209250"
  },
  {
    "name" : "CCD 3 CP Lviv-Pivdennyi",
    "unCode" : "UA209260"
  },
  {
    "name" : "CCD 5 CP Horodok",
    "unCode" : "UA209270"
  },
  {
    "name" : "BCP Chop-Zakhon",
    "unCode" : "UA305020"
  },
  {
    "name" : "BCP Chop - Zakhon",
    "unCode" : "UA305030"
  },
  {
    "name" : "ContrP Batieve BCP Salovka-Eperjes.",
    "unCode" : "UA305050"
  },
  {
    "name" : "BCP Chop-Zakhon CP Tysa",
    "unCode" : "UA305060"
  },
  {
    "name" : "BCP Uzhhorod-Vyshnie-Niemetske",
    "unCode" : "UA305090"
  },
  {
    "name" : "BCP Malyi Bereznyi-Ubl'a",
    "unCode" : "UA305100"
  },
  {
    "name" : "CCD 1 CP Vynohradiv",
    "unCode" : "UA305110"
  },
  {
    "name" : "CCD 2 CP Vynohradiv",
    "unCode" : "UA305120"
  },
  {
    "name" : "CCD 1,4 CP Uzhhorod-Vantazhnyi",
    "unCode" : "UA305130"
  },
  {
    "name" : "CCD 3 CP Uzhhorod-Vantazhnyi",
    "unCode" : "UA305140"
  },
  {
    "name" : "CCD 2 CP Uzhhorod-Vantazhnyi",
    "unCode" : "UA305150"
  },
  {
    "name" : "CCD 1 CP Mukachevo",
    "unCode" : "UA305160"
  },
  {
    "name" : "CCD 2 CP Mukachevo",
    "unCode" : "UA305170"
  },
  {
    "name" : "CCS 1 CP Mukachevo",
    "unCode" : "UA305180"
  },
  {
    "name" : "BCP Pavlove-Matiovtse",
    "unCode" : "UA305190"
  },
  {
    "name" : "BCP Luzhanka-Berehshuran CP Astei",
    "unCode" : "UA305200"
  },
  {
    "name" : "BCP Vylok-Tisabech CCD 1-4 CP Vylok",
    "unCode" : "UA305230"
  },
  {
    "name" : "BCP Diakove-Halmeu CCD 1-4",
    "unCode" : "UA305240"
  },
  {
    "name" : "BCP Diakove-Halmeu CCD 5 CP Diakove",
    "unCode" : "UA305250"
  },
  {
    "name" : "CCD 3 CP Vynohradiv",
    "unCode" : "UA305270"
  },
  {
    "name" : "CCD 5 CP Uzhhorod-Vantazhnyi",
    "unCode" : "UA305290"
  },
  {
    "name" : "BCP Velyka Palad-Nadhodosh",
    "unCode" : "UA305350"
  },
  {
    "name" : "CP Kamianets-Podilskyi",
    "unCode" : "UA400020"
  },
  {
    "name" : "CP Slavuta",
    "unCode" : "UA400030"
  },
  {
    "name" : "CCD 1 CP Khmelnytskyi",
    "unCode" : "UA400040"
  },
  {
    "name" : "CCS 1 CP Khmelnytskyi",
    "unCode" : "UA400050"
  },
  {
    "name" : "CCD 1 CP Khmelnytskyi",
    "unCode" : "UA400070"
  },
  {
    "name" : "CCD 1 CP Vinnytsia",
    "unCode" : "UA401020"
  },
  {
    "name" : "CCD 2 CP Vinnytsia",
    "unCode" : "UA401030"
  },
  {
    "name" : "CCD CP Vinnytsia",
    "unCode" : "UA401050"
  },
  {
    "name" : "CP Haisyn",
    "unCode" : "UA401060"
  },
  {
    "name" : "BCP Mohyliv-Podilskyi-Otach",
    "unCode" : "UA401080"
  },
  {
    "name" : "BCP Mohyliv-Podilskyi-Volchynets",
    "unCode" : "UA401090"
  },
  {
    "name" : "BCP Bronnytsia-Ungur CCD 4",
    "unCode" : "UA401100"
  },
  {
    "name" : "CP Pishchanka",
    "unCode" : "UA401110"
  },
  {
    "name" : "CCD 1 CP Dnister",
    "unCode" : "UA401160"
  },
  {
    "name" : "CCD 1 CP Ternopil",
    "unCode" : "UA403020"
  },
  {
    "name" : "CCD 2 CP Ternopil",
    "unCode" : "UA403030"
  },
  {
    "name" : "CCD 4 CP Ternopil",
    "unCode" : "UA403040"
  },
  {
    "name" : "CP Chortkiv",
    "unCode" : "UA403060"
  },
  {
    "name" : "CCD 3 CP Ternopil",
    "unCode" : "UA403070"
  },
  {
    "name" : "CCD 1 CP Chernivtsi",
    "unCode" : "UA408020"
  },
  {
    "name" : "CCD 3 CP Chernivtsi",
    "unCode" : "UA408040"
  },
  {
    "name" : "BCP Porubne-Siret CCD 1-2",
    "unCode" : "UA408050"
  },
  {
    "name" : "BCP Vadyl-Siret-Vikshany CCD 3",
    "unCode" : "UA408060"
  },
  {
    "name" : "BCP Mamalyha-Кryva CCD 1",
    "unCode" : "UA408070"
  },
  {
    "name" : "BCP Mamalyha-Кryva CCD 2",
    "unCode" : "UA408080"
  },
  {
    "name" : "BCP Кelmentsi-Larha CCD 1",
    "unCode" : "UA408090"
  },
  {
    "name" : "BCP Larha BCP Кеlmetsi-Larha CCD 2",
    "unCode" : "UA408100"
  },
  {
    "name" : "BCP Rossoshany-Brichen CCD 3",
    "unCode" : "UA408110"
  },
  {
    "name" : "BCP Sokyriany-Oknytsia CCD 4",
    "unCode" : "UA408120"
  },
  {
    "name" : "BCP Sokyriany-Oknytsia CCD 5",
    "unCode" : "UA408130"
  },
  {
    "name" : "BCP Vashkivtsi-Hrimenkeuts CCD 6",
    "unCode" : "UA408140"
  },
  {
    "name" : "BCP Diakivtsi-Rakovets CP Diakivtsi",
    "unCode" : "UA408150"
  },
  {
    "name" : "BCP Krasnoilsk-Vikovu de Sus",
    "unCode" : "UA408160"
  },
  {
    "name" : "CCS 1 CP Chernivtsi",
    "unCode" : "UA408170"
  },
  {
    "name" : "BCP Odeskyi Morskyi Port CCD 1",
    "unCode" : "UA500020"
  },
  {
    "name" : "BCP Odeskyi Morskyi Port CCD 3",
    "unCode" : "UA500040"
  },
  {
    "name" : "BCP Odesa Morskyi Port CCD 4",
    "unCode" : "UA500050"
  },
  {
    "name" : "BCP Odeskyi Morskyi Port CCD 2",
    "unCode" : "UA500060"
  },
  {
    "name" : "CCD 4 CP Chornomorsk",
    "unCode" : "UA500080"
  },
  {
    "name" : "BCP Chornomorskyi Port CCD 3",
    "unCode" : "UA500090"
  },
  {
    "name" : "BCP Chornomorskyi Port CCD 2",
    "unCode" : "UA500100"
  },
  {
    "name" : "BCP Chornomorskyi Rybnyi Port",
    "unCode" : "UA500110"
  },
  {
    "name" : "BCP Chornomorskyi Sudnorem. Zavod",
    "unCode" : "UA500120"
  },
  {
    "name" : "ContrP Vyzyrka CCD 1",
    "unCode" : "UA500130"
  },
  {
    "name" : "BCP Morskyi port Pivdennyi CCD 2",
    "unCode" : "UA500140"
  },
  {
    "name" : "BCP Starokozache-Tudora",
    "unCode" : "UA500160"
  },
  {
    "name" : "BCP Maiaky-Udobne-Palanka CCD 1",
    "unCode" : "UA500170"
  },
  {
    "name" : "BCP Serpneve 1-Basarabiaska CCD 2",
    "unCode" : "UA500180"
  },
  {
    "name" : "BCP Bilhorod-Dnistrovskyi Port",
    "unCode" : "UA500190"
  },
  {
    "name" : "BCP Maloiaroslavets 1-Chadur-Lunha",
    "unCode" : "UA500200"
  },
  {
    "name" : "BCP Lisne-Seits CCD 2",
    "unCode" : "UA500210"
  },
  {
    "name" : "CCD 4 CP Dnistrovskyi",
    "unCode" : "UA500220"
  },
  {
    "name" : "BCP Kuchurhan-Novosavytske",
    "unCode" : "UA500310"
  },
  {
    "name" : "CCD 5 CP Dnistrovskyi",
    "unCode" : "UA500350"
  },
  {
    "name" : "BCP Izmailskyi Morskyi Port CCD 1",
    "unCode" : "UA500370"
  },
  {
    "name" : "BCP Reni-Dzhiurdzhiulesht CCD 4",
    "unCode" : "UA500380"
  },
  {
    "name" : "CCD 3 CP Prydunaiskiy",
    "unCode" : "UA500390"
  },
  {
    "name" : "BCP Tabaky-Myrne CCD 2",
    "unCode" : "UA500400"
  },
  {
    "name" : "BCP Ust-Dunaiskyi Morskyi Port",
    "unCode" : "UA500410"
  },
  {
    "name" : "BCP Orlivka CCD 5 CP Prydunaiskiy",
    "unCode" : "UA500420"
  },
  {
    "name" : "BCP Vynohradivka-Vulcanesti CCD 2",
    "unCode" : "UA500430"
  },
  {
    "name" : "BCP Dolynske-Chishmikioi CCD 4",
    "unCode" : "UA500440"
  },
  {
    "name" : "BCP Reni-Dzhiurdzhiulesht CCD 3",
    "unCode" : "UA500450"
  },
  {
    "name" : "BCP Reniiskyi Morskyi Port CCD 3",
    "unCode" : "UA500460"
  },
  {
    "name" : "BCP Novi Troiany-Chadyr-Lunga CCD 2",
    "unCode" : "UA500470"
  },
  {
    "name" : "BCP Frikatsey-Etulia CCD 3",
    "unCode" : "UA500480"
  },
  {
    "name" : "ContrP Odesa-Lisky CCD 1 CP",
    "unCode" : "UA500490"
  },
  {
    "name" : "CCD 2 CP Odesa-vnutrishnyi",
    "unCode" : "UA500500"
  },
  {
    "name" : "CCD 3 CP Odesa-vnutrishnyi",
    "unCode" : "UA500520"
  },
  {
    "name" : "CCS 1 CP Prydunaiskiy",
    "unCode" : "UA500530"
  },
  {
    "name" : "CCD 5 CP Chornomorsk",
    "unCode" : "UA500540"
  },
  {
    "name" : "CP Podilsk",
    "unCode" : "UA500550"
  },
  {
    "name" : "BCP Serpneve 1-Basarabiaska CCD 2",
    "unCode" : "UA500570"
  },
  {
    "name" : "CCD 6 CP Chornomorsk",
    "unCode" : "UA500580"
  },
  {
    "name" : "CCS 1 CP Odesa-vnutrishnyi",
    "unCode" : "UA500590"
  },
  {
    "name" : "CP Mizhnarodnyi Aeroport Odesa",
    "unCode" : "UA500600"
  },
  {
    "name" : "CCS 2 CP Pervomaisk",
    "unCode" : "UA504070"
  },
  {
    "name" : "CCS 1 CP Pervomaisk",
    "unCode" : "UA504080"
  },
  {
    "name" : "CCD 1 CP Kostiantynivka",
    "unCode" : "UA504170"
  },
  {
    "name" : "CCD 2 CP Kostiantynivka",
    "unCode" : "UA504180"
  },
  {
    "name" : "CCS 1 CP Kostiantynivka",
    "unCode" : "UA504190"
  },
  {
    "name" : "CP Pervomaisk",
    "unCode" : "UA504210"
  },
  {
    "name" : "CCD 1 CP Sumy",
    "unCode" : "UA805020"
  },
  {
    "name" : "CCD 2 CP Sumy",
    "unCode" : "UA805030"
  },
  {
    "name" : "CP Romny",
    "unCode" : "UA805090"
  },
  {
    "name" : "CP Shostka",
    "unCode" : "UA805170"
  },
  {
    "name" : "CP Konotop",
    "unCode" : "UA805200"
  },
  {
    "name" : "CCD 1 CP Poltava",
    "unCode" : "UA806020"
  },
  {
    "name" : "CCD 2 CP Poltava",
    "unCode" : "UA806030"
  },
  {
    "name" : "CCS 1 CP Poltava",
    "unCode" : "UA806040"
  },
  {
    "name" : "CCS 2 CP Poltava",
    "unCode" : "UA806050"
  },
  {
    "name" : "CCD 1 CP Kremenchuk",
    "unCode" : "UA806070"
  },
  {
    "name" : "CCD 2 CP Kremenchuk",
    "unCode" : "UA806080"
  },
  {
    "name" : "CCS 3 CP Poltava",
    "unCode" : "UA806090"
  },
  {
    "name" : "CCD 3 CP Poltava",
    "unCode" : "UA806100"
  },
  {
    "name" : "ContrP Kharkiv-Sortuvalnyi",
    "unCode" : "UA807090"
  },
  {
    "name" : "CP Kharkiv-tovarnyi",
    "unCode" : "UA807180"
  },
  {
    "name" : "CCD 2 CP Barabashovo",
    "unCode" : "UA807190"
  },
  {
    "name" : "CCD 1 CP Barabashovo",
    "unCode" : "UA807200"
  },
  {
    "name" : "CP Babai",
    "unCode" : "UA807210"
  },
  {
    "name" : "CCD 2 CP Aeroport Kharkiv",
    "unCode" : "UA807230"
  },
  {
    "name" : "CCD 1 CP Kropyvnytskyi",
    "unCode" : "UA901020"
  },
  {
    "name" : "CCD 2 CP Kropyvnytskyi",
    "unCode" : "UA901030"
  },
  {
    "name" : "CP Oleksandriia",
    "unCode" : "UA901050"
  },
  {
    "name" : "CCS 1 CP Oleksandriia",
    "unCode" : "UA901060"
  },
  {
    "name" : "CCD 1 CP Cherkasy",
    "unCode" : "UA902020"
  },
  {
    "name" : "CCD 2 CP Cherkasy",
    "unCode" : "UA902040"
  },
  {
    "name" : "CCS Smila CP Cherkasy",
    "unCode" : "UA902050"
  },
  {
    "name" : "CCS Bogdan Logystyc CP Cherkasy",
    "unCode" : "UA902060"
  },
  {
    "name" : "CCS Korsun-Shevchenkyvskyi",
    "unCode" : "UA902070"
  },
  {
    "name" : "CP Uman",
    "unCode" : "UA902080"
  },
  {
    "name" : "CCS Zvenygorodka CP Uman",
    "unCode" : "UA902090"
  },
  {
    "name" : "CCD Kyiv CP Tsentralnyi",
    "unCode" : "UA903020"
  },
  {
    "name" : "CCD Korosten CP Tsentralnyi",
    "unCode" : "UA903040"
  },
  {
    "name" : "CCD Lviv CP Zakhidnyi",
    "unCode" : "UA903050"
  },
  {
    "name" : "CCD Kalush CP Pivdenno-Zakhidnyi",
    "unCode" : "UA903060"
  },
  {
    "name" : "CCD Mukachevo CP Zakhidnyi",
    "unCode" : "UA903070"
  },
  {
    "name" : "CCD Novohrad-Volynskyi CP Zakhidnyi",
    "unCode" : "UA903080"
  },
  {
    "name" : "CCD Odesa CP Pivdennyi",
    "unCode" : "UA903110"
  },
  {
    "name" : "BCP Odeskyi Port CP Pivdennyi",
    "unCode" : "UA903120"
  },
  {
    "name" : "CCD Izmail CP Pivdennyi",
    "unCode" : "UA903150"
  },
  {
    "name" : "BCP Mykolaivskyi Port CP Pivdennyi",
    "unCode" : "UA903170"
  },
  {
    "name" : "CCD Poltava CP Tsentralnyi",
    "unCode" : "UA903180"
  },
  {
    "name" : "CCD Chernivtsy",
    "unCode" : "UA903200"
  },
  {
    "name" : "CCD Reni CP Pivdennyi",
    "unCode" : "UA903210"
  },
  {
    "name" : "CCD Kovel CP Zakhidnyi",
    "unCode" : "UA903220"
  },
  {
    "name" : "CCS Vinnytsia CP Pivdenno-Zakhidnyi",
    "unCode" : "UA903230"
  },
  {
    "name" : "CCD Uzhhorod CP Zakhidnyi",
    "unCode" : "UA903240"
  },
  {
    "name" : "CCD Boryspil CP Tsentralnyi",
    "unCode" : "UA903250"
  },
  {
    "name" : "CCD Odesa Vantazhnyi CP Pivdennyi",
    "unCode" : "UA903260"
  },
  {
    "name" : "NI Auth Consignor/nees",
    "unCode" : "XI000081"
  },
  {
    "name" : "Belfast",
    "unCode" : "XI000142"
  },
  {
    "name" : "Warrenpoint",
    "unCode" : "XI005160"
  },
  {
    "name" : "Larne",
    "unCode" : "XI005220"
  }
]
